export const PostsData={
    "ListAllBrands": {
        "ABB": 4,
        "Adept": 2,
        "Allen Bradley": 1,
        "Annin Robotics": 1,
        "AUBO": 3,
        "Automata": 1,
        "BORUNTE": 1,
        "Brooks": 1,
        "CLOOS": 1,
        "Comau": 3,
        "CPR": 1,
        "CROBOTP": 1,
        "Denso": 3,
        "Dobot": 4,
        "Doosan Robotics": 1,
        "Elite Robots": 4,
        "Epson": 1,
        "Estun": 2,
        "FAIRINO": 2,
        "Fanuc": 3,
        "Flexiv": 1,
        "Foxbot": 1,
        "GSK": 1,
        "Han's": 1,
        "Hanwha": 1,
        "HIWIN": 1,
        "Huayan Han's": 1,
        "Hyundai Robotics": 1,
        "igus": 1,
        "IIMT": 1,
        "Inexbot": 1,
        "INOVANCE": 1,
        "JAKA": 1,
        "Kassow Robots": 1,
        "Kawasaki": 1,
        "KEBA": 1,
        "Kinova": 2,
        "KUKA": 23,
        "Ligent": 1,
        "MABI Robotic": 1,
        "Mecademic": 2,
        "Mitsubishi": 2,
        "MyCobot": 1,
        "Nachi": 1,
        "Neura": 1,
        "NEWKer": 2,
        "Niryo": 1,
        "Omron": 5,
        "OTC Daihen": 1,
        "Panasonic": 1,
        "QJAR": 1,
        "Rainbow Robotics": 1,
        "RoboDK": 3,
        "Robostar": 1,
        "Rokae": 1,
        "Rozum": 2,
        "RSI": 1,
        "Schneider Electric": 1,
        "Siasun": 3,
        "Siemens": 4,
        "Staubli": 6,
        "Techman Robot": 5,
        "Toshiba": 1,
        "Turin": 1,
        "uFactory": 2,
        "Universal Robots": 8,
        "Wlkata": 1,
        "Yamaha": 1,
        "Yaskawa Motoman": 3
    },
    "ListAllControllers": {
        "ABB IRC5": 2,
        "ABB IRC5C Compact": 2,
        "ABB M2004": 2,
        "ABB OmniCore C30": 1,
        "ABB OmniCore C90XT": 1,
        "ABB OmniCore E10": 1,
        "ABB OmniCore V250XT": 1,
        "ABB S4": 1,
        "ABB S4C": 1,
        "ABB S4C+": 1,
        "Adept V+": 4,
        "Aerotech A3200": 1,
        "Allen Bradley Logix5000": 1,
        "Annin Robotics AR2": 1,
        "Annin Robotics AR3": 1,
        "AUBO ARCS": 1,
        "AUBO AUBOPE": 2,
        "Automata EVA": 1,
        "B&R Industrial Automation": 1,
        "Brooks PreciseFlex": 1,
        "Chaifu C2": 1,
        "CLOOS Rotrol": 1,
        "Comau C5G": 3,
        "Denso RC7": 1,
        "Denso RC7M": 1,
        "Denso RC8": 1,
        "Denso RC9": 1,
        "Denso RC9L": 1,
        "Denso RC9M": 1,
        "Dobot Magician": 1,
        "Dobot MG400": 1,
        "Dobot V3": 1,
        "Dobot V4": 1,
        "Elite Robots CS": 2,
        "Elite Robots EC": 2,
        "Epson RC": 1,
        "Estun RCS2": 1,
        "Estun RCS3": 1,
        "FAIRINO FRC100-AC": 2,
        "Fanuc R30iA": 1,
        "Fanuc R-30iA": 1,
        "Fanuc R30iB": 1,
        "Fanuc R-30iB": 1,
        "Fanuc R-J3": 1,
        "Fanuc R-J3iA": 2,
        "Fanuc R-J3iB": 2,
        "Fanuc R-J3iC": 2,
        "Flexiv Hesper": 1,
        "Foxbot": 1,
        "G9": 1,
        "GCR DUCO": 1,
        "GSK": 1,
        "Hanwha HCR": 1,
        "HIWIN HRSS": 1,
        "Huacheng R6 2.0.2.7 F2": 1,
        "Huacheng R6 2.0.2.7 G2L master": 1,
        "Huacheng R6 2.0.2.7 master": 1,
        "Hyundai Hi5": 1,
        "Hyundai Hi6": 1,
        "igus iRC Release 14": 1,
        "IIMT CR Series": 1,
        "Inovance IRCB501": 1,
        "Kassow Robots KR2": 1,
        "Kawasaki C": 1,
        "Kawasaki D": 1,
        "Kawasaki D+": 1,
        "Kawasaki E": 1,
        "Kawasaki F": 1,
        "Kinova": 2,
        "KUKA KR C1": 1,
        "KUKA KR C2": 10,
        "KUKA KR C4": 13,
        "KUKA KR C5": 11,
        "KUKA LBR": 2,
        "Ligent (Inexbot v1.0.6)": 1,
        "LXMRL00C2000": 1,
        "LXMRL03C1000": 1,
        "LXMRL07C1000": 1,
        "LXMRL12C1000": 1,
        "Mitsubishi MELFA CR-D": 1,
        "Mitsubishi MELFA CR-Q": 1,
        "Mitsubishi MELFA CR-R": 1,
        "Mitsubishi MOVEMASTER EX": 1,
        "Nachi AX": 1,
        "Nachi FD": 1,
        "Neura Real-Time NR-Motion Master": 1,
        "NEWKer i6": 2,
        "Omron eCobra": 2,
        "Omron SmartController EX": 2,
        "Omron Sysmac NJ": 2,
        "OTC Daihen FD": 1,
        "Panasonic G3": 1,
        "QJAR": 1,
        "Rozum RC Series": 2,
        "Siasun SNRC4": 1,
        "Siemens SIMATIC": 1,
        "Siemens SINUMERIK": 4,
        "Staubli CS7": 5,
        "Staubli CS8C": 4,
        "Staubli CS8M": 4,
        "Staubli CS9": 3,
        "Staubli CS9s": 1,
        "Staubli S6": 1,
        "uFactory uArm": 1,
        "uFactory xArm": 1,
        "Universal Robots UR": 8,
        "Universal Robots URe": 8,
        "WLKATA Mirobot": 1,
        "Yaskawa Motoman DX100": 3,
        "Yaskawa Motoman DX200": 3,
        "Yaskawa Motoman FS100": 3,
        "Yaskawa Motoman XRC": 3,
        "Yaskawa Motoman YRC1000": 3,
        "Yaskawa Motoman YRC1000micro": 3
    },
    "ListAllExtensions": {
        ".001": 2,
        ".act": 1,
        ".aubo": 2,
        ".cfg": 1,
        ".cnc": 5,
        ".cpc": 1,
        ".csr": 1,
        ".csv": 4,
        ".drl": 1,
        ".erp": 1,
        ".flow": 6,
        ".gpl": 2,
        ".hrb": 1,
        ".java": 2,
        ".jbi": 2,
        ".JBI": 4,
        ".JBR": 1,
        ".jks": 2,
        ".jlt": 1,
        ".JOB": 2,
        ".js": 1,
        ".json": 1,
        ".kr2": 1,
        ".LS": 3,
        ".lua": 7,
        ".mod": 3,
        ".modx": 1,
        ".mpf": 4,
        ".nc": 1,
        ".pac": 2,
        ".pcs": 2,
        ".pdl": 3,
        ".pg": 2,
        ".pjx": 5,
        ".prg": 5,
        ".PRL": 1,
        ".pro": 1,
        ".py": 11,
        ".r0": 1,
        ".rbg": 1,
        ".scpt": 1,
        ".script": 14,
        ".spf": 1,
        ".src": 19,
        ".task": 1,
        ".tip": 1,
        ".traj": 1,
        ".txt": 9,
        ".V2": 1,
        ".vb1": 3,
        ".wsl": 1,
        ".xml": 2
    },
    "DATA_ALL": {
        "ABB-RAPID-IRC5": {
            "N": "ABB RAPID IRC5",
            "F": "ABB_RAPID_IRC5.py",
            "B": "ABB",
            "EXT": ".mod",
            "SC": [
                "ABB IRC5",
                "ABB IRC5C Compact",
                "ABB M2004"
            ],
            "D": [
                "The ABB RAPID IRC5 post processor allows you to generate code for ABB IRC5 controllers. The ABB IRC5 controller powers ABB's latest generation of robots. This ABB controller supports multi-robot control.",
                "The ABB IRC5 controller was first introduced in 2004 and it is also known as the ABB M2004 controller.",
                "The IRC5 controller is available as a single cabinet, dual cabinet compact cabinet styles.",
                "Use the **ABB_RAPID_S4C** post processor instead for older controllers.",
                "You can also use the **ABB_RAPID_IRC5_Robtargets** post processor to export target variables with the same name you used in your RoboDK project."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "mod",
                    "comment": [
                        "Default for IRC5 controllers.",
                        "Set the program file extension.",
                        "PROG_EXT = 'prg' \u2010 Default for S4 (older controllers).",
                        "PROG_EXT = 'modx' \u2010 OmniCore (newer controllers)."
                    ]
                },
                "FIRST_PROG_AS_MAIN": {
                    "value": "True",
                    "comment": [
                        "It will generate PROG Main().",
                        "Set to True if you want to generate the main/first program as a Main() program. The name of the main/first program will be replaced by Main().",
                        "Example: PROC Main() instead of PROG Prog1().",
                        "FIRST_PROG_AS_MAIN = False \u2010 It will generate PROG Prog1() (or the name set in the RoboDK program)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 20000,
                    "comment": [
                        "Recommended for IRC5: 20000.",
                        "Default maximum number of lines per program. If a program exceeds this value it will then generate multiple \"pages\" (files).",
                        "This value can also be set in Tools-Options-Program-Maximum number of lines per program.",
                        "MAX_LINES_X_PROG = 5000 \u2010 recommended for S4: 5000."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the main module.",
                        "Set to True to include sub programs in the same module."
                    ]
                },
                "MAX_SUBPROG_LINES": {
                    "value": 500,
                    "comment": [
                        "Specify the maximum lines of code allowed to include a subprogram in the main/first program.",
                        "If a subprogram exceeds this number of lines of code it will be generated as a separate program file (module)."
                    ]
                },
                "CHARACTER_LIMIT": {
                    "value": 32,
                    "comment": [
                        "Character limit for identifiers."
                    ]
                },
                "EXTERNAL_DRIPFEEDER": {
                    "value": "False",
                    "comment": [
                        "It will generate a main program to load subprograms.",
                        "External dripfeed: set to True if you use an external tool to load the programs (such as RAPBOX).",
                        "EXTERNAL_DRIPFEEDER = True \u2010 It will not generate a main program to load subprograms. Each subprogram will be called Main(). This is suitable for RAPBOX."
                    ]
                },
                "RAPID_REMOTE_PATH": {
                    "value": "/hd0a/Enter-Serial-Number/HOME/RoboDK",
                    "comment": [
                        "Remote path to place programs in the robot controller.",
                        "When program splitting takes place we need this path to load programs on the fly."
                    ]
                },
                "TURNTABLE_IGNORE": {
                    "value": "False",
                    "comment": [
                        "Default: False.",
                        "Set if you want to ignore the setup of the turntable (or external axis) on the controller.",
                        "If you set it to True it means the controller will not be aware of the axis.",
                        "(you can't move using a synchronized movement and the turntable will not hold the wobjdata)."
                    ]
                },
                "MECHANICAL_UNIT_NAME": {
                    "value": "Turntable_Mechanical_Unit_Name",
                    "comment": [
                        "Specify the mechanical unit name for linear track and/or turntable, if required.",
                        "This name will be added to the wobjdata variable.",
                        "MECHANICAL_UNIT_NAME = 'T6003'.",
                        "MECHANICAL_UNIT_NAME = 'STN1'."
                    ]
                },
                "MOVEJ_AS_MOVEABSJ": {
                    "value": "True",
                    "comment": [
                        "Set to False to use MoveJ for joint movements instead of MoveAbsJ."
                    ]
                },
                "AXES_RATIO": {
                    "value": "",
                    "comment": [
                        "Enter the axes ratio for external axes, if required.",
                        "AXES_RATIO = [1,1,1,1,1,1, -1,1,1]."
                    ]
                },
                "EXTAXES_IDX": {
                    "value": "[0, 1, 2, 3, 4, 5]",
                    "comment": [
                        "Enter the external axes indexes. For example, if you use one external axis mapped to index ext axis 5, you can use.",
                        "EXTAXES_IDX = [4,5]."
                    ]
                },
                "SPEED_MMS": {
                    "value": 500,
                    "comment": [
                        "Default speed."
                    ]
                },
                "SPEEDDATA": {
                    "value": "v500",
                    "comment": [
                        "Default speed variable.",
                        "Example: [500,500,5000,1000]."
                    ]
                },
                "ZONEDATA": {
                    "value": "z1",
                    "comment": [
                        "Default rounding."
                    ]
                },
                "TOOLDATA": {
                    "value": "tool0",
                    "comment": [
                        "Default tool."
                    ]
                },
                "WOBJDATA": {
                    "value": "wobj0",
                    "comment": [
                        "Default reference."
                    ]
                }
            }
        },
        "ABB-RAPID-IRC5-Robtargets": {
            "N": "ABB RAPID IRC5 Robtargets",
            "F": "ABB_RAPID_IRC5_Robtargets.py",
            "B": "ABB",
            "EXT": ".mod",
            "SC": [
                "ABB IRC5",
                "ABB IRC5C Compact",
                "ABB M2004"
            ],
            "D": [
                "The ABB RAPID IRC5 Robtargets post processor allows you to generate code for ABB IRC5 controllers. The ABB IRC5 controller powers ABB's latest generation of robots. This ABB controller supports multi-robot control.",
                "The ABB IRC5 controller was first introduced in 2004 and it is also known as the ABB M2004 controller.",
                "The IRC5 controller is available as a single cabinet, dual cabinet compact cabinet styles.",
                "Use the **ABB_RAPID_S4C** post processor instead for older controllers.",
                "You can also use the **ABB_RAPID_IRC5** if you need to better customize the output for ABB robots."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "mod",
                    "comment": [
                        "Default for IRC5 controllers.",
                        "Set the program file extension.",
                        "PROG_EXT = 'prg' \u2010 S4 (older controllers).",
                        "PROG_EXT = 'modx' \u2010 OmniCore (newer controllers)."
                    ]
                },
                "FIRST_PROG_AS_MAIN": {
                    "value": "True",
                    "comment": [
                        "It will generate PROG Main().",
                        "Set to True if you want to generate the main/first program as a Main() program. The name of the main/first program will be replaced by Main().",
                        "Example: PROC Main() instead of PROG Prog1().",
                        "FIRST_PROG_AS_MAIN = False \u2010 It will generate PROG Prog1() (or the name set in the RoboDK program)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 20000,
                    "comment": [
                        "Recommended for IRC5: 20000.",
                        "Default maximum number of lines per program. If a program exceeds this value it will then generate multiple \"pages\" (files).",
                        "This value can also be set in Tools-Options-Program-Maximum number of lines per program.",
                        "MAX_LINES_X_PROG = 5000 \u2010 recommended for S4: 5000."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the main module.",
                        "Set to True to include sub programs in the same module."
                    ]
                },
                "MAX_SUBPROG_LINES": {
                    "value": 500,
                    "comment": [
                        "Specify the maximum lines of code allowed to include a subprogram in the main/first program.",
                        "If a subprogram exceeds this number of lines of code it will be generated as a separate module."
                    ]
                },
                "CHARACTER_LIMIT": {
                    "value": 32,
                    "comment": [
                        "Character limit for identifiers."
                    ]
                },
                "EXTERNAL_DRIPFEEDER": {
                    "value": "False",
                    "comment": [
                        "It will generate a main program to load subprograms.",
                        "External dripfeed: set to True if you use an external tool to load the programs (such as RAPBOX).",
                        "EXTERNAL_DRIPFEEDER = True \u2010 It will not generate a main program to load subprograms. Each subprogram will be called Main(). This is suitable for RAPBOX."
                    ]
                },
                "RAPID_REMOTE_PATH": {
                    "value": "/hd0a/Enter-Serial-Number/HOME/RoboDK",
                    "comment": [
                        "Remote path to place programs in the robot controller.",
                        "When program splitting takes place we need this path to load programs on the fly."
                    ]
                },
                "TURNTABLE_IGNORE": {
                    "value": "False",
                    "comment": [
                        "Default: False.",
                        "Set if you want to ignore the setup of the turntable (or external axis) on the controller.",
                        "If you set it to True it means the controller will not be aware of the axis.",
                        "(you can't move using a synchronized movement and the turntable will not hold the wobjdata)."
                    ]
                },
                "MECHANICAL_UNIT_NAME": {
                    "value": "Turntable_Mechanical_Unit_Name",
                    "comment": [
                        "Specify the mechanical unit name for linear track and/or turntable, if required.",
                        "This name will be added to the wobjdata variable.",
                        "MECHANICAL_UNIT_NAME = 'T6003'.",
                        "MECHANICAL_UNIT_NAME = 'STN1'."
                    ]
                },
                "MOVEJ_AS_MOVEABSJ": {
                    "value": "True",
                    "comment": [
                        "Set to False to use MoveJ for joint movements instead of MoveAbsJ."
                    ]
                },
                "AXES_RATIO": {
                    "value": "",
                    "comment": [
                        "Enter the axes ratio for external axes, if required.",
                        "AXES_RATIO = [1,1,1,1,1,1, -1,1,1]."
                    ]
                },
                "SPEED_MMS": {
                    "value": 500,
                    "comment": [
                        "Default speed."
                    ]
                },
                "SPEEDDATA": {
                    "value": "v500",
                    "comment": [
                        "Default speed variable.",
                        "Example: [500,500,5000,1000]."
                    ]
                },
                "ZONEDATA": {
                    "value": "z1",
                    "comment": [
                        "Default rounding."
                    ]
                },
                "TOOLDATA": {
                    "value": "tool0",
                    "comment": [
                        "Default tool."
                    ]
                },
                "WOBJDATA": {
                    "value": "wobj0",
                    "comment": [
                        "Default reference."
                    ]
                }
            }
        },
        "ABB-RAPID-OmniCore": {
            "N": "ABB RAPID OmniCore",
            "F": "ABB_RAPID_OmniCore.py",
            "B": "ABB",
            "EXT": ".modx",
            "SC": [
                "ABB OmniCore C30",
                "ABB OmniCore C90XT",
                "ABB OmniCore E10",
                "ABB OmniCore V250XT"
            ],
            "D": [
                "The ABB RAPID OmniCore post processor generates code (.modx) for ABB OmniCore controllers.",
                "OmniCore is ABB's latest robot controller platform, designed to offer improved motion control, higher speed, and more compact hardware compared to previous generations.",
                "Use the **ABB_RAPID_IRC5** post processor instead if you are working with the older IRC5 controller."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "modx",
                    "comment": [
                        "Default for OmniCore controllers (newer controllers).",
                        "Set the program file extension.",
                        "PROG_EXT = 'prg' \u2010 S4 (older controllers).",
                        "PROG_EXT = 'mod' \u2010 Default for IRC5 controllers."
                    ]
                },
                "FIRST_PROG_AS_MAIN": {
                    "value": "True",
                    "comment": [
                        "It will generate PROG Main().",
                        "Set to True if you want to generate the main/first program as a Main() program. The name of the main/first program will be replaced by Main().",
                        "Example: PROC Main() instead of PROG Prog1().",
                        "FIRST_PROG_AS_MAIN = False \u2010 It will generate PROG Prog1() (or the name set in the RoboDK program)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 20000,
                    "comment": [
                        "Recommended for IRC5: 20000.",
                        "Default maximum number of lines per program. If a program exceeds this value it will then generate multiple \"pages\" (files).",
                        "This value can also be set in Tools-Options-Program-Maximum number of lines per program.",
                        "MAX_LINES_X_PROG = 5000 \u2010 recommended for S4: 5000."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the main module.",
                        "Set to True to include sub programs in the same module."
                    ]
                },
                "MAX_SUBPROG_LINES": {
                    "value": 500,
                    "comment": [
                        "Specify the maximum lines of code allowed to include a subprogram in the main/first program.",
                        "If a subprogram exceeds this number of lines of code it will be generated as a separate program file (module)."
                    ]
                },
                "CHARACTER_LIMIT": {
                    "value": 32,
                    "comment": [
                        "Character limit for identifiers."
                    ]
                },
                "EXTERNAL_DRIPFEEDER": {
                    "value": "False",
                    "comment": [
                        "It will generate a main program to load subprograms.",
                        "External dripfeed: set to True if you use an external tool to load the programs (such as RAPBOX).",
                        "EXTERNAL_DRIPFEEDER = True \u2010 It will not generate a main program to load subprograms. Each subprogram will be called Main(). This is suitable for RAPBOX."
                    ]
                },
                "RAPID_REMOTE_PATH": {
                    "value": "/hd0a/Enter-Serial-Number/HOME/RoboDK",
                    "comment": [
                        "Remote path to place programs in the robot controller.",
                        "When program splitting takes place we need this path to load programs on the fly."
                    ]
                },
                "TURNTABLE_IGNORE": {
                    "value": "False",
                    "comment": [
                        "Default: False.",
                        "Set if you want to ignore the setup of the turntable (or external axis) on the controller.",
                        "If you set it to True it means the controller will not be aware of the axis.",
                        "(you can't move using a synchronized movement and the turntable will not hold the wobjdata)."
                    ]
                },
                "MECHANICAL_UNIT_NAME": {
                    "value": "Turntable_Mechanical_Unit_Name",
                    "comment": [
                        "Specify the mechanical unit name for linear track and/or turntable, if required.",
                        "This name will be added to the wobjdata variable.",
                        "MECHANICAL_UNIT_NAME = 'T6003'.",
                        "MECHANICAL_UNIT_NAME = 'STN1'."
                    ]
                },
                "MOVEJ_AS_MOVEABSJ": {
                    "value": "True",
                    "comment": [
                        "Set to False to use MoveJ for joint movements instead of MoveAbsJ."
                    ]
                },
                "AXES_RATIO": {
                    "value": "",
                    "comment": [
                        "Enter the axes ratio for external axes, if required.",
                        "AXES_RATIO = [1,1,1,1,1,1, -1,1,1]."
                    ]
                },
                "EXTAXES_IDX": {
                    "value": "[0, 1, 2, 3, 4, 5]",
                    "comment": [
                        "Enter the external axes indexes. For example, if you use one external axis mapped to index ext axis 5, you can use.",
                        "EXTAXES_IDX = [4,5]."
                    ]
                },
                "SPEED_MMS": {
                    "value": 500,
                    "comment": [
                        "Default speed."
                    ]
                },
                "SPEEDDATA": {
                    "value": "v500",
                    "comment": [
                        "Default speed variable.",
                        "Example: [500,500,5000,1000]."
                    ]
                },
                "ZONEDATA": {
                    "value": "z1",
                    "comment": [
                        "Default rounding."
                    ]
                },
                "TOOLDATA": {
                    "value": "tool0",
                    "comment": [
                        "Default tool."
                    ]
                },
                "WOBJDATA": {
                    "value": "wobj0",
                    "comment": [
                        "Default reference."
                    ]
                },
                "USE_RWS_OVER_FTP": {
                    "value": "True",
                    "comment": [
                        "Use Robot Web Services (RWS) over FTP for uploading files."
                    ]
                }
            }
        },
        "ABB-RAPID-S4C": {
            "N": "ABB RAPID S4C",
            "F": "ABB_RAPID_S4C.py",
            "B": "ABB",
            "EXT": ".prg",
            "SC": [
                "ABB S4",
                "ABB S4C",
                "ABB S4C+"
            ],
            "D": [
                "The ABB RAPID S4C post processor is designed to produce RAPID code compatible with the ABB S4C robot controller series.",
                "The output is formatted as a .prg file, making it compatible with older ABB controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "prg",
                    "comment": [
                        "Default for S4 controllers (older controllers).",
                        "Set the program file extension.",
                        "PROG_EXT = 'mod' \u2010 Default for IRC5 (newer controllers)."
                    ]
                },
                "FIRST_PROG_AS_MAIN": {
                    "value": "True",
                    "comment": [
                        "It will generate PROG Main().",
                        "Set to True if you want to generate the main/first program as a Main() program. The name of the main/first program will be replaced by Main().",
                        "Example: PROC Main() instead of PROG Prog1().",
                        "FIRST_PROG_AS_MAIN = False \u2010 It will generate PROG Prog1() (or the name set in the RoboDK program)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 5000,
                    "comment": [
                        "Recommended for S4:  5000.",
                        "Default maximum number of lines per program. If a program exceeds this value it will then generate multiple \"pages\" (files).",
                        "This value can also be set in Tools-Options-Program-Maximum number of lines per program.",
                        "MAX_LINES_X_PROG = 20000 \u2010 recommended for IRC5: 20000."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the main module.",
                        "Set to True to include sub programs in the same module."
                    ]
                },
                "MAX_SUBPROG_LINES": {
                    "value": 500,
                    "comment": [
                        "Specify the maximum lines of code allowed to include a subprogram in the main/first program.",
                        "If a subprogram exceeds this number of lines of code it will be generated as a separate module."
                    ]
                },
                "CHARACTER_LIMIT": {
                    "value": 13,
                    "comment": [
                        "Character limit for identifiers."
                    ]
                },
                "EXTERNAL_DRIPFEEDER": {
                    "value": "False",
                    "comment": [
                        "It will generate a main program to load subprograms.",
                        "External dripfeed: set to True if you use an external tool to load the programs (such as RAPBOX).",
                        "EXTERNAL_DRIPFEEDER = True \u2010 It will not generate a main program to load subprograms. Each subprogram will be called Main(). This is suitable for RAPBOX."
                    ]
                },
                "RAPID_REMOTE_PATH": {
                    "value": "/hd0a/Enter-Serial-Number/HOME/RoboDK",
                    "comment": [
                        "Remote path to place programs in the robot controller.",
                        "When program splitting takes place we need this path to load programs on the fly."
                    ]
                },
                "TURNTABLE_IGNORE": {
                    "value": "False",
                    "comment": [
                        "Default: False.",
                        "Set if you want to ignore the setup of the turntable (or external axis) on the controller.",
                        "If you set it to True it means the controller will not be aware of the axis.",
                        "(you can't move using a synchronized movement and the turntable will not hold the wobjdata)."
                    ]
                },
                "MECHANICAL_UNIT_NAME": {
                    "value": "Turntable_Mechanical_Unit_Name",
                    "comment": [
                        "Specify the mechanical unit name for linear track and/or turntable, if required.",
                        "This name will be added to the wobjdata variable.",
                        "MECHANICAL_UNIT_NAME = 'T6003'.",
                        "MECHANICAL_UNIT_NAME = 'STN1'."
                    ]
                },
                "AXES_RATIO": {
                    "value": "",
                    "comment": [
                        "Enter the axes ratio for external axes, if required.",
                        "AXES_RATIO = [1,1,1,1,1,1, -1,1,1]."
                    ]
                },
                "SPEED_MMS": {
                    "value": 500,
                    "comment": [
                        "Default speed."
                    ]
                },
                "SPEEDDATA": {
                    "value": "v500",
                    "comment": [
                        "Default speed variable.",
                        "Example: [500,500,5000,1000]."
                    ]
                },
                "ZONEDATA": {
                    "value": "z1",
                    "comment": [
                        "Default rounding."
                    ]
                },
                "TOOLDATA": {
                    "value": "tool0",
                    "comment": [
                        "Default tool."
                    ]
                },
                "WOBJDATA": {
                    "value": "wobj0",
                    "comment": [
                        "Default reference."
                    ]
                }
            }
        },
        "Adept-Staubli-Vplus-custom": {
            "N": "Adept Staubli Vplus custom",
            "F": "Adept_Staubli_Vplus_custom.py",
            "B": "Adept",
            "EXT": ".V2",
            "SC": [
                "Adept V+"
            ],
            "D": [
                "The Adept Staubli Vplus custom post processor allows for specialized code output (.V2) tailored for Adept and Staubli controllers using the V+ language."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "V2",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Adept-Vplus": {
            "N": "Adept Vplus",
            "F": "Adept_Vplus.py",
            "B": "Adept",
            "EXT": ".vb1",
            "SC": [
                "Adept V+",
                "Omron Sysmac NJ",
                "Omron eCobra",
                "Omron SmartController EX"
            ],
            "D": [
                "The Adept Vplus post processor is dedicated to generating code in the V+ language for Adept controllers.",
                "The output code is formatted as a .vb1 file.",
                "Omron acquired Adept in 2015."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "vb1",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "OMRON": {
                    "value": "False",
                    "comment": [
                        "Set this to true to support OMRON Adept V+ specific instructions."
                    ]
                }
            }
        },
        "Allen-Bradley-Logix5000": {
            "N": "Allen Bradley Logix5000",
            "F": "Allen_Bradley_Logix5000.py",
            "B": "Allen Bradley",
            "EXT": ".txt",
            "SC": [
                "Allen Bradley Logix5000"
            ],
            "D": [
                "The Allen Bradley Logix5000 post processor generates RSLogix 5000 code for Allen Bradley Logix5000 series PLCs.",
                "With the output formatted as a .txt file, this post processor is suitable for controlling a robot from a PLC."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Annin-Robotics": {
            "N": "Annin Robotics",
            "F": "Annin_Robotics.py",
            "B": "Annin Robotics",
            "SC": [
                "Annin Robotics AR2",
                "Annin Robotics AR3"
            ],
            "D": [
                "The Annin Robotics post processor allows for code generation (.ar3) for Annin Robotics controllers."
            ],
            "VARS": {
                "SPEED_MMS": {
                    "value": 10,
                    "comment": [
                        "Set default speed in MM/S."
                    ]
                }
            }
        },
        "Astorino": {
            "N": "Astorino",
            "F": "Astorino.py",
            "EXT": ".pg",
            "D": [
                "The astorino post processor generates .pg programs for the Kawasaki astorino, a 6-axis",
                "educational robot running a reduced dialect of the Kawasaki AS language."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "pg",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "AUBO": {
            "N": "AUBO",
            "F": "AUBO.py",
            "B": "AUBO",
            "EXT": ".aubo",
            "SC": [
                "AUBO AUBOPE"
            ],
            "D": [
                "The AUBO post processor generates code (.aubo) for AUBO AUBOPE robotic controllers."
            ],
            "VARS": {
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.3,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "MGP_END_ANGLE_SPEED_RADS": {
                    "value": 1.570796,
                    "comment": [
                        "Default angle speed for MGP moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 0.25,
                    "comment": [
                        "Default acceleration for lineaer moves in m/s^2."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.1,
                    "comment": [
                        "Default acceleration for joint moves in rad/s^2."
                    ]
                },
                "MGP_END_ANGLE_ACCEL_RADSS": {
                    "value": 13.089969,
                    "comment": [
                        "Default angle acceleration for MGP moves in rad/s."
                    ]
                },
                "MGP_JERK_RATIO": {
                    "value": 0.25,
                    "comment": [
                        "Default jerk ratio for MGP moves in percent."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "LINEAR_SPEED_MAX": {
                    "value": 2000.0,
                    "comment": [
                        "Maximum linear speed used to convert to %, in mm/s. i.e. 1000/2000=50%."
                    ]
                },
                "LINEAR_ACCEL_MAX": {
                    "value": 4000.0,
                    "comment": [
                        "Maximum linear acceleration used to convert to %, in mm/s^2. i.e. 2000/4000=50%."
                    ]
                },
                "JOINT_SPEED_MAX": {
                    "value": 150.0,
                    "comment": [
                        "Maximum joint speed (all joints) used to convert to %, in deg/s. i.e. 75/150=50%."
                    ]
                },
                "MGP_END_ANGLE_SPEED_MAX": {
                    "value": 180,
                    "comment": [
                        "Maximum angle speed (end angle) used to convert to %, in deg/s. i.e. 75/150=50%."
                    ]
                },
                "JOINT_ACCEL_MAX": {
                    "value": 1000.0,
                    "comment": [
                        "Maximum joint acceleration (all joints) used to convert to %, in deg/s^2. i.e. 500/1000=50%."
                    ]
                },
                "MGP_END_ANGLE_ACCEL_MAX": {
                    "value": 1500,
                    "comment": [
                        "Maximum angle acceleration used to convert to %, in deg/s^2. i.e. 500/1000=50%."
                    ]
                },
                "CIRCULAR_SPEED_MAX": {
                    "value": 2000.0,
                    "comment": [
                        "Maximum circular speed used to convert to %, in mm/s. i.e. 1000/2000=50%."
                    ]
                },
                "CIRCULAR_ACCEL_MAX": {
                    "value": 2000.0,
                    "comment": [
                        "Maximum circular acceleration used to convert to %, in mm/s^2. i.e. 1000/2000=50%."
                    ]
                },
                "USE_MOVEGROUP_PRO": {
                    "value": "False",
                    "comment": [
                        "Choose to use move_group_pro for smooth movements via ARAL(AUBO Robot Algorithm Library)."
                    ]
                },
                "USE_TRACKREC": {
                    "value": "False",
                    "comment": [
                        "Choose to use move_track for smooth movements using a CSV/RECT file(Algorithm base on RoboDK)."
                    ]
                },
                "TRACKREC_SAMPLING_MM_STEP": {
                    "value": -1,
                    "comment": [
                        "Step in mm to split the linear movements."
                    ]
                },
                "TRACKREC_SAMPLING_DEG_STEP": {
                    "value": -1,
                    "comment": [
                        "Step in deg to split the joint movements."
                    ]
                },
                "TRACKREC_SAMPLING_COLLISION_CHECK": {
                    "value": "False",
                    "comment": [
                        "(Optional) Check for collisions."
                    ]
                },
                "TRACKREC_SAMPLING_FLAG": {
                    "value": 4,
                    "comment": [
                        "(Optional) Set to 1 to include the timings between movements, set to 2 to also include the joint speeds (deg/s), set to 3 to also include the accelerations, set to 4 to include all previous information and make the splitting time-based."
                    ]
                },
                "USE_TRACKREC_HZ_RATE": {
                    "value": 10,
                    "comment": [
                        "Set to 10 to force output joints at 10Hz rate (one value every 100 ms)."
                    ]
                },
                "TRACKREC_ROUDING": {
                    "value": 1,
                    "comment": [
                        "Set Trackrec Rouding, in mm."
                    ]
                },
                "TRACKREC_SPEED": {
                    "value": 100,
                    "comment": [
                        "Set Trackrec End Speed, in mm/s."
                    ]
                }
            }
        },
        "AUBO-ARCS": {
            "N": "AUBO ARCS",
            "F": "AUBO_ARCS.py",
            "B": "AUBO",
            "EXT": ".lua",
            "SC": [
                "AUBO ARCS"
            ],
            "D": [
                "The AUBO ARCS post processor generates code (.lua and .pro) for AUBO ARCS robotic controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 5000,
                    "comment": [
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "UPLOAD_SFTP": {
                    "value": "True",
                    "comment": [
                        "If True, it will attempt to upload using SFTP. If False, it will attempt to using Websocket 30003 running at robot. It requires PYSFTP (pip install pysftp. Important: It requires Visual Studio Community C++ 10.0)."
                    ]
                },
                "PROG_EXT": {
                    "value": "lua",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "DEFAULT_PAYLOAD_VALUE": {
                    "value": 0,
                    "comment": [
                        "Set the default payload."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_CHECK_ADJUST": {
                    "value": "True",
                    "comment": [
                        "Enable or disable blend check adjust."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "WELD_TYPE": {
                    "value": "SINE",
                    "comment": [
                        "Welding weaving type \"SINE\" \"SPIRAL\" \"TRIANGLE\" \"TRAPEZOIDAL\"."
                    ]
                },
                "WELD_STEP": {
                    "value": 0.005,
                    "comment": [
                        "Welding weaving step."
                    ]
                },
                "WELD_AMPLITUDE": {
                    "value": "[0.002, 0.002]",
                    "comment": [
                        "Welding weaving amplitude range."
                    ]
                },
                "WELD_HOLD_DISTANCE": {
                    "value": "[0, 0]",
                    "comment": [
                        "Welding weaving hold distance range."
                    ]
                },
                "WELD_HOLD_TIME": {
                    "value": "[0, 0]",
                    "comment": [
                        "Welding weaving hold time range."
                    ]
                },
                "WELD_ANGLE": {
                    "value": 0,
                    "comment": [
                        "Welding weaving angle."
                    ]
                },
                "WELD_DIRECTION": {
                    "value": 0,
                    "comment": [
                        "Welding weaving direction."
                    ]
                },
                "USE_MOVEP": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MoveP, set to False to use MoveL."
                    ]
                },
                "USE_MOVES": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MoveS, set to False to use MoveJ."
                    ]
                },
                "VAR_TYPE": {
                    "value": "EXPRESSION",
                    "comment": [
                        "Var default type \"EXPRESSION\" \"OPERATOR\"."
                    ]
                },
                "VAR_SYNC_FLAG": {
                    "value": "False",
                    "comment": [
                        "Var Sync func default setting."
                    ]
                },
                "VAR_LOCAL_FLAG": {
                    "value": "False",
                    "comment": [
                        "Define local Var or TP var."
                    ]
                }
            }
        },
        "AUBO-Move-Track": {
            "N": "AUBO Move Track",
            "F": "AUBO_Move_Track.py",
            "B": "AUBO",
            "SC": [
                "AUBO AUBOPE"
            ],
            "D": [
                "The AUBO post processor generates code (.aubo and .rect) for AUBO AUBOPE robotic controllers that require specific path tracking."
            ],
            "VARS": {
                "USE_TRACKREC": {
                    "value": "True",
                    "comment": [
                        "Choose to use move_track for smooth movements using a CSV/RECT file."
                    ]
                },
                "TRACKREC_SAMPLING_MM_STEP": {
                    "value": -1,
                    "comment": [
                        "Step in mm to split the linear movements."
                    ]
                },
                "TRACKREC_SAMPLING_DEG_STEP": {
                    "value": -1,
                    "comment": [
                        "Step in deg to split the joint movements."
                    ]
                },
                "TRACKREC_SAMPLING_COLLISION_CHECK": {
                    "value": "False",
                    "comment": [
                        "(Optional) Check for collisions."
                    ]
                },
                "TRACKREC_SAMPLING_FLAG": {
                    "value": 4,
                    "comment": [
                        "(Optional) Set to 1 to include the timings between movements, set to 2 to also include the joint speeds (deg/s), set to 3 to also include the accelerations, set to 4 to include all previous information and make the splitting time-based."
                    ]
                },
                "USE_TRACKREC_HZ_RATE": {
                    "value": 10,
                    "comment": [
                        "Set to 10 to force output joints at 10Hz rate (one value every 100 ms)."
                    ]
                },
                "TRACKREC_ROUDING": {
                    "value": 1,
                    "comment": [
                        "Set Trackrec Rouding, in mm."
                    ]
                },
                "TRACKREC_SPEED": {
                    "value": 100,
                    "comment": [
                        "Set Trackrec End Speed, in mm/s."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.3,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "MGP_END_ANGLE_SPEED_RADS": {
                    "value": 1.570796,
                    "comment": [
                        "Default angle speed for MGP moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 0.25,
                    "comment": [
                        "Default acceleration for lineaer moves in m/s^2."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.1,
                    "comment": [
                        "Default acceleration for joint moves in rad/s^2."
                    ]
                },
                "MGP_END_ANGLE_ACCEL_RADSS": {
                    "value": 13.089969,
                    "comment": [
                        "Default angle acceleration for MGP moves in rad/s."
                    ]
                },
                "MGP_JERK_RATIO": {
                    "value": 0.25,
                    "comment": [
                        "Default jerk ratio for MGP moves in percent."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "LINEAR_SPEED_MAX": {
                    "value": 2000.0,
                    "comment": [
                        "Maximum linear speed used to convert to %, in mm/s. i.e. 1000/2000=50%."
                    ]
                },
                "LINEAR_ACCEL_MAX": {
                    "value": 4000.0,
                    "comment": [
                        "Maximum linear acceleration used to convert to %, in mm/s^2. i.e. 2000/4000=50%."
                    ]
                },
                "JOINT_SPEED_MAX": {
                    "value": 150.0,
                    "comment": [
                        "Maximum joint speed (all joints) used to convert to %, in deg/s. i.e. 75/150=50%."
                    ]
                },
                "MGP_END_ANGLE_SPEED_MAX": {
                    "value": 180,
                    "comment": [
                        "Maximum angle speed (end angle) used to convert to %, in deg/s. i.e. 75/150=50%."
                    ]
                },
                "JOINT_ACCEL_MAX": {
                    "value": 1000.0,
                    "comment": [
                        "Maximum joint acceleration (all joints) used to convert to %, in deg/s^2. i.e. 500/1000=50%."
                    ]
                },
                "MGP_END_ANGLE_ACCEL_MAX": {
                    "value": 1500,
                    "comment": [
                        "Maximum angle acceleration used to convert to %, in deg/s^2. i.e. 500/1000=50%."
                    ]
                },
                "CIRCULAR_SPEED_MAX": {
                    "value": 2000.0,
                    "comment": [
                        "Maximum circular speed used to convert to %, in mm/s. i.e. 1000/2000=50%."
                    ]
                },
                "CIRCULAR_ACCEL_MAX": {
                    "value": 2000.0,
                    "comment": [
                        "Maximum circular acceleration used to convert to %, in mm/s^2. i.e. 1000/2000=50%."
                    ]
                },
                "USE_MOVEGROUP_PRO": {
                    "value": "False",
                    "comment": [
                        "Choose to use move_group_pro for smooth movements via ARAL(AUBO Robot Algorithm Library)."
                    ]
                }
            },
            "EXT": ".aubo"
        },
        "Automata": {
            "N": "Automata",
            "F": "Automata.py",
            "B": "Automata",
            "EXT": ".py",
            "SC": [
                "Automata EVA"
            ],
            "D": [
                "The Automata post processor generates Python code compatible with Automata robotic controllers."
            ],
            "VARS": {
                "POST_CODEGEN_MODE": {
                    "value": 2,
                    "comment": [
                        "Code generation mode.",
                        "1 = simulate.",
                        "2 = Online Programming (run on robot).",
                        "3 = Macro generation (RDK.AddProgram)."
                    ]
                },
                "MAIN_PROGRAM_NAME": {
                    "value": "",
                    "comment": [
                        "Name of the main function, obtained from first instance of ProgStart being called."
                    ]
                },
                "API_TOKEN": {
                    "value": "ROBODK",
                    "comment": [
                        "API Token name created in the dashboard of the Automata robot controller."
                    ]
                }
            }
        },
        "Borunte": {
            "N": "Borunte",
            "F": "Borunte.py",
            "B": "BORUNTE",
            "EXT": ".act",
            "SC": [
                "Huacheng R6 2.0.2.7 G2L master",
                "Huacheng R6 2.0.2.7 master",
                "Huacheng R6 2.0.2.7 F2"
            ],
            "D": [
                "The Borunte post processor generates downloadable zip-package with necessary files for BRTIRUS robot controllers."
            ],
            "VARS": {
                "DEF_SPD_MMS": {
                    "value": 1000.0,
                    "comment": [
                        "Default speed settings."
                    ]
                },
                "DEF_SPD_DEG": {
                    "value": 200.0,
                    "comment": []
                },
                "SHOW_PROGRAM_ZIP": {
                    "value": "True",
                    "comment": [
                        "Show zip file on program generation."
                    ]
                },
                "SHOW_PROGRAM_TXT": {
                    "value": "True",
                    "comment": [
                        "Show text file on program generation."
                    ]
                },
                "SKIP_COMMENTS": {
                    "value": "True",
                    "comment": []
                }
            }
        },
        "Chaifu": {
            "N": "Chaifu",
            "F": "Chaifu.py",
            "EXT": ".cfg",
            "SC": [
                "Chaifu C2"
            ],
            "D": [
                "The Chaifu post processor allows you to generate code for Chaifu C2 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "cfg",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "SYNERGY_FLAG": {
                    "value": 0,
                    "comment": [
                        "Synergy 0/7."
                    ]
                },
                "ARCS_MOV_TYPE": {
                    "value": 0,
                    "comment": [
                        "Arcs output style."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 2000.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                },
                "DEFAULT_MAX_LINES_X_PROG": {
                    "value": "",
                    "comment": [
                        "Default maximum number of lines per file. If this number is exceeded, the program is splitted in different files.",
                        "This setting can be overridden in RoboDK (Tools-Options-Program).",
                        "A value <=0 or None will discard this limit."
                    ]
                },
                "SAVE_SUBPROGRAMS_SEPARATELY": {
                    "value": "False",
                    "comment": [
                        "Set to True to create one additional file per subprogram, False to bundle everything in one file."
                    ]
                }
            }
        },
        "CLOOS": {
            "N": "CLOOS",
            "F": "CLOOS.py",
            "B": "CLOOS",
            "EXT": ".txt",
            "SC": [
                "CLOOS Rotrol"
            ],
            "D": [
                "The CLOOS post processor is tailored for the generation of code for CLOOS robotic welding systems. ",
                "Output is formatted as .txt and .pkt files."
            ],
            "VARS": {
                "ROBOT_MODEL": {
                    "value": "310",
                    "comment": [
                        "Enter the robot model (needed in the program file)."
                    ]
                },
                "SERIAL_NR": {
                    "value": "3511462",
                    "comment": [
                        "Enter the serial number (needed in the program file)."
                    ]
                },
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 5000,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "SPEED_MMS": {
                    "value": 50,
                    "comment": [
                        "Default speed in mm/s."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs."
                    ]
                },
                "PULSES_ZERO": {
                    "value": 4194304,
                    "comment": [
                        "Zero position for pulses."
                    ]
                },
                "PATH_MAKE_SP": {
                    "value": "C:/Program Files (x86)/CLOOS/",
                    "comment": [
                        "Path of the compiler to convert the ASCII file to a binary file."
                    ]
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1]",
                    "comment": [
                        "Pulses per degree (provide these in the robot parameters menu: Double click the motoman robot in RoboDK, select \"Parameters\"."
                    ]
                }
            }
        },
        "Comau-C5G": {
            "N": "Comau C5G",
            "F": "Comau_C5G.py",
            "B": "Comau",
            "EXT": ".pdl",
            "SC": [
                "Comau C5G"
            ],
            "D": [
                "The Comau C5G Joints post processor is suited for the Comau C5G series.",
                "The output is a .pdl file."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 5000,
                    "comment": [
                        "Maximum number of lines per program. If exceeded, it will then generate multiple \"pages (files)\".",
                        "This is the default setting and it can be changed in Tools-Options-Program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the main program (same file)."
                    ]
                },
                "FLY_DIST": {
                    "value": -1,
                    "comment": [
                        "Default fly dist (rounding). Set to >0 to use MOVEFLY."
                    ]
                },
                "EXT_POSEXT": {
                    "value": "True",
                    "comment": [
                        "Set EXT_POSEXT to define external axes as POSEXT variables (inlined).",
                        "If set to False, it will use XTNDPOS instead."
                    ]
                },
                "PROG_EXT": {
                    "value": "pdl",
                    "comment": [
                        "Program extension."
                    ]
                },
                "PAL": {
                    "value": -1,
                    "comment": [
                        "Option if palletizing robot is used.",
                        "-1: off.",
                        "4: 4-axis generic.",
                        "5: 5-axis generic.",
                        "470: PAL470 model."
                    ]
                }
            }
        },
        "Comau-C5G-Joints": {
            "N": "Comau C5G Joints",
            "F": "Comau_C5G_Joints.py",
            "B": "Comau",
            "EXT": ".pdl",
            "SC": [
                "Comau C5G"
            ],
            "D": [
                "The Comau C5G Joints post processor is suited for the Comau C5G series, and is customized for POSEXT support.",
                "The output is a .pdl file."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 5000,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\"."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Include sub programs in the main program."
                    ]
                },
                "FLY_DIST": {
                    "value": -1,
                    "comment": [
                        "Default fly dist (rounding). Set to >0 to use MOVEFLY."
                    ]
                },
                "PROG_EXT": {
                    "value": "pdl",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Comau-Nodal": {
            "N": "Comau Nodal",
            "F": "Comau_Nodal.py",
            "B": "Comau",
            "EXT": ".pdl",
            "SC": [
                "Comau C5G"
            ],
            "D": [
                "The Comau Nodal post processor generates code in the PDL2 language."
            ],
            "VARS": {
                "MOVEJ_USES_JOINTS": {
                    "value": "True",
                    "comment": [
                        "Set to False to use MoveJ for joint movements using pose data."
                    ]
                },
                "SPEED_MMS": {
                    "value": 100,
                    "comment": [
                        "Default speed in mm/s."
                    ]
                },
                "SPEEDDATA": {
                    "value": "VLMax",
                    "comment": [
                        "Default speed variable for linear movements, in mm/s."
                    ]
                },
                "SPEEDDATA_J": {
                    "value": "VJMax",
                    "comment": [
                        "Default speed variable for joint movements, in deg/s."
                    ]
                },
                "ZONEDATA": {
                    "value": "ZFine",
                    "comment": [
                        "Default rounding (zone data)."
                    ]
                },
                "ZONEDATAJOINT": {
                    "value": "ZJFine",
                    "comment": []
                },
                "TOOLDATA": {
                    "value": "T0",
                    "comment": [
                        "Default tool."
                    ]
                },
                "WOBJDATA": {
                    "value": "F0",
                    "comment": [
                        "Default reference."
                    ]
                },
                "ONETAB": {
                    "value": "  ",
                    "comment": [
                        "In general, one tab equals 2 spaces, 4 spaces or a tab."
                    ]
                },
                "CUSTOM_RESERVED_NAMES": {
                    "value": "[]",
                    "comment": [
                        "Add the variable names you want to skip."
                    ]
                },
                "EXT_POSEXT": {
                    "value": "False",
                    "comment": [
                        "Set EXT_POSEXT to define external axes as POSEXT variables (inlined).",
                        "If set to False, it will use XTNDPOS instead."
                    ]
                },
                "PROG_EXT": {
                    "value": "pdl",
                    "comment": [
                        "Set the program file extension."
                    ]
                },
                "PROG_EXT_DATA": {
                    "value": "lsv",
                    "comment": []
                },
                "ARC_WEAVEDATA": {
                    "value": "WeaveData",
                    "comment": [
                        "Default WeaveData used for Arc welding."
                    ]
                },
                "ARC_SEAMDATA": {
                    "value": "SeamData",
                    "comment": [
                        "Default SeamData used for Arc welding."
                    ]
                },
                "FIRST_PROG_AS_MAIN": {
                    "value": "True",
                    "comment": [
                        "It will generate PROG Main().",
                        "Set if we want to generate the main/first program as a Main() program. The name of the main/first program will be replaced by Main().",
                        "Example: PROC Main() instead of PROG Prog1().",
                        "FIRST_PROG_AS_MAIN = False \u2010 It will generate PROG Prog1() (or the name set in the RoboDK program)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 20000,
                    "comment": [
                        "Default maximum number of lines per program. If a program exceeds this value it will then generate multiple \"pages\" (files).",
                        "This value can also be set in Tools-Options-Program-Maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Include subprograms in the main module.",
                        "Set to True to include sub programs in the same module."
                    ]
                },
                "RATIO_EXTAX": {
                    "value": "",
                    "comment": [
                        "Enter the axes ratio for external axes, if required.",
                        "RATIO_EXTAX = [1,1,1,1,1,1, -1,1,1]."
                    ]
                },
                "EXTAXES_IDX": {
                    "value": "[0, 1, 2, 3, 4, 5]",
                    "comment": [
                        "Enter the external axes indexes. For example, if you use one external axis mapped to index ext axis 5, you can use.",
                        "EXTAXES_IDX = [4,5]."
                    ]
                },
                "init_routine": {
                    "value": "[...]",
                    "comment": [
                        "Init routine for programs."
                    ]
                }
            }
        },
        "CPC": {
            "N": "CPC",
            "F": "CPC.py",
            "EXT": ".cpc",
            "SC": [],
            "D": []
        },
        "CPR": {
            "N": "CPR",
            "F": "CPR.py",
            "B": "CPR",
            "EXT": ".xml",
            "SC": [],
            "D": [
                "The CPR post processor produces XML-formatted code suitable for CPR robotic systems."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "xml",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "CRP": {
            "N": "CRP",
            "F": "CRP.py",
            "B": "CROBOTP",
            "EXT": ".r0",
            "SC": [
                "G9"
            ],
            "D": [
                "The CRP post processor produces R0 formatted code suitable for CRP robot systems."
            ]
        },
        "CSV": {
            "N": "CSV",
            "F": "CSV.py",
            "EXT": ".csv",
            "SC": [],
            "D": [
                "The CSV post processor generates simple CSV-formatted files for generic robotic and automation controllers.",
                "This post processor is versatile and can be used in applications requiring straightforward data import and export."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "csv",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Denso-RC7": {
            "N": "Denso RC7",
            "F": "Denso_RC7.py",
            "B": "Denso",
            "EXT": ".pac",
            "SC": [
                "Denso RC7",
                "Denso RC7M"
            ],
            "D": [
                "The Denso RC7 post processor generates PacScript (.pac) files designed for DENSO Robotics RC7 controllers.",
                "PacScript is based on the PAC language, a programming language used to control DENSO Robotics."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "SPEED_MPS": {
                    "value": 0.1,
                    "comment": [
                        "Default speed in meters per second."
                    ]
                },
                "SPEED": {
                    "value": 10,
                    "comment": [
                        "Default speed in percentage."
                    ]
                },
                "PASS": {
                    "value": "@P",
                    "comment": [
                        "Nothing = default = '@0' (does not work well) @P is more reliable."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 2,
                    "comment": [
                        "Default tool id."
                    ]
                },
                "ACTIVE_WOBJ": {
                    "value": 3,
                    "comment": [
                        "Default wobj id."
                    ]
                },
                "PROG_EXT": {
                    "value": "pac",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Denso-RC8": {
            "N": "Denso RC8",
            "F": "Denso_RC8.py",
            "B": "Denso",
            "EXT": ".pcs",
            "SC": [
                "Denso RC8"
            ],
            "D": [
                "The Denso RC8 post processor generates PacScript (.pcs) files designed for DENSO Robotics RC8 controllers.",
                "PacScript is based on the PAC language, a programming language used to control DENSO Robotics."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": -1,
                    "comment": [
                        "Maximum number of lines per program."
                    ]
                },
                "TurnTableExport_RobotBase": {
                    "value": "False",
                    "comment": [
                        "Export targets with respect to the robot when a turntable is used.",
                        "This is turned on automatically if we have a turntable."
                    ]
                },
                "PROG_EXT": {
                    "value": "pcs",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Denso-RC9": {
            "N": "Denso RC9",
            "F": "Denso_RC9.py",
            "B": "Denso",
            "EXT": ".pcs",
            "SC": [
                "Denso RC9",
                "Denso RC9M",
                "Denso RC9L"
            ],
            "D": [
                "The Denso RC9 post processor generates PacScript (.pcs) files designed for DENSO Robotics RC9 controllers.",
                "PacScript is based on the PAC language, a programming language used to control DENSO Robotics."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "pcs",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": -1,
                    "comment": [
                        "Default acceleration for linear moves in % (-1 means Speed^2/100)."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": -1,
                    "comment": [
                        "Default acceleration for joint moves in % (-1 means Speed^2/100)."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "True",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "True",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "True",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                },
                "DEFAULT_WORK_ID": {
                    "value": 1,
                    "comment": [
                        "Default WORD ID to use when not provided (0 to 7)."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default WORD ID to use when not provided (0 to 63)."
                    ]
                }
            }
        },
        "Dobot-Magician": {
            "N": "Dobot Magician",
            "F": "Dobot_Magician.py",
            "B": "Dobot",
            "EXT": ".py",
            "SC": [
                "Dobot Magician"
            ],
            "D": [
                "The Dobot Magician post processor produces Python script compatible with Dobot Magician robotic arms."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "py",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "ROBOT_IP": {
                    "value": "COM2",
                    "comment": []
                },
                "ROBOT_PORT": {
                    "value": 10000,
                    "comment": []
                }
            }
        },
        "Dobot-MG400": {
            "N": "Dobot MG400",
            "F": "Dobot_MG400.py",
            "B": "Dobot",
            "EXT": ".lua",
            "SC": [
                "Dobot MG400"
            ],
            "D": [
                "The Dobot MG400 post processor generates Lua (.lua) script designed for the Dobot MG400 robots."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "lua",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Dobot-V3": {
            "N": "Dobot V3",
            "F": "Dobot_V3.py",
            "B": "Dobot",
            "EXT": ".lua",
            "SC": [
                "Dobot V3"
            ],
            "D": [
                "The Dobot V3 post processor generates Lua (.lua) files for Dobot V3 robot controllers, such as the Nova, MG400 and CR robots."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "lua",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "ROBOT_IP": {
                    "value": "192.168.1.100",
                    "comment": []
                },
                "ROBOT_PORT": {
                    "value": 10000,
                    "comment": []
                }
            }
        },
        "Dobot-V4": {
            "N": "Dobot V4",
            "F": "Dobot_V4.py",
            "B": "Dobot",
            "EXT": ".lua",
            "SC": [
                "Dobot V4"
            ],
            "D": [
                "The Dobot V4 post processor generates Lua (.lua) files for Dobot V4 robot controllers, such as the CRA and Magician E6 robots."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "lua",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "ROBOT_IP": {
                    "value": "192.168.1.100",
                    "comment": []
                },
                "ROBOT_PORT": {
                    "value": 10000,
                    "comment": []
                }
            }
        },
        "Doosan-Robotics": {
            "N": "Doosan Robotics",
            "F": "Doosan_Robotics.py",
            "B": "Doosan Robotics",
            "EXT": ".drl",
            "SC": [],
            "D": [
                "The Doosan Robotics post processor generates DRL (Doosan Robotics Language) code for Doosan robots."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 5000,
                    "comment": [
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "PROG_EXT": {
                    "value": "drl",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "BLEND_RADIUS": {
                    "value": -1,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "USE_MOVEB": {
                    "value": "False",
                    "comment": []
                },
                "MOVEB_SEG_COUNT": {
                    "value": 0,
                    "comment": []
                },
                "MOVEB_SEG_LIST": {
                    "value": "[]",
                    "comment": []
                },
                "MOVEB_START": {
                    "value": "False",
                    "comment": []
                },
                "LAST_POSE": {
                    "value": "",
                    "comment": []
                },
                "SPEED_MMS": {
                    "value": 150,
                    "comment": []
                },
                "ACC_MMSS": {
                    "value": 250,
                    "comment": []
                }
            }
        },
        "Elite-Robots-CS": {
            "N": "Elite Robots CS",
            "F": "Elite_Robots_CS.py",
            "B": "Elite Robots",
            "EXT": ".task",
            "SC": [
                "Elite Robots CS"
            ],
            "D": [
                "The Elite Robots CS Task post processor allows you to generate code for CS controllers."
            ],
            "VARS": {
                "DEFAULT_TCP": {
                    "value": "[0, 0, 0, 0, 0, 0]",
                    "comment": [
                        "Default TCP [Xmm, Ymm, Zmm, RX\u00b0, RY\u00b0, RZ\u00b0]."
                    ]
                },
                "DEFAULT_SPEED": {
                    "value": 250,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_ACCELERATION": {
                    "value": 1200,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_SPEEDJOINTS": {
                    "value": 60,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "DEFAULT_ACCELERATIONJOINTS": {
                    "value": 80,
                    "comment": [
                        "Default acceleration for joint moves in deg/s^2."
                    ]
                },
                "DEFAULT_ROUNDING": {
                    "value": 0,
                    "comment": [
                        "Default rounding in mm."
                    ]
                },
                "MOVEJ_POSITION_TYPE": {
                    "value": 0,
                    "comment": [
                        "Position type for MoveJ (0:JOINT_ANGLES 1:CARTESIAN_POSE)."
                    ]
                },
                "PROGRAM_CALL_MODE": {
                    "value": 0,
                    "comment": [
                        "Program call mode (0:Folder 1:SubTask)."
                    ]
                },
                "LANGUAGE_SETTING": {
                    "value": "zh",
                    "comment": [
                        "Language (zh:\u4e2d\u6587 ja:\u65e5\u672c\u8a9e en:English)."
                    ]
                }
            }
        },
        "Elite-Robots-CS-Script": {
            "N": "Elite Robots CS Script",
            "F": "Elite_Robots_CS_Script.py",
            "B": "Elite Robots",
            "EXT": ".script",
            "SC": [
                "Elite Robots CS"
            ],
            "D": [
                "The Elite Robots CS Task post processor allows you to generate code for CS controllers."
            ],
            "VARS": {
                "DEFAULT_FRAME": {
                    "value": "[0, 0, 0, 0, 0, 0]",
                    "comment": [
                        "Default reference frame [Xmm, Ymm, Zmm, RX\u00b0, RY\u00b0, RZ\u00b0]."
                    ]
                },
                "DEFAULT_SPEED": {
                    "value": 250,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_ACCELERATION": {
                    "value": 1200,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_SPEEDJOINTS": {
                    "value": 60,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "DEFAULT_ACCELERATIONJOINTS": {
                    "value": 80,
                    "comment": [
                        "Default acceleration for joint moves in deg/s^2."
                    ]
                },
                "DEFAULT_ROUNDING": {
                    "value": 0,
                    "comment": [
                        "Default rounding in mm."
                    ]
                }
            }
        },
        "Elite-Robots-EC-movE": {
            "N": "Elite Robots EC movE",
            "F": "Elite_Robots_EC_movE.py",
            "B": "Elite Robots",
            "EXT": ".jbi",
            "SC": [
                "Elite Robots EC"
            ],
            "D": [
                "The Elite Robots EC movE post processor allows you to generate code for EC controllers.",
                "Points are generated as movE commands"
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "Set the default maximum number of lines per program.",
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 9,
                    "comment": [
                        "Specify the default UTool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use UTOOL number 2)."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Specify a spare Position register for calculations (Tool, Reference, ...)."
                    ]
                },
                "USE_MFRAME": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MFRAME for setting reference frames automatically within the program."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 9,
                    "comment": [
                        "Specify the default UFrame Id to use (register).",
                        "You can also use Numbered References in RoboDK (for example, a reference named \"Reference 4\" will use UFRAME number 4)."
                    ]
                }
            }
        },
        "Elite-Robots-EC-V3": {
            "N": "Elite Robots EC V3",
            "F": "Elite_Robots_EC_V3.py",
            "B": "Elite Robots",
            "EXT": ".jbi",
            "SC": [
                "Elite Robots EC"
            ],
            "D": [
                "The Elite Robots EC movE post processor allows you to generate code for EC controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 9,
                    "comment": [
                        "Specify the default UTool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use UTOOL number 2)."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Specify a spare Position register for calculations (Tool, Reference, ...)."
                    ]
                },
                "USE_MFRAME": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MFRAME for setting reference frames automatically within the program."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 9,
                    "comment": [
                        "Specify the default UFrame Id to use (register).",
                        "You can also use Numbered References in RoboDK (for example, a reference named \"Reference 4\" will use UFRAME number 4)."
                    ]
                }
            }
        },
        "Epson-RC": {
            "N": "Epson RC",
            "F": "Epson_RC.py",
            "B": "Epson",
            "EXT": ".prg",
            "SC": [
                "Epson RC"
            ],
            "D": [
                "The Epson RC post processor generates .prg files specifically for Epson RC controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "prg",
                    "comment": [
                        "Set the program file extension.",
                        "PROG_EXT = 'gpl'."
                    ]
                },
                "USE_FRAMES": {
                    "value": "True",
                    "comment": [
                        "Set to True to use \"Local \" coordinate systems.",
                        "Set to False to not use any Local coordinate systems, the targets will be exported with respect to the base."
                    ]
                },
                "ADD_MOVEL_CONFIG": {
                    "value": "True",
                    "comment": [
                        "Set to True to add the configuration flag /L /R to the Cartesian movements.",
                        "This applies to Scara robots only."
                    ]
                },
                "FORCE_MOVEJCARTESIAN": {
                    "value": "False",
                    "comment": [
                        "Set to true to force exporting joint moves using Cartesian coordinates instead of joint values."
                    ]
                },
                "DEFAULT_LOCAL_ID": {
                    "value": 1,
                    "comment": [
                        "Set the default local id to use.",
                        "Example, RoboDK will output \"Local 1\" if default local id is 1.",
                        "However, if you have a number in your reference frame (for example, \"Frame 2\"), the ID of the reference will be used instead."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Set the default TLSet id to use.",
                        "Example, RoboDK will output \"TLSet 1\" if default tool id is 1.",
                        "However, if you have a number in your reference frame (for example, \"Tool 3\"), the ID of the reference will be used instead."
                    ]
                }
            }
        },
        "Estun-RCS2": {
            "N": "Estun RCS2",
            "F": "Estun_RCS2.py",
            "B": "Estun",
            "EXT": ".erp",
            "SC": [
                "Estun RCS2"
            ],
            "D": [
                "This postprocessor generates ERD (data) and ERP (command) files",
                "The '_global.erd' file (TCP and user frame definitions) is generated optionally"
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "erp",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DATA_EXT": {
                    "value": "erd",
                    "comment": []
                },
                "ADD_GLOBAL_ERD": {
                    "value": "True",
                    "comment": [
                        "Generate the '_global.erd' file (TCP and user frame definitions)."
                    ]
                },
                "PNT_PARAMS": {
                    "value": "True",
                    "comment": [
                        "Include motion parameters to point variables."
                    ]
                },
                "DENSE_POINT": {
                    "value": "False",
                    "comment": [
                        "Complex toolpath."
                    ]
                },
                "COMPLETE_BC": {
                    "value": "False",
                    "comment": [
                        "TODO: Generate complete backup."
                    ]
                },
                "SPD_OVR": {
                    "value": "GOVRON",
                    "comment": [
                        "Speed overriding (GOVRON to allow speed override or GOVOFF to ignore speed override)."
                    ]
                },
                "DEF_PER": {
                    "value": 100,
                    "comment": [
                        "Default percentage speed instruction."
                    ]
                },
                "DEF_ORI": {
                    "value": 360,
                    "comment": [
                        "Default orientation speed in deg/s."
                    ]
                },
                "DEF_EXJ_L": {
                    "value": 360,
                    "comment": [
                        "Default External Axes linear speed in deg/s."
                    ]
                },
                "DEF_EXJ_R": {
                    "value": 180,
                    "comment": [
                        "Default External Axes for Rotative axes in deg/s."
                    ]
                },
                "INT0": {
                    "value": 100,
                    "comment": [
                        "Wait DI timeout judgement value (ms)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for linear moves in %."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "True",
                    "comment": [
                        "Add the RoboDK frame."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "True",
                    "comment": [
                        "Add the RoboDK tool."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                },
                "DEFAULT_MAX_LINES_X_PROG": {
                    "value": "",
                    "comment": [
                        "Default maximum number of lines per file. If this number is exceeded, the program is splitted in different files.",
                        "This setting can be overridden in RoboDK (Tools-Options-Program).",
                        "A value <=0 or None will discard this limit."
                    ]
                },
                "SAVE_SUBPROGRAMS_SEPARATELY": {
                    "value": "False",
                    "comment": [
                        "Set to True to create one additional file per subprogram, False to bundle everything in one file."
                    ]
                },
                "END_TOOL_NAME": {
                    "value": "nullTool",
                    "comment": [
                        "Tool to load at the end of every program (None to disable).",
                        "Adds a MovJ to the current joint position (APOS, so the robot does not move) using this.",
                        "Tool, which leaves it loaded when the program ends. The tool must already exist on the.",
                        "Controller (TCP 0,0,0): it is deliberately not written to '_global.erd', because.",
                        "Rewriting the tool that is currently loaded gives controller error 88806."
                    ]
                },
                "JOINT_SPEED_100PCT_DEGS": {
                    "value": 200.0,
                    "comment": [
                        "Convert the RoboDK joint speed (deg/s) to the 'per' (%) field of the SPEED variables.",
                        "Set both to None to keep DEF_PER for every SPEED.",
                        "JOINT_SPEED_100PCT_DEGS: joint speed in deg/s that corresponds to 100 % (200.0 is the.",
                        "Same conversion as the RoboDK Estun RCS2 driver).",
                        "FIXED_JOINT_PCT: fixed 'per' (%) for every SPEED, ignoring the RoboDK joint speed.",
                        "Takes precedence over JOINT_SPEED_100PCT_DEGS."
                    ]
                },
                "FIXED_JOINT_PCT": {
                    "value": 10.0,
                    "comment": []
                },
                "MERGE_GLOBAL_ERD": {
                    "value": "True",
                    "comment": [
                        "Merge the generated '_global.erd' into a copy of the '_global.erd' of the robot, instead.",
                        "Of using it directly (RoboDK only knows the tools and frames of the current station).",
                        "Result: '_global_MERGED.erd' and '_global_MERGED_report.txt' next to the program."
                    ]
                },
                "ROBOT_GLOBAL_ERD": {
                    "value": "",
                    "comment": [
                        "ROBOT_GLOBAL_ERD: path to a copy of the robot '_global.erd'.",
                        "None = look for '_global_robot.erd' in the program folder, which is the copy that.",
                        "\"Send program to robot\" downloads from the controller."
                    ]
                },
                "MERGE_OVERWRITE": {
                    "value": "[]",
                    "comment": [
                        "Variables to update even if they already exist on the robot (for TOOL and USERCOOR only.",
                        "X,y,z,a,b,c are updated, the id, the payload and the note of the robot are kept).",
                        "[] only add what is missing, never change an existing variable.",
                        "['Tool1', 'Tool2'] update these ones.",
                        "'ALL' or True update every variable of this station that exists on the robot.",
                        "The variables of MERGE_IGNORE ('Home' and the end-of-program tool) are never updated."
                    ]
                },
                "SEND_GLOBAL_ERD": {
                    "value": "True",
                    "comment": [
                        "\"Send program to robot\": download the global file of the robot, merge the new RoboDK.",
                        "Tools and frames into it, and upload it again. A backup is kept on the robot.",
                        "('_global_backup_<date>.erd') and on the PC. The '_global.erd' generated by RoboDK is.",
                        "Never uploaded as-is when this option is enabled."
                    ]
                },
                "ROBOT_GLOBAL_ERD_REMOTE": {
                    "value": "",
                    "comment": [
                        "Global variables file (t_g) on the controller. None = automatic: '_global.erd' in the.",
                        "Project folder, which is the parent of the Remote path,.",
                        "E.g. Remote path /opt/runtime/Project/MyPrograms -> /opt/runtime/Project/_global.erd."
                    ]
                },
                "ROBOT_PROJECT_FOLDERS": {
                    "value": "['/opt/runtime/Project']",
                    "comment": [
                        "The Remote path of the robot connection must be a SUBFOLDER of the controller project.",
                        "Folder, e.g. /opt/runtime/Project/MyPrograms, and that subfolder must already exist on.",
                        "The controller. Transferring the programs directly into the project folder does not.",
                        "Work. Sending a program to one of the folders listed here is refused with a warning.",
                        "Add the project folder of your controller if it is not the standard one."
                    ]
                }
            }
        },
        "Estun-RCS3": {
            "N": "Estun RCS3",
            "F": "Estun_RCS3.py",
            "B": "Estun",
            "EXT": ".jlt",
            "SC": [
                "Estun RCS3"
            ],
            "D": [
                "The Estun RCS3 post processor for Estun robots generates module files (.jlt) for RCS3 controllers.",
                "The '_S_frame_r1.jlt' and '_S_tool_r1.jlt' files (user frame and TCP definitions) are generated optionally"
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "jlt",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "ADD_TDATA": {
                    "value": "True",
                    "comment": [
                        "Generate TCP definition file."
                    ]
                },
                "ADD_FDATA": {
                    "value": "True",
                    "comment": [
                        "Generate frame definition file."
                    ]
                },
                "USE_MAIN": {
                    "value": "True",
                    "comment": [
                        "Use main module."
                    ]
                },
                "COMPLETE_BC": {
                    "value": "False",
                    "comment": [
                        "TODO: Generate complete backup."
                    ]
                },
                "DEF_PER": {
                    "value": 10,
                    "comment": [
                        "Default speed instruction options.",
                        "%."
                    ]
                },
                "DEF_ORI": {
                    "value": 360,
                    "comment": [
                        "Deg/s."
                    ]
                },
                "DEF_EXJ_L": {
                    "value": 360,
                    "comment": [
                        "Deg/s."
                    ]
                },
                "DEF_EXJ_R": {
                    "value": 180,
                    "comment": [
                        "Deg/s."
                    ]
                },
                "INT0": {
                    "value": 100,
                    "comment": [
                        "Wait DI timeout judgement value (ms)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 2000.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "True",
                    "comment": [
                        "Add the RoboDK frame."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "True",
                    "comment": [
                        "Add the RoboDK tool."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                },
                "DEFAULT_MAX_LINES_X_PROG": {
                    "value": "",
                    "comment": [
                        "Default maximum number of lines per file. If this number is exceeded, the program is splitted in different files.",
                        "This setting can be overridden in RoboDK (Tools-Options-Program).",
                        "A value <=0 or None will discard this limit."
                    ]
                },
                "SAVE_SUBPROGRAMS_SEPARATELY": {
                    "value": "False",
                    "comment": [
                        "Set to True to create one additional file per subprogram, False to bundle everything in one file."
                    ]
                }
            }
        },
        "Fairino": {
            "N": "Fairino",
            "F": "Fairino.py",
            "B": "FAIRINO",
            "EXT": ".lua",
            "SC": [
                "FAIRINO FRC100-AC"
            ],
            "D": [
                "The Fairino post processor produces .lua files and supports the Fairino FR series of robots."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "lua",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Fairino-db": {
            "N": "Fairino db",
            "F": "Fairino_db.py",
            "B": "FAIRINO",
            "EXT": ".lua",
            "SC": [
                "FAIRINO FRC100-AC"
            ],
            "D": [
                "The Fairino post processor produces .lua files and DB-file with point coordinates."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "lua",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "RECALC_USER_FRAME": {
                    "value": "True",
                    "comment": [
                        "Recalculate the user frame relative to the base frame."
                    ]
                }
            }
        },
        "Fanuc-R30i": {
            "N": "Fanuc R30i",
            "F": "Fanuc_R30i.py",
            "B": "Fanuc",
            "EXT": ".LS",
            "SC": [
                "Fanuc R30iA",
                "Fanuc R30iB"
            ],
            "D": [
                "The Fanuc R30i post processor produces .LS code and supports the most modern Fanuc R30i robot controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 9999,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages\" (files).",
                        "This setting can be overriden by RoboDK settings (Tools-Options-Program)."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs."
                    ]
                },
                "JOINT_SPEED": {
                    "value": "20%",
                    "comment": [
                        "Set default joint speed (percentage of the total speed)."
                    ]
                },
                "SPEED": {
                    "value": "200mm/sec",
                    "comment": [
                        "Set default cartesian speed motion."
                    ]
                },
                "CNT_VALUE": {
                    "value": "FINE",
                    "comment": [
                        "Set default CNT value (all motion until smooth value is changed).",
                        "CNT_VALUE = 'CNT5' \u2010 5% smoothing (set CNT1-CNT100)."
                    ]
                },
                "ACCEL_VALUE": {
                    "value": "",
                    "comment": [
                        "Set the acceleration value. For example: ACC20 or empty."
                    ]
                },
                "ACTIVE_UF": {
                    "value": 9,
                    "comment": [
                        "Active UFrame Id (register)."
                    ]
                },
                "ACTIVE_UT": {
                    "value": 9,
                    "comment": [
                        "Active UTool Id (register)."
                    ]
                },
                "SPARE_PR": {
                    "value": 9,
                    "comment": [
                        "Spare Position register for calculations (such as setting UFRAME and UTOOL)."
                    ]
                },
                "MAX_FRAME_ID": {
                    "value": 9,
                    "comment": [
                        "Set the maximum index to use when linking to existing Frame IDs. This is a safety feature as linking to non valid IDs can make the controller behave unexpectedly."
                    ]
                },
                "MAX_TOOL_ID": {
                    "value": 9,
                    "comment": [
                        "Set the maximum index to use when linking to existing Tool IDs. This is a safety feature as linking to non valid IDs can make the controller behave unexpectedly."
                    ]
                },
                "CUSTOM_STRING": {
                    "value": "",
                    "comment": [
                        "Custom string to add at the end of each linear movement. For example: Offset,PR[1], or COORD."
                    ]
                },
                "CUSTOM_STRING_J": {
                    "value": "",
                    "comment": [
                        "Custom string to add at the end of each joint movement. For example: Offset,PR[1], or COORD."
                    ]
                },
                "TURNTABLE_GROUP": {
                    "value": "GP2",
                    "comment": [
                        "Set the turntable group (usually GP2 or GP3, set to None to not use a new group).",
                        "TURNTABLE_GROUP = None.",
                        "TURNTABLE_GROUP = 'GP3'."
                    ]
                },
                "USE_VAR_AXES_MOTION_GROUP": {
                    "value": "False",
                    "comment": [
                        "Disables motion group heuristics and uses user defnined mapping."
                    ]
                },
                "AXES_MOTION_GROUP": {
                    "value": "[1, 1, 1, 1, 1, 1, 2, 2, 3, 1, 1, 1, 2, 2, 2, 2, 2, 2]",
                    "comment": [
                        "Motion group for each axis, default first 9 axes in group 1, then next 9 axes in group 2.",
                        "AXES_MOTION_GROUP = [1,1,1,1,2,2,2,2]."
                    ]
                },
                "FORCE_EXTAXES": {
                    "value": "",
                    "comment": [
                        "Default.",
                        "Force adding values for the external axes for joint targets and Cartesian targets without the need to synchronize them in RoboDK."
                    ]
                },
                "USE_ROBODK_UFRAME": {
                    "value": "False",
                    "comment": [
                        "Always use RoboDK user frames (references)."
                    ]
                },
                "USE_ROBODK_UTOOL": {
                    "value": "False",
                    "comment": [
                        "Always use RoboDK tool frames (tools)."
                    ]
                },
                "FANUC_RJ3_COMPATIBLE": {
                    "value": "False",
                    "comment": [
                        "Set to True to generate programs compatible with RJ3 controllers (small difference in the program header, program names should have less than 6-8 characters)."
                    ]
                },
                "MAX_PROG_CHARS": {
                    "value": 12,
                    "comment": [
                        "Maximum number of characters for program names.",
                        "R-30iB+ limit is 16 characters, R-30iA and R-30iB are 12 characters and RJ3 is 8 characters."
                    ]
                },
                "MAX_LINE_CHARS": {
                    "value": 72,
                    "comment": [
                        "Maximum number of characters for a line of code.",
                        "R-30iB+ limit is 80 characters, R-30iA, R-30iB and RJ3 are 72 characters."
                    ]
                },
                "EXTAXES_FLAGS": {
                    "value": "['1', '*', '*', '*', '*']",
                    "comment": [
                        "Set the flags for external axes (keep it to 5 at most)."
                    ]
                },
                "APPLICATION_DATA": {
                    "value": "",
                    "comment": [
                        "Set custom application data, such as welding options or external axes options.",
                        "You may need to configure the custom /APPL header if you see this error when you try to run your program: \"INTP-281 No application data\".",
                        "APPLICATION_DATA = ['ARC : TRUE;' , 'ARC Welding Equipment : 1,*,*,*,*;']."
                    ]
                },
                "PATH_MAKE_TP": {
                    "value": "C:/Program Files (x86)/FANUC/WinOLPC/bin/",
                    "comment": [
                        "PATH_MAKE_TP = None # Ignore program compilation.",
                        "Compile LS program to TP programs.",
                        "More help here: https://robodk.com/doc/en/Robots-Fanuc.html#LSvsTP.",
                        "Set the path to Roboguide WinOLPC tools, alternatively, set to None to prevent generating TP files.",
                        "This step is ignored if the path does not exist."
                    ]
                },
                "DRIPFEED_FILE_NAME": {
                    "value": "",
                    "comment": [
                        "Don't do any dripfeeding.",
                        "Generate a drip feeder program: this will split long programs in subprograms and load them to the controller as they are executed.",
                        "Set a file name to use an automatic dripfeeder: Files will be sent over FTP as they are executed.",
                        "Right click a program and select \"Send Program to Robot\" to trigger the dripfeeding automatically.",
                        "DRIPFEED_FILE_NAME = \"Fanuc_SendProgram_DripFeed.py\"."
                    ]
                },
                "FORCE_POPUP_SAVE": {
                    "value": "False",
                    "comment": [
                        "Force user input to save the folder."
                    ]
                },
                "IS_5DOF_ARM": {
                    "value": "False",
                    "comment": [
                        "Set to True for a 5-axis robot arm that is modelled like a 6-axis robot.",
                        "This flag is automatically set to True for 5-axis robots such as the Fanuc LR Mate 100i."
                    ]
                }
            }
        },
        "Fanuc-RJ3": {
            "N": "Fanuc RJ3",
            "F": "Fanuc_RJ3.py",
            "B": "Fanuc",
            "SC": [
                "Fanuc R-J3iA",
                "Fanuc R-J3iB",
                "Fanuc R-J3iC",
                "Fanuc R-30iA",
                "Fanuc R-30iB"
            ],
            "D": [
                "The Fanuc RJ3 post processor generates robot programs for the Fanuc R-J3 Controller.",
                "The FANUC R-J3 controller is an industrial robot controller that is available in multiple cabinet sizes.",
                "This Fanuc controller was produced from 1998 until 2001.",
                "This post processor supports almost all Fanuc controllers available."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 9999,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages\" (files).",
                        "This setting can be overriden by RoboDK settings (Tools-Options-Program)."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs."
                    ]
                },
                "JOINT_SPEED": {
                    "value": "20%",
                    "comment": [
                        "Set default joint speed (percentage of the total speed)."
                    ]
                },
                "SPEED": {
                    "value": "200mm/sec",
                    "comment": [
                        "Set default cartesian speed motion."
                    ]
                },
                "CNT_VALUE": {
                    "value": "FINE",
                    "comment": [
                        "Set default CNT value (all motion until smooth value is changed).",
                        "CNT_VALUE = 'CNT5' \u2010 5% smoothing (set CNT1-CNT100)."
                    ]
                },
                "ACCEL_VALUE": {
                    "value": "",
                    "comment": [
                        "Set the acceleration value. For example: ACC20 or empty."
                    ]
                },
                "ACTIVE_UF": {
                    "value": 9,
                    "comment": [
                        "Active UFrame Id (register)."
                    ]
                },
                "ACTIVE_UT": {
                    "value": 9,
                    "comment": [
                        "Active UTool Id (register)."
                    ]
                },
                "SPARE_PR": {
                    "value": 9,
                    "comment": [
                        "Spare Position register for calculations (such as setting UFRAME and UTOOL)."
                    ]
                },
                "MAX_FRAME_ID": {
                    "value": 9,
                    "comment": [
                        "Set the maximum index to use when linking to existing Frame IDs. This is a safety feature as linking to non valid IDs can make the controller behave unexpectedly."
                    ]
                },
                "MAX_TOOL_ID": {
                    "value": 9,
                    "comment": [
                        "Set the maximum index to use when linking to existing Tool IDs. This is a safety feature as linking to non valid IDs can make the controller behave unexpectedly."
                    ]
                },
                "CUSTOM_STRING": {
                    "value": "",
                    "comment": [
                        "Custom string to add at the end of each linear movement. For example: Offset,PR[1], or COORD."
                    ]
                },
                "CUSTOM_STRING_J": {
                    "value": "",
                    "comment": [
                        "Custom string to add at the end of each joint movement. For example: Offset,PR[1], or COORD."
                    ]
                },
                "TURNTABLE_GROUP": {
                    "value": "GP2",
                    "comment": [
                        "Set the turntable group (usually GP2 or GP3, set to None to not use a new group).",
                        "TURNTABLE_GROUP = None.",
                        "TURNTABLE_GROUP = 'GP3'."
                    ]
                },
                "USE_VAR_AXES_MOTION_GROUP": {
                    "value": "False",
                    "comment": [
                        "Disables motion group heuristics and uses user defnined mapping."
                    ]
                },
                "AXES_MOTION_GROUP": {
                    "value": "[1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2]",
                    "comment": [
                        "Motion group for each axis, default first 9 axes in group 1, then next 9 axes in group 2.",
                        "AXES_MOTION_GROUP = [1,1,1,1,2,2,2,2]."
                    ]
                },
                "USE_ROBODK_UFRAME": {
                    "value": "False",
                    "comment": [
                        "Always use RoboDK user frames (references)."
                    ]
                },
                "USE_ROBODK_UTOOL": {
                    "value": "False",
                    "comment": [
                        "Always use RoboDK tool frames (tools)."
                    ]
                },
                "FANUC_RJ3_COMPATIBLE": {
                    "value": "True",
                    "comment": [
                        "Set to True to generate programs compatible with RJ3 controllers (small difference in the program header)."
                    ]
                },
                "MAX_PROG_CHARS": {
                    "value": 8,
                    "comment": [
                        "Maximum number of characters for program names.",
                        "R-30iB+ limit is 16 characters, R-30iA and R-30iB are 12 characters and RJ3 is 8 characters."
                    ]
                },
                "MAX_LINE_CHARS": {
                    "value": 72,
                    "comment": [
                        "Maximum number of characters for a line of code.",
                        "R-30iB+ limit is 80 characters, R-30iA, R-30iB and RJ3 are 72 characters."
                    ]
                },
                "PATH_MAKE_TP": {
                    "value": "C:/Program Files (x86)/FANUC/WinOLPC/bin/",
                    "comment": [
                        "PATH_MAKE_TP = None # Ignore program compilation.",
                        "Compile LS program to TP programs.",
                        "More help here: https://robodk.com/doc/en/Robots-Fanuc.html#LSvsTP.",
                        "Set the path to Roboguide WinOLPC tools, alternatively, set to None to prevent generating TP files.",
                        "This step is ignored if the path does not exist."
                    ]
                },
                "DRIPFEED_FILE_NAME": {
                    "value": "",
                    "comment": [
                        "Don't do any dripfeeding.",
                        "Generate a drip feeder program: this will split long programs in subprograms and load them to the controller as they are executed.",
                        "Set a file name to use an automatic dripfeeder: Files will be sent over FTP as they are executed.",
                        "Right click a program and select \"Send Program to Robot\" to trigger the dripfeeding automatically.",
                        "DRIPFEED_FILE_NAME = \"Fanuc_SendProgram_DripFeed.py\"."
                    ]
                },
                "FORCE_POPUP_SAVE": {
                    "value": "False",
                    "comment": [
                        "Force user input to save the folder."
                    ]
                },
                "IS_5DOF_ARM": {
                    "value": "False",
                    "comment": [
                        "Set to True for a 5-axis robot arm that is modelled like a 6-axis robot.",
                        "This flag is automatically set to True for 5-axis robots such as the Fanuc LR Mate 100i."
                    ]
                },
                "FORCE_EXTAXES": {
                    "value": "",
                    "comment": [
                        "Default.",
                        "Force adding values for the external axes for joint targets and Cartesian targets without the need to synchronize them in RoboDK."
                    ]
                },
                "EXTAXES_FLAGS": {
                    "value": "['1', '*', '*', '*', '*']",
                    "comment": [
                        "Set the flags for external axes (keep it to 5 at most)."
                    ]
                },
                "APPLICATION_DATA": {
                    "value": "",
                    "comment": [
                        "Set custom application data, such as welding options or external axes options.",
                        "You may need to configure the custom /APPL header if you see this error when you try to run your program: \"INTP-281 No application data\".",
                        "APPLICATION_DATA = ['ARC : TRUE;' , 'ARC Welding Equipment : 1,*,*,*,*;']."
                    ]
                }
            },
            "EXT": ".LS"
        },
        "Fanuc-RJ3-DripFeed": {
            "N": "Fanuc RJ3 DripFeed",
            "F": "Fanuc_RJ3_DripFeed.py",
            "B": "Fanuc",
            "SC": [
                "Fanuc R-J3",
                "Fanuc R-J3iA",
                "Fanuc R-J3iB",
                "Fanuc R-J3iC"
            ],
            "D": [
                "The Fanuc RJ3 DripFeed post processor generates robot programs for the Fanuc R-J3 Controller.",
                "It is specially designed to generate a drip feeder program that will split long programs in subprograms and load them to the controller as they are executed."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 9999,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages\" (files).",
                        "This setting can be overriden by RoboDK settings (Tools-Options-Program)."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs."
                    ]
                },
                "JOINT_SPEED": {
                    "value": "20%",
                    "comment": [
                        "Set default joint speed (percentage of the total speed)."
                    ]
                },
                "SPEED": {
                    "value": "200mm/sec",
                    "comment": [
                        "Set default cartesian speed motion."
                    ]
                },
                "CNT_VALUE": {
                    "value": "FINE",
                    "comment": [
                        "Set default CNT value (all motion until smooth value is changed).",
                        "CNT_VALUE = 'CNT5' \u2010 5% smoothing (set CNT1-CNT100)."
                    ]
                },
                "ACCEL_VALUE": {
                    "value": "",
                    "comment": [
                        "Set the acceleration value. For example: ACC20 or empty."
                    ]
                },
                "ACTIVE_UF": {
                    "value": 9,
                    "comment": [
                        "Active UFrame Id (register)."
                    ]
                },
                "ACTIVE_UT": {
                    "value": 9,
                    "comment": [
                        "Active UTool Id (register)."
                    ]
                },
                "SPARE_PR": {
                    "value": 9,
                    "comment": [
                        "Spare Position register for calculations (such as setting UFRAME and UTOOL)."
                    ]
                },
                "MAX_FRAME_ID": {
                    "value": 9,
                    "comment": [
                        "Set the maximum index to use when linking to existing Frame IDs. This is a safety feature as linking to non valid IDs can make the controller behave unexpectedly."
                    ]
                },
                "MAX_TOOL_ID": {
                    "value": 9,
                    "comment": [
                        "Set the maximum index to use when linking to existing Tool IDs. This is a safety feature as linking to non valid IDs can make the controller behave unexpectedly."
                    ]
                },
                "CUSTOM_STRING": {
                    "value": "",
                    "comment": [
                        "Custom string to add at the end of each linear movement. For example: Offset,PR[1], or COORD."
                    ]
                },
                "CUSTOM_STRING_J": {
                    "value": "",
                    "comment": [
                        "Custom string to add at the end of each joint movement. For example: Offset,PR[1], or COORD."
                    ]
                },
                "TURNTABLE_GROUP": {
                    "value": "GP2",
                    "comment": [
                        "Set the turntable group (usually GP2 or GP3, set to None to not use a new group).",
                        "TURNTABLE_GROUP = None.",
                        "TURNTABLE_GROUP = 'GP3'."
                    ]
                },
                "USE_ROBODK_UFRAME": {
                    "value": "False",
                    "comment": [
                        "Always use RoboDK user frames (references)."
                    ]
                },
                "USE_ROBODK_UTOOL": {
                    "value": "False",
                    "comment": [
                        "Always use RoboDK tool frames (tools)."
                    ]
                },
                "FANUC_RJ3_COMPATIBLE": {
                    "value": "True",
                    "comment": [
                        "Set to True to generate programs compatible with RJ3 controllers (small difference in the program header, program names should have less than 6-8 characters)."
                    ]
                },
                "MAX_PROG_CHARS": {
                    "value": 8,
                    "comment": [
                        "Maximum number of characters for program names.",
                        "R-30iB+ limit is 16 characters, R-30iA and R-30iB are 12 characters and RJ3 is 8 characters."
                    ]
                },
                "MAX_LINE_CHARS": {
                    "value": 72,
                    "comment": [
                        "Maximum number of characters for a line of code.",
                        "R-30iB+ limit is 80 characters, R-30iA, R-30iB and RJ3 are 72 characters."
                    ]
                },
                "PATH_MAKE_TP": {
                    "value": "C:/Program Files (x86)/FANUC/WinOLPC/bin/",
                    "comment": [
                        "PATH_MAKE_TP = None # Ignore program compilation.",
                        "Compile LS program to TP programs.",
                        "More help here: https://robodk.com/doc/en/Robots-Fanuc.html#LSvsTP.",
                        "Set the path to Roboguide WinOLPC tools, alternatively, set to None to prevent generating TP files.",
                        "This step is ignored if the path does not exist."
                    ]
                },
                "DRIPFEED_FILE_NAME": {
                    "value": "Fanuc_SendProgram_DripFeed.py",
                    "comment": [
                        "DRIPFEED_FILE_NAME = None       # Don't do any dripfeeding.",
                        "Generate a drip feeder program: this will split long programs in subprograms and load them to the controller as they are executed.",
                        "Set a file name to use an automatic dripfeeder: Files will be sent over FTP as they are executed.",
                        "Right click a program and select \"Send Program to Robot\" to trigger the dripfeeding automatically."
                    ]
                },
                "FORCE_POPUP_SAVE": {
                    "value": "True",
                    "comment": [
                        "Always force user input to save the folder."
                    ]
                },
                "IS_5DOF_ARM": {
                    "value": "False",
                    "comment": [
                        "Set to True for a 5-axis robot arm that is modelled like a 6-axis robot.",
                        "This flag is automatically set to True for 5-axis robots such as the Fanuc LR Mate 100i."
                    ]
                },
                "USE_VAR_AXES_MOTION_GROUP": {
                    "value": "False",
                    "comment": [
                        "Disables motion group heuristics and uses user defnined mapping."
                    ]
                },
                "AXES_MOTION_GROUP": {
                    "value": "[1, 1, 1, 1, 1, 1, 2, 2, 3, 1, 1, 1, 2, 2, 2, 2, 2, 2]",
                    "comment": [
                        "Motion group for each axis, default first 9 axes in group 1, then next 9 axes in group 2.",
                        "AXES_MOTION_GROUP = [1,1,1,1,2,2,2,2]."
                    ]
                },
                "FORCE_EXTAXES": {
                    "value": "",
                    "comment": [
                        "Default.",
                        "Force adding values for the external axes for joint targets and Cartesian targets without the need to synchronize them in RoboDK."
                    ]
                },
                "EXTAXES_FLAGS": {
                    "value": "['1', '*', '*', '*', '*']",
                    "comment": [
                        "Set the flags for external axes (keep it to 5 at most)."
                    ]
                },
                "APPLICATION_DATA": {
                    "value": "",
                    "comment": [
                        "Set custom application data, such as welding options or external axes options.",
                        "You may need to configure the custom /APPL header if you see this error when you try to run your program: \"INTP-281 No application data\".",
                        "APPLICATION_DATA = ['ARC : TRUE;' , 'ARC Welding Equipment : 1,*,*,*,*;']."
                    ]
                }
            },
            "EXT": ".LS"
        },
        "Flexiv": {
            "N": "Flexiv",
            "F": "Flexiv.py",
            "B": "Flexiv",
            "EXT": ".traj",
            "SC": [
                "Flexiv Hesper"
            ],
            "D": [
                "The Flexiv post processor generates trajectory files (.traj) for Flexiv Hesper controllers.",
                "The Hesper controllers are used for Rizon robots."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "traj",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 0.5,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 2000.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": "Z0",
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                },
                "DEFAULT_MAX_LINES_X_PROG": {
                    "value": "",
                    "comment": [
                        "Default maximum number of lines per file. If this number is exceeded, the program is splitted in different files.",
                        "This setting can be overridden in RoboDK (Tools-Options-Program).",
                        "A value <=0 or None will discard this limit."
                    ]
                },
                "SAVE_SUBPROGRAMS_SEPARATELY": {
                    "value": "False",
                    "comment": [
                        "Set to True to create one additional file per subprogram, False to bundle everything in one file."
                    ]
                }
            }
        },
        "Foxbot": {
            "N": "Foxbot",
            "F": "Foxbot.py",
            "B": "Foxbot",
            "EXT": ".pac",
            "SC": [
                "Foxbot"
            ],
            "D": [
                "The Foxbot post processor produces .pac files for Foxbot controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "pac",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "SPEED_PERCENT": {
                    "value": 20,
                    "comment": [
                        "Default speed percentage."
                    ]
                },
                "TARGETS_AS_MDB_FILE": {
                    "value": "True",
                    "comment": [
                        "Use MDB file to save targets."
                    ]
                }
            }
        },
        "GCode-A3200": {
            "N": "GCode A3200",
            "F": "GCode_A3200.py",
            "EXT": ".cnc",
            "SC": [
                "Aerotech A3200"
            ],
            "D": [
                "The GCode A3200 post processor generates .cnc files that are specifically formatted for Aerotech's A3200 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "cnc",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "GCode-BnR": {
            "N": "GCode BnR",
            "F": "GCode_BnR.py",
            "EXT": ".cnc",
            "SC": [
                "B&R Industrial Automation"
            ],
            "D": [
                "The GCode BnR post processor produces .cnc code for B&R Industrial Automation controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "cnc",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "GCode-NCP": {
            "N": "GCode NCP",
            "F": "GCode_NCP.py",
            "EXT": ".cnc",
            "SC": [],
            "D": [
                "The GCode NCP post processor generates .cnc files compatible with controllers that support the NCP language."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "cnc",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "GSK": {
            "N": "GSK",
            "F": "GSK.py",
            "B": "GSK",
            "EXT": ".PRL",
            "SC": [
                "GSK"
            ],
            "D": [
                "The GSK post processor produces .PRL files tailored for GSK controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "PRL",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 999,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\"."
                    ]
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1]",
                    "comment": []
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": []
                }
            }
        },
        "Hans": {
            "N": "Hans",
            "F": "Hans.py",
            "B": "Han's",
            "EXT": ".script",
            "SC": [],
            "D": [
                "The Han's Post generates programs for Han's Robot robots (now known as Huayan Robotics).",
                "The post outputs two files:",
                "A .script file that shows the program instructions in a human readable format.",
                "A .json file that contains the program instructions in a machine readable format and can be uploaded to Hans controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "JSON_EXT": {
                    "value": "json",
                    "comment": []
                },
                "JSON_TXT": {
                    "value": "[...]",
                    "comment": []
                }
            }
        },
        "HCR": {
            "N": "HCR",
            "F": "HCR.py",
            "B": "Hanwha",
            "EXT": ".js",
            "SC": [
                "Hanwha HCR"
            ],
            "D": [
                "The HCR post processor generates JavaScript code suitable for Hanwha HCR robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "js",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "CURR_SPEED": {
                    "value": 500,
                    "comment": []
                },
                "CURR_ACCEL": {
                    "value": 1000,
                    "comment": []
                },
                "CURR_JOINT_SPEED": {
                    "value": 50,
                    "comment": []
                },
                "CURR_JOINT_ACCEL": {
                    "value": 100,
                    "comment": []
                }
            }
        },
        "HIWIN-HRSS": {
            "N": "HIWIN HRSS",
            "F": "HIWIN_HRSS.py",
            "B": "HIWIN",
            "EXT": ".hrb",
            "SC": [
                "HIWIN HRSS"
            ],
            "D": [
                "The HIWIN HRSS post processor generates .hrb files for HIWIN HRSS systems (HIWIN Robot System Software)."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "hrb",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 5000,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\"."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": []
                }
            }
        },
        "Huayan": {
            "N": "Huayan",
            "F": "Huayan.py",
            "B": "Huayan Han's",
            "SC": [],
            "D": [
                "The Huayan Post generates programs for Huayan Robotics robots (formerly known as Han's Robot).",
                "The post outputs two files:",
                "A .script file that shows the program instructions in a human readable format.",
                "A .json file that contains the program instructions in a machine readable format and can be uploaded to Hans controllers."
            ],
            "VARS": {
                "JSON_TXT": {
                    "value": "[...]",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "JSON_EXT": {
                    "value": "json",
                    "comment": []
                }
            },
            "EXT": ".script"
        },
        "Hyundai": {
            "N": "Hyundai",
            "F": "Hyundai.py",
            "B": "Hyundai Robotics",
            "EXT": ".JOB",
            "SC": [
                "Hyundai Hi5",
                "Hyundai Hi6"
            ],
            "D": [
                "The Hyundai post processor produces .JOB files compatible with Hyundai robotic controllers."
            ],
            "VARS": {
                "HEADER_LINE": {
                    "value": "",
                    "comment": [
                        "Program header line.",
                        "Example: Program File Format Version : 1.6 MechType: 578(HA006L-02) TotalAxis: 8 AuxAxis: 2."
                    ]
                },
                "PROG_ID": {
                    "value": 5,
                    "comment": [
                        "Default Program ID (ID to store the program)."
                    ]
                },
                "TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default id for the tool (H=TOOL_ID)."
                    ]
                },
                "FRAME_ID": {
                    "value": 0,
                    "comment": [
                        "Default id for the reference (H=TOOL_ID)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 950,
                    "comment": [
                        "Default maximum number of lines per program."
                    ]
                },
                "EXTAXIS_UNIT": {
                    "value": "",
                    "comment": [
                        "\"A/UNIT2\".",
                        "Name of the external axis unit (M2J or M3J).",
                        "Tip: You can name a coordinate system with the M2J or M3J keyword to automatically swap the unit."
                    ]
                },
                "USE_MOVEP_FOR_MOVEJ": {
                    "value": "False",
                    "comment": [
                        "Use MOVEP instruction for joint movements."
                    ]
                }
            }
        },
        "IGUS": {
            "N": "IGUS",
            "F": "IGUS.py",
            "B": "igus",
            "EXT": ".xml",
            "SC": [
                "igus iRC Release 14"
            ],
            "D": [
                "The igus post processor produces XML-formatted code suitable for igus robotic systems."
            ],
            "VARS": {
                "IGUS_USE_TOOL_FILE": {
                    "value": "True",
                    "comment": [
                        "Generates a file with all the tools used."
                    ]
                },
                "IGUS_USE_FRAME_FILE": {
                    "value": "True",
                    "comment": [
                        "Generates a file with all the frames used in the program."
                    ]
                }
            }
        },
        "IIMT": {
            "N": "IIMT",
            "F": "IIMT.py",
            "B": "IIMT",
            "EXT": ".lua",
            "SC": [
                "IIMT CR Series"
            ],
            "D": [
                "The IIMT post processor generates IIMT CR code for the IIMT CR series robots. The output is formatted in .txt, allowing to be loaded in IIMT CR robots easily."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "lua",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 2000.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                }
            }
        },
        "Inexbot": {
            "N": "Inexbot",
            "F": "Inexbot.py",
            "B": "Inexbot",
            "EXT": ".JBI",
            "SC": [],
            "D": [
                "The Inexbot post processor generates .JBI files specifically designed for Inexbot controllers (Inform III)."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "Set the default maximum number of lines per program.",
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "MAX_NAME_CHARS": {
                    "value": 7,
                    "comment": [
                        "Set the maximum number of characters allowed for program names."
                    ]
                },
                "USE_SETTOOL": {
                    "value": "False",
                    "comment": [
                        "Set to True to use SETTOOL for setting the tool in the JBI program.",
                        "USE_SETTOOL = True \u2010 This requires the SETTOOL option from Motoman (paid option)."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 9,
                    "comment": [
                        "Specify the default UTool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use UTOOL number 2)."
                    ]
                },
                "SPEED_CM_MIN": {
                    "value": "False",
                    "comment": [
                        "Set the linear speed in CM/MIN instead of MM/S.",
                        "Some Motoman controllers require the speed in CM/S."
                    ]
                },
                "USE_RELATIVE_JOB": {
                    "value": "False",
                    "comment": [
                        "Set to False to always use pulses (otherwise, it may require a paid option).",
                        "USE_RELATIVE_JOB = True \u2010 This requires the Relative Job option from Motoman."
                    ]
                },
                "MOVEJ_IN_CARTESIAN": {
                    "value": "False",
                    "comment": [
                        "Force joint movements to be in Cartesian."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Specify a spare Position register for calculations (Tool, Reference, ...)."
                    ]
                },
                "USE_MFRAME": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MFRAME for setting reference frames automatically within the program."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 9,
                    "comment": [
                        "Specify the default UFrame Id to use (register).",
                        "You can also use Numbered References in RoboDK (for example, a reference named \"Reference 4\" will use UFRAME number 4)."
                    ]
                },
                "EXTAXES_USE_MOVJ": {
                    "value": "True",
                    "comment": [
                        "Will output: MOVL C00008 V=166.7  +MOVJ EC00008 VJ=100.00.",
                        "Specify if external axes must be moved according to a separate MOVJ command.",
                        "EXTAXES_USE_MOVJ = False \u2010 Will output: MOVL C00008 EC00008 V=166.7."
                    ]
                },
                "EXTAXES_USE_SMOVL": {
                    "value": "False",
                    "comment": [
                        "Specify if we want synchronized motion for Linear moves.",
                        "If True (default): Will output: SMOVL C00008 BC00008 V=166.7 +MOVJ EC00008 -> Synchronized motion (for the turntable).",
                        "If False : Will output: MOVL C00008 BC00008 V=166.7 +MOVJ EC00008 VJ=100.00 -> Non synchronized motion (for the turntable)."
                    ]
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1, 1.0, 1.0, 1, 1]",
                    "comment": [
                        "Specify the pulses/degree ratio for the external axes here (index 7,8,...)."
                    ]
                },
                "AXIS_INDEX": {
                    "value": "[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]",
                    "comment": [
                        "Table is already swaped (final ids).",
                        "Option to swap a specific axis.",
                        "AXIS_INDEX = [0,1,2,3,4,5,6,7] \u2010 example to swap axes 7 and 8 (external axes 1-2)."
                    ]
                },
                "DEFAULT_ACCELERATION": {
                    "value": 100,
                    "comment": []
                }
            }
        },
        "INOVANCE": {
            "N": "INOVANCE",
            "F": "INOVANCE.py",
            "B": "INOVANCE",
            "EXT": ".pro",
            "SC": [
                "Inovance IRCB501"
            ],
            "D": [
                "The Inovance post processor allows you to generate code for Inovance robot controllers."
            ]
        },
        "JAKA": {
            "N": "JAKA",
            "F": "JAKA.py",
            "B": "JAKA",
            "EXT": ".jks",
            "SC": [],
            "D": [
                "The JAKA post processor allows you to generate code for JAKA controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "Default maximum number of lines per program. If a program exceeds this value it will then generate multiple \"pages\" (files).",
                        "This value can also be set in Tools-Options-Program-Maximum number of lines per program."
                    ]
                },
                "PROG_EXT": {
                    "value": "jks",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "PROG_EXT_ZU": {
                    "value": "zu",
                    "comment": [
                        "Set the Zu file extension."
                    ]
                },
                "PROG_EXT_ZUS": {
                    "value": "zus",
                    "comment": [
                        "Set the Zus (sub programs) file extension."
                    ]
                },
                "SPEED_MMS": {
                    "value": 250,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "SPEED_DEGS": {
                    "value": 60,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "ACCEL_MMSS": {
                    "value": 250,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "ACCEL_DEGSS": {
                    "value": 200,
                    "comment": [
                        "Default acceleration for joint moves in deg/s^2."
                    ]
                },
                "BLEND_RADIUS_MM": {
                    "value": 1.0,
                    "comment": [
                        "Default blend radius in millimeters (corners smoothing)."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "NEW_CONTROLLER_VERSION": {
                    "value": "True",
                    "comment": [
                        "Version toggle."
                    ]
                }
            }
        },
        "Kassow": {
            "N": "Kassow",
            "F": "Kassow.py",
            "B": "Kassow Robots",
            "EXT": ".kr2",
            "SC": [
                "Kassow Robots KR2"
            ],
            "D": [
                "The Kassow Robots post processor allows you to generate code for Kassow Robots KR2 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "kr2",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "SPEED_MMS": {
                    "value": 250,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "SPEED_DEGS": {
                    "value": 60,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "ACCEL_MMSS": {
                    "value": 250,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "ACCEL_DEGSS": {
                    "value": 200,
                    "comment": [
                        "Default acceleration for joint moves in deg/s^2."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": -1,
                    "comment": [
                        "Default blend radius in meters. A value less or equal to 0 means no blending."
                    ]
                },
                "TFC": {
                    "value": "",
                    "comment": [
                        "Robot-specific TFC for KR2 ([x_m,y_m,z_m,r_rad,p_rad,w_rad)]). If none is provided, will fallback to preset values based on robot name."
                    ]
                }
            }
        },
        "Kawasaki": {
            "N": "Kawasaki",
            "F": "Kawasaki.py",
            "B": "Kawasaki",
            "EXT": ".pg",
            "SC": [
                "Kawasaki C",
                "Kawasaki D",
                "Kawasaki D+",
                "Kawasaki E",
                "Kawasaki F"
            ],
            "D": [
                "The Kawasaki post processor allows you to generate code (.pg) for Kawasaki C, D, D+, E controllers.",
                "Up to 8 external axes are supported."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "pg",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "KEBA-KAIRO": {
            "N": "KEBA KAIRO",
            "F": "KEBA_KAIRO.py",
            "B": "KEBA",
            "EXT": ".tip",
            "SC": [],
            "D": [
                "The KEBA KAIRO post processor generates .tip files tailored for KEBA KAIRO instruction set."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "tip",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "PROG_EXT_VAR": {
                    "value": "tid",
                    "comment": []
                },
                "count_var_ptp": {
                    "value": 0,
                    "comment": []
                },
                "count_var_lin": {
                    "value": 0,
                    "comment": []
                }
            }
        },
        "Kinova": {
            "N": "Kinova",
            "F": "Kinova.py",
            "B": "Kinova",
            "EXT": ".py",
            "SC": [
                "Kinova"
            ],
            "D": [
                "The Kinova post processor generates Python code using the Kortex API, compatible with Kinova robotic arms."
            ],
            "VARS": {
                "POST_CODEGEN_MODE": {
                    "value": 1,
                    "comment": [
                        "Code generation mode.",
                        "1 = simulate.",
                        "2 = Online Programming (run on robot).",
                        "3 = Macro generation (RDK.AddProgram)."
                    ]
                },
                "MAIN_PROGRAM_NAME": {
                    "value": "",
                    "comment": [
                        "Name of the main function, obtained from first instance of ProgStart being called."
                    ]
                },
                "CURRENT_PROGRAM_NAME": {
                    "value": "robot",
                    "comment": [
                        "Name of the current program being written, only for AddProgram (mode 3).",
                        "Defaults to robot for api usage (mode 1 and 2)."
                    ]
                }
            }
        },
        "Kinova-Link6": {
            "N": "Kinova Link6",
            "F": "Kinova_Link6.py",
            "B": "Kinova",
            "EXT": ".json",
            "SC": [
                "Kinova"
            ],
            "D": [
                "The Kinova Link 6 post processor generates JSON (.json) code, compatible with Kinova Link 6 robotic arms."
            ],
            "VARS": {
                "MOVEL_FORCE_JOINT_TARGETS": {
                    "value": "False",
                    "comment": [
                        "Forces the use of joint values instead of cartesian coordinates for MoveL."
                    ]
                },
                "MOVEL_JOINT_TARGET_IGNORE_TOOL": {
                    "value": "False",
                    "comment": [
                        "Remove the tool pose for joint-based MoveL Kinematics."
                    ]
                }
            }
        },
        "KUKA-app4PostPro": {
            "N": "KUKA app4PostPro",
            "F": "KUKA_app4PostPro.py",
            "B": "KUKA",
            "EXT": ".csv",
            "SC": [
                "KUKA KR C4"
            ],
            "D": [
                "The KUKA app4PostPro post processor produces .csv files designed for KUKA KR C4 controllers with app4PostPro."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "csv",
                    "comment": [
                        "File extension: set the program extension."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use."
                    ]
                }
            }
        },
        "KUKA-CNC": {
            "N": "KUKA CNC",
            "F": "KUKA_CNC.py",
            "B": "KUKA",
            "EXT": ".nc",
            "SC": [
                "KUKA KR C4"
            ],
            "D": [
                "The KUKA CNC post processor produces .nc files designed for KUKA.CNC systems."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "nc",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "JOINT_DATA": {
                    "value": "['X', 'Y', 'Z', 'A', 'B', 'C', 'X1=', 'Y1=', 'Z1=']",
                    "comment": [
                        "Set the joint axis mappings."
                    ]
                }
            }
        },
        "KUKA-custom": {
            "N": "KUKA custom",
            "F": "KUKA_custom.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [],
            "D": [
                "The KUKA custom post processor allows generating .src files for KUKA robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "KUKA-EntertainTech": {
            "N": "KUKA EntertainTech",
            "F": "KUKA_EntertainTech.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [],
            "D": [
                "The KUKA EntertainTech post processor allows generating .src and .emily files for KUKA robotic controllers with Entertain Tech package."
            ]
        },
        "KUKA-IIWA": {
            "N": "KUKA IIWA",
            "F": "KUKA_IIWA.py",
            "B": "KUKA",
            "EXT": ".java",
            "SC": [
                "KUKA LBR"
            ],
            "D": [
                "The KUKA IIWA post processor generates Java code for KUKA iiwa robots."
            ],
            "VARS": {
                "MOVE_Spline": {
                    "value": "False",
                    "comment": [
                        "Generate Spline movements instead of LIN movements."
                    ]
                },
                "BLENDING_MM": {
                    "value": 1,
                    "comment": [
                        "Default blend radius for LIN movements."
                    ]
                }
            }
        },
        "KUKA-IIWA-Spline": {
            "N": "KUKA IIWA Spline",
            "F": "KUKA_IIWA_Spline.py",
            "B": "KUKA",
            "SC": [
                "KUKA LBR"
            ],
            "D": [
                "The KUKA IIWA Spline post processor generates Java code for KUKA iiwa robots.",
                "It generates spline movements by default."
            ],
            "VARS": {
                "MOVE_Spline": {
                    "value": "True",
                    "comment": [
                        "Generate Spline movements instead of LIN movements."
                    ]
                },
                "BLENDING_MM": {
                    "value": 1,
                    "comment": [
                        "Default blend radius for LIN movements."
                    ]
                }
            },
            "EXT": ".java"
        },
        "KUKA-KRC1-DAT": {
            "N": "KUKA KRC1 DAT",
            "F": "KUKA_KRC1_DAT.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C1"
            ],
            "D": [
                "The KUKA KRC1 DAT post processor produces .src and .dat files for KUKA KR C1 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "KUKA-KRC2": {
            "N": "KUKA KRC2",
            "F": "KUKA_KRC2.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2",
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C2 post processor allows you to generate code (.src) for KUKA KR C2 controllers and later.",
                "The KUKA KR C2 controller offers plug-and-play functionality, a low maintenance system and standard PC components to ensure maximum availability.",
                "This post processor does not output configuration flags and turn flags like the **KUKA_KRC2_Config** version of this post processor does.",
                "This post processor inlines the target coordinates inside the linear movements. You can use the **KUKA_KRC2_DAT** version instead to save the targets in a data file instead.",
                "This is the default post processor for KUKA robots because it supports most KUKA robot controllers (except for KUKA KR C1 controllers and the KUKA IIWA robots).",
                "You can configure this post processor to generate tool frames and reference frames linking to an index in your BASE_DATA and TOOL_DATA tables by setting the BASE_INDEX and TOOL_INDEX variables to True respectively.",
                "In this case, RoboDK will provide the ID of your references and tools to the controller. For example, a tool called \"Tool 2\" in RoboDK will generate a program with the tool as $TOOL = TOOL_DATA[2] instead of providing the tool coordinates.",
                "You can use the **KUKA_KRC4** post processor if your controller is a KUKA KR C4 or later."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "KRC_VERSION": {
                    "value": 2,
                    "comment": [
                        "For KRC2 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4.",
                        "KRC_VERSION = 4 \u2010 for KRC4 controllers."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use TOOL_DATA[3])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "LIN",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SLIN, SPL (use a Spline Block, ...",
                        "Tip: Add a comment such as start_spl, start_lin or start_slin to change the move command."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "False",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "True",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers.",
                        "CASCADED_CALLS = True.",
                        "CASCADED_CALLS = False."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "False",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header.",
                        "PROG_EXT_EXCLUDE = [\"tool_change\",\"spindle_start\",\"spindle_stop\"].",
                        "PROG_EXT_EXCLUDE = True \u2010 Never add EXT programs in the header.",
                        "PROG_EXT_EXCLUDE = False \u2010 Always add EXT programs."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "False",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 16,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis)."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "PRINT_E_ANOUT": {
                    "value": 5,
                    "comment": [
                        "Analog Output ID to command the extruder flow.",
                        "Parameters for 3D printing using a custom extruder.",
                        "3D Printing Extruder Setup Parameters."
                    ]
                },
                "PRINT_SPEED_2_SIGNAL": {
                    "value": 0.1,
                    "comment": [
                        "Ratio to convert the speed/flow to an analog output signal."
                    ]
                },
                "PRINT_FLOW_MAX_SIGNAL": {
                    "value": 24,
                    "comment": [
                        "Maximum signal to provide to the Extruder."
                    ]
                },
                "PRINT_ACCEL_MMSS": {
                    "value": -1,
                    "comment": [
                        "Acceleration, -1 assumes constant speed if we use rounding/blending."
                    ]
                },
                "HEADER": {
                    "value": "[...]",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = DEFAULT_HEADER + \"CallProgram();\\n\"."
                    ]
                }
            }
        },
        "KUKA-KRC2-CamRob": {
            "N": "KUKA KRC2 CamRob",
            "F": "KUKA_KRC2_CamRob.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2"
            ],
            "D": [
                "The KUKA KRC2 CamRob post processor generates .src files designed for KUKA CAMRob applications on KUKA KR C2 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension.",
                        "Set the program file extension."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": []
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "True",
                    "comment": [
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis).",
                        "EXTAXIS_EXTRUDER = True."
                    ]
                },
                "PRINT_E_NEW_MOTOR": {
                    "value": 0,
                    "comment": [
                        "External axis value to start controlling the Extruder."
                    ]
                }
            }
        },
        "KUKA-KRC2-CamRob-AvgSpeed": {
            "N": "KUKA KRC2 CamRob AvgSpeed",
            "F": "KUKA_KRC2_CamRob_AvgSpeed.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2"
            ],
            "D": [
                "The KUKA KRC2 CamRob AvgSpeed post processor generates .src files designed for KUKA CAMRob applications on KUKA KR C2 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "KUKA-KRC2-CamRob-SingleFile": {
            "N": "KUKA KRC2 CamRob SingleFile",
            "F": "KUKA_KRC2_CamRob_SingleFile.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2"
            ],
            "D": [
                "The KUKA KRC2 CamRob SingleFile post processor generates a single .src file designed for KUKA CAMRob applications on KUKA KR C2 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program file extension."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the main module.",
                        "Set to True to include sub programs in the same module."
                    ]
                },
                "MAX_SUBPROG_LINES": {
                    "value": 500,
                    "comment": [
                        "You can also specify the maximum lines of code allowed to include a subprogram in the main/first program.",
                        "If a subprogram exceeds this number of lines of code it will be generated as a separate module."
                    ]
                },
                "GENERATE_JOB_FILE": {
                    "value": "True",
                    "comment": [
                        "Generate a JOB file as a summary."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "True",
                    "comment": [
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis).",
                        "EXTAXIS_EXTRUDER = True."
                    ]
                },
                "PRINT_E_NEW_MOTOR": {
                    "value": 0,
                    "comment": [
                        "External axis value to start controlling the Extruder."
                    ]
                }
            }
        },
        "KUKA-KRC2-Config": {
            "N": "KUKA KRC2 Config",
            "F": "KUKA_KRC2_Config.py",
            "B": "KUKA",
            "SC": [
                "KUKA KR C2"
            ],
            "D": [
                "The KUKA KRC2 Config post processor allows you to generate .src files for KUKA KR C2 controllers and later. ",
                "This post processor adds configuration and turn bits to motion commands."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "KRC_VERSION": {
                    "value": 2,
                    "comment": [
                        "For KRC2 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4.",
                        "KRC_VERSION = 4 \u2010 for KRC4 controllers."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "FRAME_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use BASE_DATA[3])."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "LIN",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SPL, SLIN, ...",
                        "Tip: Add a comment such as usespl or useslin to change the move command."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "True",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers.",
                        "CASCADED_CALLS = True.",
                        "CASCADED_CALLS = False."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "True",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 16,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "True",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis).",
                        "EXTAXIS_EXTRUDER = False."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "PRINT_E_ANOUT": {
                    "value": 5,
                    "comment": [
                        "Analog Output ID to command the extruder flow.",
                        "Parameters for 3D printing using a custom extruder.",
                        "3D Printing Extruder Setup Parameters."
                    ]
                },
                "PRINT_SPEED_2_SIGNAL": {
                    "value": 0.1,
                    "comment": [
                        "Ratio to convert the speed/flow to an analog output signal."
                    ]
                },
                "PRINT_FLOW_MAX_SIGNAL": {
                    "value": 24,
                    "comment": [
                        "Maximum signal to provide to the Extruder."
                    ]
                },
                "PRINT_ACCEL_MMSS": {
                    "value": -1,
                    "comment": [
                        "Acceleration, -1 assumes constant speed if we use rounding/blending."
                    ]
                },
                "HEADER": {
                    "value": "[...]",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = MainPost.HEADER + \"CallProgram();\\n\"."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "False",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "False",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header.",
                        "PROG_EXT_EXCLUDE = [\"tool_change\",\"spindle_start\",\"spindle_stop\"].",
                        "PROG_EXT_EXCLUDE = True \u2010 Never add EXT programs in the header.",
                        "PROG_EXT_EXCLUDE = False \u2010 Always add EXT programs."
                    ]
                }
            },
            "EXT": ".src"
        },
        "KUKA-KRC2-DAT": {
            "N": "KUKA KRC2 DAT",
            "F": "KUKA_KRC2_DAT.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2"
            ],
            "D": [
                "The KUKA KRC2 DAT post processor produces .src and .dat files for KUKA KR C2 controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "KUKA-KRC2-DAT-Arc": {
            "N": "KUKA KRC2 DAT Arc",
            "F": "KUKA_KRC2_DAT_Arc.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2",
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C2 post processor allows you to generate .src and .dat files for KUKA KR C2 controllers and later.",
                "This post processor does output configuration flags and turn flags."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "KUKA-KRC2-DAT-Arc-A20": {
            "N": "KUKA KRC2 DAT Arc A20",
            "F": "KUKA_KRC2_DAT_Arc_A20.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2",
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C2 post processor allows you to generate .src and .dat files for KUKA KR C2 controllers and later.",
                "This post processor does output configuration flags and turn flags."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\"."
                    ]
                },
                "ARC_Pgno": {
                    "value": 12,
                    "comment": [
                        "Arc program number."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file."
                    ]
                }
            }
        },
        "KUKA-KRC4": {
            "N": "KUKA KRC4",
            "F": "KUKA_KRC4.py",
            "B": "KUKA",
            "SC": [
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C4 post processor allows you to generate code (.src) for KUKA KR C4 controllers.",
                "The KUKA KR C4 controller integrates robot control, PLC Control, motion control and safety control.",
                "You can easily configure the KRC Version variable to generate code for KRC 2 controllers only.",
                "This post processor inlines the target coordinates inside linear movements. ",
                "You can use the **KUKA_KRC4_DAT** post processor instead to save the targets in a data (DAT) file instead."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "KRC_VERSION": {
                    "value": 4,
                    "comment": [
                        "For KRC4 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4.",
                        "KRC_VERSION = 2 \u2010 for KRC2 controllers."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "FRAME_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use TOOL_DATA[3])."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "LIN",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SLIN, SPL (use a Spline Block, ...",
                        "Tip: Add a comment such as start_spl, start_lin or start_slin to change the move command."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "False",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "False",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers.",
                        "CASCADED_CALLS = True.",
                        "CASCADED_CALLS = False."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "True",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header.",
                        "PROG_EXT_EXCLUDE = [\"tool_change\",\"spindle_start\",\"spindle_stop\"].",
                        "PROG_EXT_EXCLUDE = True \u2010 Never add EXT programs in the header.",
                        "PROG_EXT_EXCLUDE = False \u2010 Always add EXT programs."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "False",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 16,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis).",
                        "EXTAXIS_EXTRUDER = True."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "PRINT_E_ANOUT": {
                    "value": 5,
                    "comment": [
                        "Analog Output ID to command the extruder flow.",
                        "Parameters for 3D printing using a custom extruder.",
                        "3D Printing Extruder Setup Parameters."
                    ]
                },
                "PRINT_SPEED_2_SIGNAL": {
                    "value": 0.1,
                    "comment": [
                        "Ratio to convert the speed/flow to an analog output signal."
                    ]
                },
                "PRINT_FLOW_MAX_SIGNAL": {
                    "value": 24,
                    "comment": [
                        "Maximum signal to provide to the Extruder."
                    ]
                },
                "PRINT_ACCEL_MMSS": {
                    "value": -1,
                    "comment": [
                        "Acceleration, -1 assumes constant speed if we use rounding/blending."
                    ]
                },
                "HEADER": {
                    "value": "[...]",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = MainPost.HEADER + \"CallProgram();\\n\"."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                }
            },
            "EXT": ".src"
        },
        "KUKA-KRC4-Config": {
            "N": "KUKA KRC4 Config",
            "F": "KUKA_KRC4_Config.py",
            "B": "KUKA",
            "SC": [
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C4 post processor allows you to generate .src and .dat for KUKA KR C4 controllers.",
                "This post processor adds configuration and turn bits to motion commands."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "KRC_VERSION": {
                    "value": 4,
                    "comment": [
                        "For KRC4 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4.",
                        "KRC_VERSION = 2 \u2010 for KRC2 controllers."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "FRAME_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use BASE_DATA[3])."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "LIN",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SPL, SLIN, ...",
                        "Tip: Add a comment such as usespl or useslin to change the move command."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "False",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers.",
                        "CASCADED_CALLS = True.",
                        "CASCADED_CALLS = False."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "True",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 16,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "True",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis).",
                        "EXTAXIS_EXTRUDER = False."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "PRINT_E_ANOUT": {
                    "value": 5,
                    "comment": [
                        "Analog Output ID to command the extruder flow.",
                        "Parameters for 3D printing using a custom extruder.",
                        "3D Printing Extruder Setup Parameters."
                    ]
                },
                "PRINT_SPEED_2_SIGNAL": {
                    "value": 0.1,
                    "comment": [
                        "Ratio to convert the speed/flow to an analog output signal."
                    ]
                },
                "PRINT_FLOW_MAX_SIGNAL": {
                    "value": 24,
                    "comment": [
                        "Maximum signal to provide to the Extruder."
                    ]
                },
                "PRINT_ACCEL_MMSS": {
                    "value": -1,
                    "comment": [
                        "Acceleration, -1 assumes constant speed if we use rounding/blending."
                    ]
                },
                "HEADER": {
                    "value": "[...]",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = MainPost.HEADER + \"CallProgram();\\n\"."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "False",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "False",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header.",
                        "PROG_EXT_EXCLUDE = [\"tool_change\",\"spindle_start\",\"spindle_stop\"].",
                        "PROG_EXT_EXCLUDE = True \u2010 Never add EXT programs in the header.",
                        "PROG_EXT_EXCLUDE = False \u2010 Always add EXT programs."
                    ]
                }
            },
            "EXT": ".src"
        },
        "KUKA-KRC4-DAT": {
            "N": "KUKA KRC4 DAT",
            "F": "KUKA_KRC4_DAT.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C4 post processor allows you to generate .src and .dat for KUKA KR C4 controllers.",
                "This post processor saves the targets in a data file (DAT)."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use TOOL_DATA[3])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                }
            }
        },
        "KUKA-KRC4-RSI": {
            "N": "KUKA KRC4 RSI",
            "F": "KUKA_KRC4_RSI.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2",
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C4 RSI post processor allows you to generate code (.src) for KUKA controllers integrated by Robotic Solutions.",
                "These controllers are customized for robot machining, they offer plug-and-play functionality, a low maintenance system and standard PC components to ensure maximum compatibility.",
                "This post processor does not output configuration flags and turn flags like the **KUKA_KRC2_Config** version of this post processor does.",
                "This post processor inlines the target coordinates inside the linear movements. You can use the **KUKA_KRC2_DAT** version instead to save the targets in a data file instead.",
                "This is the default post processor for KUKA robots because it supports most KUKA robot controllers (except for KUKA KR C1 controllers and the KUKA IIWA robots).",
                "You can configure this post processor to generate tool frames and reference frames linking to an index in your BASE_DATA and TOOL_DATA tables by setting the BASE_INDEX and TOOL_INDEX variables to True respectively.",
                "In this case, RoboDK will provide the ID of your references and tools to the controller. For example, a tool called \"Tool 2\" in RoboDK will generate a program with the tool as $TOOL = TOOL_DATA[2] instead of providing the tool coordinates.",
                "You can use the **KUKA_KRC4** post processor if your controller is a KUKA KR C4 or later."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 10000,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "KRC_VERSION": {
                    "value": 4,
                    "comment": [
                        "For KRC4 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use TOOL_DATA[3])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "LIN",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SLIN, SPL (use a Spline Block, ...",
                        "Tip: Add a comment such as start_spl, start_lin or start_slin to change the move command."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "False",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "False",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers.",
                        "CASCADED_CALLS = True.",
                        "CASCADED_CALLS = False."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "['SetTool', 'SetRPM']",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "False",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 24,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis)."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "RSI": {
                    "value": "True",
                    "comment": [
                        "RSI system."
                    ]
                },
                "RPM": {
                    "value": 12000,
                    "comment": []
                },
                "MAIN_NAME": {
                    "value": "",
                    "comment": []
                },
                "RSI_RECALC": {
                    "value": "True",
                    "comment": []
                },
                "TOOL_N": {
                    "value": 0,
                    "comment": []
                },
                "HEADER": {
                    "value": "",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = DEFAULT_HEADER + \"CallProgram();\\n\"."
                    ]
                },
                "PG_HEADER": {
                    "value": "&ACCESS RVP\n&REL 1\n&PARAM TEMPLATE = C:\\KRC\\Roboter\\Template\\vorgabe\n&PARAM EDITMASK = *",
                    "comment": []
                }
            }
        },
        "KUKA-KRC4-Slow": {
            "N": "KUKA KRC4 Slow",
            "F": "KUKA_KRC4_Slow.py",
            "B": "KUKA",
            "SC": [
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C4 Slow post processor allows you to generate code (.src) for KUKA KR C4 controllers."
            ],
            "VARS": {
                "KRC_VERSION": {
                    "value": 4,
                    "comment": [
                        "For KRC4 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4.",
                        "KRC_VERSION = 2 \u2010 for KRC2 controllers."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "False",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use TOOL_DATA[3])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "LIN",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SLIN, SPL (use a Spline Block, ...",
                        "Tip: Add a comment such as start_spl, start_lin or start_slin to change the move command."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "False",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "False",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header.",
                        "PROG_EXT_EXCLUDE = [\"tool_change\",\"spindle_start\",\"spindle_stop\"].",
                        "PROG_EXT_EXCLUDE = True \u2010 Never add EXT programs in the header.",
                        "PROG_EXT_EXCLUDE = False \u2010 Always add EXT programs."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "False",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 16,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis)."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "PRINT_E_ANOUT": {
                    "value": 5,
                    "comment": [
                        "Analog Output ID to command the extruder flow.",
                        "Parameters for 3D printing using a custom extruder.",
                        "3D Printing Extruder Setup Parameters."
                    ]
                },
                "PRINT_SPEED_2_SIGNAL": {
                    "value": 0.1,
                    "comment": [
                        "Ratio to convert the speed/flow to an analog output signal."
                    ]
                },
                "PRINT_FLOW_MAX_SIGNAL": {
                    "value": 24,
                    "comment": [
                        "Maximum signal to provide to the Extruder."
                    ]
                },
                "PRINT_ACCEL_MMSS": {
                    "value": -1,
                    "comment": [
                        "Acceleration, -1 assumes constant speed if we use rounding/blending."
                    ]
                },
                "HEADER": {
                    "value": "[...]",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = DEFAULT_HEADER + \"CallProgram();\\n\"."
                    ]
                }
            },
            "EXT": ".src"
        },
        "KUKA-KRC4-Spline": {
            "N": "KUKA KRC4 Spline",
            "F": "KUKA_KRC4_Spline.py",
            "B": "KUKA",
            "SC": [
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C4 post processor allows you to generate code (.src) for KUKA KR C4 controllers. ",
                "You can easily configure the KRC Version variable to generate code for KRC 2 controllers only.",
                "This post processor uses Spline movements (SPL) and inlines the target coordinates inside the linear movements. ",
                "You can use the KUKA KR C4 DAT version instead to save the targets in a data file instead."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "KRC_VERSION": {
                    "value": 4,
                    "comment": [
                        "For KRC4 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4.",
                        "KRC_VERSION = 2 \u2010 for KRC2 controllers."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "FRAME_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use TOOL_DATA[3])."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "SPL",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SLIN, SPL (use a Spline Block, ...",
                        "Tip: Add a comment such as start_spl, start_lin or start_slin to change the move command."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "True",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "False",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers.",
                        "CASCADED_CALLS = True.",
                        "CASCADED_CALLS = False."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "False",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 16,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "True",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis).",
                        "EXTAXIS_EXTRUDER = False."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "PRINT_E_ANOUT": {
                    "value": 5,
                    "comment": [
                        "Analog Output ID to command the extruder flow.",
                        "Parameters for 3D printing using a custom extruder.",
                        "3D Printing Extruder Setup Parameters."
                    ]
                },
                "PRINT_SPEED_2_SIGNAL": {
                    "value": 0.1,
                    "comment": [
                        "Ratio to convert the speed/flow to an analog output signal."
                    ]
                },
                "PRINT_FLOW_MAX_SIGNAL": {
                    "value": 24,
                    "comment": [
                        "Maximum signal to provide to the Extruder."
                    ]
                },
                "PRINT_ACCEL_MMSS": {
                    "value": -1,
                    "comment": [
                        "Acceleration, -1 assumes constant speed if we use rounding/blending."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "False",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header.",
                        "PROG_EXT_EXCLUDE = [\"tool_change\",\"spindle_start\",\"spindle_stop\"].",
                        "PROG_EXT_EXCLUDE = True \u2010 Never add EXT programs in the header.",
                        "PROG_EXT_EXCLUDE = False \u2010 Always add EXT programs."
                    ]
                },
                "HEADER": {
                    "value": "[...]",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = DEFAULT_HEADER + \"CallProgram();\\n\"."
                    ]
                }
            },
            "EXT": ".src"
        },
        "KUKA-KRC5": {
            "N": "KUKA KRC5",
            "F": "KUKA_KRC5.py",
            "B": "KUKA",
            "SC": [
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KR C5 post processor allows you to generate code (.src) for KUKA KR C4 and KUKA KR C5 controllers.",
                "This post processors generates almost the same output as the KUKA KR C4.",
                "You can easily configure the KRC Version variable to generate code for KRC 2 controllers only.",
                "This post processor inlines the target coordinates inside the linear movements. ",
                "You can use the KUKA KR C4 DAT version instead to save the targets in a data file instead."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2500,
                    "comment": [
                        "Maximum number of lines per program. It will then generate multiple \"pages (files)\" if the program is too long.",
                        "This is the default value. You can change this value in RoboDK.",
                        "Tools-Options-Program-Limit the maximum number of lines per program."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Set to True to include subprograms in the same file.",
                        "Set to True to include subprograms in the main program. Otherwise, programs can be generated separately."
                    ]
                },
                "SUB_PROGRAMS_AS_FILES": {
                    "value": "True",
                    "comment": [
                        "Generate subprograms as new files instead of adding them in the same file (INCLUDE_SUB_PROGRAMS must be set to True)."
                    ]
                },
                "KRC_VERSION": {
                    "value": 5,
                    "comment": [
                        "For KRC4 controllers.",
                        "Set KRC Version (2 or 4).",
                        "Version 2 for KRC2 controllers or Version 4 for KRC4.",
                        "KRC_VERSION = 2 \u2010 for KRC2 controllers."
                    ]
                },
                "SKIP_MESSAGE_POPUPS": {
                    "value": "False",
                    "comment": [
                        "Display messages on the teach pendant. This feature is not supported by all controllers and must be disabled for some controllers.",
                        "SKIP_MESSAGE_POPUPS = True."
                    ]
                },
                "FRAME_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "TOOL_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Tool index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your tool to \"Tool 3\" to use TOOL_DATA[3])."
                    ]
                },
                "LIN_KEYWORD": {
                    "value": "LIN",
                    "comment": [
                        "Define the move linear keyword (usually LIN).",
                        "Other examples: SLIN, SPL (use a Spline Block, ...",
                        "Tip: Add a comment such as start_spl, start_lin or start_slin to change the move command."
                    ]
                },
                "SPLINE_BLOCK": {
                    "value": "False",
                    "comment": [
                        "Use SPLINE block (SPL movements). You can change this flag or change the LIN KEYWORD to SPL."
                    ]
                },
                "CASCADED_CALLS": {
                    "value": "False",
                    "comment": [
                        "Set if we want to have cascaded program calls when program splitting takes place.",
                        "Usually, cascaded is better for older controllers.",
                        "CASCADED_CALLS = True.",
                        "CASCADED_CALLS = False."
                    ]
                },
                "PROG_EXT_EXCLUDE": {
                    "value": "True",
                    "comment": [
                        "Enter program names to exclude from EXT definition in each program header.",
                        "PROG_EXT_EXCLUDE = [\"tool_change\",\"spindle_start\",\"spindle_stop\"].",
                        "PROG_EXT_EXCLUDE = True \u2010 Never add EXT programs in the header.",
                        "PROG_EXT_EXCLUDE = False \u2010 Always add EXT programs."
                    ]
                },
                "ADD_CONFIG_TURN": {
                    "value": "False",
                    "comment": [
                        "Optionally output configuration and turn flags S and T.",
                        "If we set this to true, the output targets will have the configuration and turn bits added in the movement.",
                        "(for example: S B'010', T B'000001')."
                    ]
                },
                "SKIP_PROG_KEYWORD": {
                    "value": "",
                    "comment": [
                        "Add a keyword to split subprograms.",
                        "SKIP_PROG_KEYWORD = 'spindle'."
                    ]
                },
                "AXES_DATA": {
                    "value": "['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6']",
                    "comment": [
                        "Set the name/order of default axes and external axes."
                    ]
                },
                "PROG_NAME_LEN": {
                    "value": 16,
                    "comment": [
                        "Program name max length (KRC4 is 24 characters)."
                    ]
                },
                "EXTAXIS_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Parameters for 3D printing.",
                        "Use a synchronized external axis as an extruder (E1, E2, ... or the last available axis)."
                    ]
                },
                "WELD_EXTRUDER": {
                    "value": "False",
                    "comment": [
                        "Use a weld gun as an extruder.",
                        "WELD_EXTRUDER = True."
                    ]
                },
                "PRINT_E_ANOUT": {
                    "value": 5,
                    "comment": [
                        "Analog Output ID to command the extruder flow.",
                        "Parameters for 3D printing using a custom extruder.",
                        "3D Printing Extruder Setup Parameters."
                    ]
                },
                "PRINT_SPEED_2_SIGNAL": {
                    "value": 0.1,
                    "comment": [
                        "Ratio to convert the speed/flow to an analog output signal."
                    ]
                },
                "PRINT_FLOW_MAX_SIGNAL": {
                    "value": 24,
                    "comment": [
                        "Maximum signal to provide to the Extruder."
                    ]
                },
                "PRINT_ACCEL_MMSS": {
                    "value": -1,
                    "comment": [
                        "Acceleration, -1 assumes constant speed if we use rounding/blending."
                    ]
                },
                "HEADER": {
                    "value": "[...]",
                    "comment": [
                        "Set or change the main header here.",
                        "Example: HEADER = MainPost.HEADER + \"CallProgram();\\n\"."
                    ]
                },
                "BASE_INDEX": {
                    "value": "False",
                    "comment": [
                        "Use the Frame index instead of the pose when the index is provided.",
                        "Example: Set to True and rename your reference to \"Frame 2\" to use BASE_DATA[2])."
                    ]
                },
                "DEFAULT_BASE_ID": {
                    "value": 1,
                    "comment": [
                        "Default BASE ID to use when the base index is not specified in the reference name and BASE_INDEX is set to True."
                    ]
                },
                "DEFAULT_TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default TOOL ID to use when the tool index is not specified in the reference name and TOOL_INDEX is set to True."
                    ]
                }
            },
            "EXT": ".src"
        },
        "KUKA-KRC-ARCTECH": {
            "N": "KUKA KRC ARCTECH",
            "F": "KUKA_KRC_ARCTECH.py",
            "B": "KUKA",
            "EXT": ".src",
            "SC": [
                "KUKA KR C2",
                "KUKA KR C4",
                "KUKA KR C5"
            ],
            "D": [
                "The KUKA KRC ARCTECH post processor produces .src and .dat files for KUKA KRC controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "src",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "ARCTECH": {
                    "value": 0,
                    "comment": [
                        "Set the ArcTech output type (0,1,2)."
                    ]
                },
                "USE_3AX_POS": {
                    "value": "False",
                    "comment": [
                        "Output for 3-axis positioner depending on the side."
                    ]
                },
                "side": {
                    "value": 0,
                    "comment": [
                        "Default side (1 or 2)."
                    ]
                },
                "STATIC_AX_NAME": {
                    "value": "e1",
                    "comment": [
                        "Static axis name."
                    ]
                },
                "SIDE_1_AX_NAME": {
                    "value": "e2",
                    "comment": [
                        "Side_1 axis name."
                    ]
                },
                "SIDE_2_AX_NAME": {
                    "value": "e3",
                    "comment": [
                        "Side_2 axis name."
                    ]
                },
                "STATIC_AX_S1_VAL": {
                    "value": -90.0,
                    "comment": [
                        "Static axis value for side 1."
                    ]
                },
                "STATIC_AX_S2_VAL": {
                    "value": 90.0,
                    "comment": [
                        "Static axis value for side 2."
                    ]
                }
            }
        },
        "Ligent": {
            "N": "Ligent",
            "F": "Ligent.py",
            "B": "Ligent",
            "EXT": ".JBR",
            "SC": [
                "Ligent (Inexbot v1.0.6)"
            ],
            "D": [
                "The Ligent post processor generates .JBR files specifically designed for Ligent (Inexbot) controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "Set the default maximum number of lines per program.",
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "MAX_NAME_CHARS": {
                    "value": 7,
                    "comment": [
                        "Set the maximum number of characters allowed for program names."
                    ]
                },
                "USE_SETTOOL": {
                    "value": "False",
                    "comment": [
                        "Set to True to use SETTOOL for setting the tool in the JBI program.",
                        "USE_SETTOOL = True \u2010 This requires the SETTOOL option from Motoman (paid option)."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 9,
                    "comment": [
                        "Specify the default UTool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use UTOOL number 2)."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "USE_MFRAME": {
                    "value": "True",
                    "comment": [
                        "Set to True to use global reference frame."
                    ]
                },
                "USE_JOINTS": {
                    "value": "True",
                    "comment": [
                        "Output joint values."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 7,
                    "comment": [
                        "Specify the default UFrame Id to use (register).",
                        "You can also use Numbered References in RoboDK (for example, a reference named \"Reference 4\" will use UFRAME number 4)."
                    ]
                },
                "PROVERSION": {
                    "value": "1.0.6",
                    "comment": [
                        "Controller version."
                    ]
                },
                "EXT": {
                    "value": "False",
                    "comment": [
                        "Ext movement options."
                    ]
                },
                "SYNC": {
                    "value": "True",
                    "comment": []
                }
            }
        },
        "MABI": {
            "N": "MABI",
            "F": "MABI.py",
            "B": "MABI Robotic",
            "EXT": ".mpf",
            "SC": [
                "Siemens SINUMERIK"
            ],
            "D": [
                "The MABI post processor produces .mpf files that are compatible with Siemens Sinumerik controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "mpf",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "MM_2_UNITS": {
                    "value": 1.0,
                    "comment": [
                        "Units (1 to use MM).",
                        "MM_2_UNITS = 1.0/25.4 \u2010 Use Inch units."
                    ]
                },
                "M_WAIT_DI": {
                    "value": "M66",
                    "comment": [
                        "Provide the M code to wait for a digital input."
                    ]
                },
                "M_SET_DO_HIGH": {
                    "value": "M62",
                    "comment": [
                        "Provide the M code to set a digital output HIGH (1 or True)."
                    ]
                },
                "M_SET_DO_LOW": {
                    "value": "M63",
                    "comment": [
                        "Provide the M code to set a digital output LOW (0 or False)."
                    ]
                },
                "JOINTS_MAP": {
                    "value": "['RA1', 'RA2', 'RA3', 'RA4', 'RA5', 'RA6', 'G', 'H', 'I', 'J', 'K', 'L']",
                    "comment": [
                        "Joint mappings from axis 1 to axis N."
                    ]
                },
                "CUSTOM_SETUP_COMAU": {
                    "value": "False",
                    "comment": [
                        "Sample special TCP setup with a custom Comau robot arm."
                    ]
                }
            }
        },
        "MARS": {
            "N": "MARS",
            "F": "MARS.py",
            "EXT": ".gpl",
            "SC": [],
            "D": [
                "The MARS post processor produces .gpl files for MARS systems."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "gpl",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Mecademic": {
            "N": "Mecademic",
            "F": "Mecademic.py",
            "B": "Mecademic",
            "EXT": ".txt",
            "SC": [],
            "D": [
                "The Mecademic post processor produces .txt files for Mecademic's web interface.",
                "It can also upload programs directly on to the Mecademic robot controller."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the output program extension."
                    ]
                },
                "IS_MECA_R2": {
                    "value": "",
                    "comment": [
                        "Set to true for older Mecademic robots. Leave to None to automatically determine if required."
                    ]
                },
                "USE_MOVE_POSE": {
                    "value": "False",
                    "comment": [
                        "Set true to use MovePose instead of MoveJoints."
                    ]
                }
            }
        },
        "Mecademic-Python": {
            "N": "Mecademic Python",
            "F": "Mecademic_Python.py",
            "B": "Mecademic",
            "EXT": ".py",
            "SC": [],
            "D": [
                "The Mecademic Python post processor produces Python files for Mecademic robots."
            ],
            "VARS": {
                "ROBOT_IP": {
                    "value": "192.168.0.100",
                    "comment": [
                        "Robot IP."
                    ]
                },
                "ROBOT_PORT": {
                    "value": 10000,
                    "comment": [
                        "Robot port."
                    ]
                },
                "IS_MECA_R2": {
                    "value": "",
                    "comment": [
                        "Set to true for older Mecademic robots. Leave to None to automatically determine if required."
                    ]
                },
                "USE_MOVE_POSE": {
                    "value": "False",
                    "comment": [
                        "Set true to use MovePose instead of MoveJoints."
                    ]
                }
            }
        },
        "Mitsubishi": {
            "N": "Mitsubishi",
            "F": "Mitsubishi.py",
            "B": "Mitsubishi",
            "EXT": ".prg",
            "SC": [
                "Mitsubishi MELFA CR-Q",
                "Mitsubishi MELFA CR-R",
                "Mitsubishi MELFA CR-D"
            ],
            "D": [
                "The Mitsubishi post processor allows you to generate .prg files for Mitsubishi MELFA CR controllers.",
                "Up to 2 external axes are supported.",
                "Spline and ExT spline functions are implemented.",
                "The use of 'spline_on' or 'espline_on' in the insert code instruction defines the beginning of the spline knots sequence, which will be converted to a spline on the controller side and executed by the MvSpl or EMvSpl instruction, respectively.",
                "The insert code instruction containing the keyword 'spline_off' defines the end of the spline node sequence."
            ],
            "VARS": {
                "DOUT_STRING": {
                    "value": "M_OUT",
                    "comment": [
                        "Default Digital Output module (usually OUT or M_OUT)."
                    ]
                },
                "AOUT_STRING": {
                    "value": "OUT",
                    "comment": [
                        "Default Analog Output module (usually OUT or M_OUT)."
                    ]
                },
                "FLAG_CONFIG": {
                    "value": "",
                    "comment": [
                        "Set the default configuration flag (7,0).",
                        "FLAG_CONFIG = '6' \u2010 Set to 6 to use front/elbow up/non flip.",
                        "FLAG_CONFIG = '7' \u2010 Set to 7 to use front/elbow up/flip.",
                        "FLAG_CONFIG = '' \u2010 Set an empty string to leave it unset.",
                        "Set to None to let RoboDK calculate it automatically."
                    ]
                },
                "FLAG_TURNS": {
                    "value": "",
                    "comment": [
                        "Set the default turn flag (7,0).",
                        "FLAG_TURNS = '0' \u2010 Closest to 0.",
                        "Set to None to let RoboDK calculate it automatically."
                    ]
                },
                "USE_FRAMES_INV": {
                    "value": "True",
                    "comment": [
                        "Inverse frames."
                    ]
                },
                "EXTAXES_USE_API": {
                    "value": "False",
                    "comment": [
                        "Use the API to calculate poses (old method)."
                    ]
                },
                "POS_VAR": {
                    "value": "True",
                    "comment": [
                        "Use position variables."
                    ]
                },
                "USE_SPLINES": {
                    "value": "False",
                    "comment": [
                        "Allow splines generation.",
                        "Spline_on (espline_on) - begining of the spline.",
                        "Spline_off - enf of spline.",
                        "Io - digital signal operations during the spline movement.",
                        "Eg.: io,103,16,FF,17."
                    ]
                }
            }
        },
        "Mitsubishi-Movemaster-EX": {
            "N": "Mitsubishi Movemaster EX",
            "F": "Mitsubishi_Movemaster_EX.py",
            "B": "Mitsubishi",
            "EXT": ".prg",
            "SC": [
                "Mitsubishi MOVEMASTER EX"
            ],
            "D": [
                "The Mitsubishi Movemaster EX post processor allows you to generate .prg files for Mitsubishi MOVEMASTER EX controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "prg",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Motoman": {
            "N": "Motoman",
            "F": "Motoman.py",
            "B": "Yaskawa Motoman",
            "EXT": ".JBI",
            "SC": [
                "Yaskawa Motoman YRC1000",
                "Yaskawa Motoman YRC1000micro",
                "Yaskawa Motoman FS100",
                "Yaskawa Motoman DX100",
                "Yaskawa Motoman DX200",
                "Yaskawa Motoman XRC"
            ],
            "D": [
                "The Motoman post processor can generate programs (.JBI) for any Motoman robot controller that supports the Motoman Inform II and Inform III programming language.",
                "You can configure the USE_SETTOOL, USE_MFRAME and USE_RELATIVE_JOB to enable or disable using paid controller options.",
                "This post generates all targets in pulses."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "Set the default maximum number of lines per program.",
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "MAX_NAME_CHARS": {
                    "value": 7,
                    "comment": [
                        "Set the maximum number of characters allowed for program names."
                    ]
                },
                "USE_SETTOOL": {
                    "value": "False",
                    "comment": [
                        "Set to True to use SETTOOL for setting the tool in the JBI program.",
                        "USE_SETTOOL = True \u2010 This requires the SETTOOL option from Motoman (paid option)."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 9,
                    "comment": [
                        "Specify the default UTool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use UTOOL number 2)."
                    ]
                },
                "SPEED_CM_MIN": {
                    "value": "False",
                    "comment": [
                        "Set the linear speed in CM/MIN instead of MM/S.",
                        "Some Motoman controllers require the speed in CM/S."
                    ]
                },
                "USE_RELATIVE_JOB": {
                    "value": "False",
                    "comment": [
                        "Use Cartesian values when available, otherwise, use pulse values.",
                        "Set to False to always use pulses (otherwise, it may require a paid option on the controller).",
                        "USE_RELATIVE_JOB = True \u2010 This requires the Relative Job option from Motoman."
                    ]
                },
                "AVOID_RJ_FLAG": {
                    "value": "False",
                    "comment": [
                        "Avoid outputting the RJ flag. The RJ flag may require an option on some controllers."
                    ]
                },
                "MOVEJ_IN_CARTESIAN": {
                    "value": "False",
                    "comment": [
                        "Force joint movements to be in Cartesian."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Specify a spare Position register for calculations (Tool, Reference, ...)."
                    ]
                },
                "USE_MFRAME": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MFRAME for setting reference frames automatically within the program."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 9,
                    "comment": [
                        "Specify the default UFrame Id to use (register).",
                        "You can also use Numbered References in RoboDK (for example, a reference named \"Reference 4\" will use UFRAME number 4)."
                    ]
                },
                "EXTAXES_USE_MOVJ": {
                    "value": "True",
                    "comment": [
                        "Will output: MOVL C00008 V=166.7  +MOVJ EC00008 VJ=100.00.",
                        "Specify if external axes must be moved according to a separate MOVJ command.",
                        "EXTAXES_USE_MOVJ = False \u2010 Will output: MOVL C00008 EC00008 V=166.7."
                    ]
                },
                "EXTAXES_USE_SMOVL": {
                    "value": "False",
                    "comment": [
                        "Specify if we want synchronized motion for Linear moves.",
                        "If True (default): Will output: SMOVL C00008 BC00008 V=166.7 +MOVJ EC00008 -> Synchronized motion (for the turntable).",
                        "If False : Will output: MOVL C00008 BC00008 V=166.7 +MOVJ EC00008 VJ=100.00 -> Non synchronized motion (for the turntable)."
                    ]
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1, 1.0, 1.0, 1, 1]",
                    "comment": [
                        "Specify the pulses/degree ratio for the external axes here (index 7,8,...)."
                    ]
                },
                "AXIS_INDEX": {
                    "value": "[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]",
                    "comment": [
                        "Table is already swaped (final ids).",
                        "Option to swap a specific axis.",
                        "AXIS_INDEX = [0,1,2,3,4,5,6,7] \u2010 example to swap axes 7 and 8 (external axes 1-2)."
                    ]
                }
            }
        },
        "Motoman-Cartesian": {
            "N": "Motoman Cartesian",
            "F": "Motoman_Cartesian.py",
            "B": "Yaskawa Motoman",
            "SC": [
                "Yaskawa Motoman YRC1000",
                "Yaskawa Motoman YRC1000micro",
                "Yaskawa Motoman FS100",
                "Yaskawa Motoman DX100",
                "Yaskawa Motoman DX200",
                "Yaskawa Motoman XRC"
            ],
            "D": [
                "The Motoman post processor can generate programs (.JBI) for any Motoman robot controller that supports the Motoman Inform II and Inform III programming language.",
                "You can configure the USE_SETTOOL, USE_MFRAME and USE_RELATIVE_JOB to enable or disable using paid controller options.",
                "This post generates linear targets in Cartesian coordinates."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "Set the default maximum number of lines per program.",
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "USE_SETTOOL": {
                    "value": "True",
                    "comment": [
                        "This requires the SETTOOL option from Motoman (paid option).",
                        "Set to True to use SETTOOL for setting the tool in the JBI program.",
                        "USE_SETTOOL = False."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 9,
                    "comment": [
                        "Specify the default UTool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use UTOOL number 2)."
                    ]
                },
                "USE_RELATIVE_JOB": {
                    "value": "True",
                    "comment": [
                        "This requires the Relative Job option from Motoman.",
                        "Use Cartesian values when available, otherwise, use pulse values.",
                        "Set to False to always use pulses (otherwise, it may require a paid option on the controller).",
                        "USE_RELATIVE_JOB = False."
                    ]
                },
                "AVOID_RJ_FLAG": {
                    "value": "False",
                    "comment": [
                        "Avoid outputting the RJ flag. The RJ flag may require an option on some controllers."
                    ]
                },
                "MOVEJ_IN_CARTESIAN": {
                    "value": "False",
                    "comment": [
                        "Force joint movements to be in Cartesian."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Specify a spare Position register for calculations (Tool, Reference, ...)."
                    ]
                },
                "USE_MFRAME": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MFRAME for setting reference frames automatically within the program."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 9,
                    "comment": [
                        "Specify the default UFrame Id to use (register).",
                        "You can also use Numbered References in RoboDK (for example, a reference named \"Reference 4\" will use UFRAME number 4)."
                    ]
                },
                "EXTAXES_USE_EC": {
                    "value": "True",
                    "comment": [
                        "Specify if external axes are defined as a separate variable unit.",
                        "(use EC instead of extending the default C register)."
                    ]
                },
                "EXTAXES_USE_MOVJ": {
                    "value": "True",
                    "comment": [
                        "Will output: MOVL C00008 V=166.7  +MOVJ EC00008 VJ=100.00.",
                        "Specify if external axes must be moved according to a separate MOVJ command."
                    ]
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1, 1.0, 1.0, 1, 1]",
                    "comment": [
                        "Specify the pulses/degree ratio for the external axes here (index 7,8,...)."
                    ]
                },
                "AXIS_INDEX": {
                    "value": "[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]",
                    "comment": [
                        "Table is already swaped (final ids).",
                        "Option to swap a specific axis.",
                        "AXIS_INDEX = [0,1,2,3,4,5,6,7] \u2010 example to swap axes 7 and 8 (external axes 1-2)."
                    ]
                },
                "MAX_NAME_CHARS": {
                    "value": 7,
                    "comment": [
                        "Set the maximum number of characters allowed for program names."
                    ]
                },
                "SPEED_CM_MIN": {
                    "value": "False",
                    "comment": [
                        "Set the linear speed in CM/MIN instead of MM/S.",
                        "Some Motoman controllers require the speed in CM/S."
                    ]
                },
                "EXTAXES_USE_SMOVL": {
                    "value": "False",
                    "comment": [
                        "Specify if we want synchronized motion for Linear moves.",
                        "If True (default): Will output: SMOVL C00008 BC00008 V=166.7 +MOVJ EC00008 -> Synchronized motion (for the turntable).",
                        "If False : Will output: MOVL C00008 BC00008 V=166.7 +MOVJ EC00008 VJ=100.00 -> Non synchronized motion (for the turntable)."
                    ]
                }
            },
            "EXT": ".JBI"
        },
        "Motoman-CartesianOnly": {
            "N": "Motoman CartesianOnly",
            "F": "Motoman_CartesianOnly.py",
            "B": "Yaskawa Motoman",
            "SC": [
                "Yaskawa Motoman YRC1000",
                "Yaskawa Motoman YRC1000micro",
                "Yaskawa Motoman FS100",
                "Yaskawa Motoman DX100",
                "Yaskawa Motoman DX200",
                "Yaskawa Motoman XRC"
            ],
            "D": [
                "The Motoman post processor can generate programs (.JBI) for any Motoman robot controller that supports the Motoman Inform II and Inform III programming language.",
                "You can configure the USE_SETTOOL, USE_MFRAME and USE_RELATIVE_JOB to enable or disable using paid controller options.",
                "This post generates all targets in Cartesian coordinates."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "Set the default maximum number of lines per program.",
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "MAX_NAME_CHARS": {
                    "value": 7,
                    "comment": [
                        "Set the maximum number of characters allowed for program names."
                    ]
                },
                "USE_SETTOOL": {
                    "value": "True",
                    "comment": [
                        "This requires the SETTOOL option from Motoman (paid option).",
                        "Set to True to use SETTOOL for setting the tool in the JBI program.",
                        "USE_SETTOOL = False."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 9,
                    "comment": [
                        "Specify the default UTool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use UTOOL number 2)."
                    ]
                },
                "USE_RELATIVE_JOB": {
                    "value": "True",
                    "comment": [
                        "This requires the Relative Job option from Motoman.",
                        "Use Cartesian values when available, otherwise, use pulse values.",
                        "Set to False to always use pulses (otherwise, it may require a paid option on the controller).",
                        "USE_RELATIVE_JOB = False."
                    ]
                },
                "AVOID_RJ_FLAG": {
                    "value": "False",
                    "comment": [
                        "Avoid outputting the RJ flag. The RJ flag may require an option on some controllers."
                    ]
                },
                "MOVEJ_IN_CARTESIAN": {
                    "value": "True",
                    "comment": [
                        "Force joint movements to be in Cartesian."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Specify a spare Position register for calculations (Tool, Reference, ...)."
                    ]
                },
                "USE_MFRAME": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MFRAME for setting reference frames automatically within the program."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 9,
                    "comment": [
                        "Specify the default UFrame Id to use (register).",
                        "You can also use Numbered References in RoboDK (for example, a reference named \"Reference 4\" will use UFRAME number 4)."
                    ]
                },
                "EXTAXES_USE_EC": {
                    "value": "True",
                    "comment": [
                        "Specify if external axes are defined as a separate variable unit.",
                        "(use EC instead of extending the default C register)."
                    ]
                },
                "EXTAXES_USE_MOVJ": {
                    "value": "True",
                    "comment": [
                        "Will output: MOVL C00008 V=166.7  +MOVJ EC00008 VJ=100.00.",
                        "Specify if external axes must be moved according to a separate MOVJ command.",
                        "EXTAXES_USE_MOVJ = False \u2010 Will output: MOVL C00008 EC00008 V=166.7."
                    ]
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1, 1.0, 1.0, 1, 1]",
                    "comment": [
                        "Specify the pulses/degree ratio for the external axes here (index 7,8,...)."
                    ]
                },
                "AXIS_INDEX": {
                    "value": "[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]",
                    "comment": [
                        "Table is already swaped (final ids).",
                        "Option to swap a specific axis.",
                        "AXIS_INDEX = [0,1,2,3,4,5,6,7] \u2010 example to swap axes 7 and 8 (external axes 1-2)."
                    ]
                },
                "SPEED_CM_MIN": {
                    "value": "False",
                    "comment": [
                        "Set the linear speed in CM/MIN instead of MM/S.",
                        "Some Motoman controllers require the speed in CM/S."
                    ]
                },
                "EXTAXES_USE_SMOVL": {
                    "value": "False",
                    "comment": [
                        "Specify if we want synchronized motion for Linear moves.",
                        "If True (default): Will output: SMOVL C00008 BC00008 V=166.7 +MOVJ EC00008 -> Synchronized motion (for the turntable).",
                        "If False : Will output: MOVL C00008 BC00008 V=166.7 +MOVJ EC00008 VJ=100.00 -> Non synchronized motion (for the turntable)."
                    ]
                }
            },
            "EXT": ".JBI"
        },
        "MyCobot": {
            "N": "MyCobot",
            "F": "MyCobot.py",
            "B": "MyCobot",
            "EXT": ".py",
            "SC": [],
            "D": [
                "The MyCobot post processor generates Python code compatible with MyCobot robotic arms."
            ],
            "VARS": {
                "POST_CODEGEN_MODE": {
                    "value": 1,
                    "comment": [
                        "Code generation mode.",
                        "1 = simulate.",
                        "2 = Online Programming (run on robot).",
                        "3 = Macro generation (RDK.AddProgram)."
                    ]
                },
                "MAIN_PROGRAM_NAME": {
                    "value": "",
                    "comment": [
                        "Name of the main function, obtained from first instance of ProgStart being called."
                    ]
                },
                "CURRENT_PROGRAM_NAME": {
                    "value": "robot",
                    "comment": [
                        "Name of the current program being written, only for AddProgram (mode 3).",
                        "Defaults to robot for api usage (mode 1 and 2)."
                    ]
                }
            }
        },
        "Nachi-AX-FD": {
            "N": "Nachi AX FD",
            "F": "Nachi_AX_FD.py",
            "B": "Nachi",
            "EXT": ".001",
            "SC": [
                "Nachi FD",
                "Nachi AX"
            ],
            "D": [
                "The Nachi AX FD post processor produces code compatible with Nachi FD and AX controllers."
            ],
            "VARS": {
                "BASE_PROGNAME": {
                    "value": "",
                    "comment": [
                        "'MZ07L-01-A'."
                    ]
                },
                "PROG_ID": {
                    "value": 5,
                    "comment": [
                        "Default Program ID (ID to store the program)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 95000,
                    "comment": [
                        "Default maximum number of lines per program."
                    ]
                },
                "EXTAXIS_UNIT": {
                    "value": "M2J",
                    "comment": [
                        "Name of the external axis unit (M2J or M3J).",
                        "Tip: You can name a coordinate system with the M2J or M3J keyword to automatically swap the unit."
                    ]
                },
                "PROG_EXT": {
                    "value": "001",
                    "comment": [
                        "Program extensions are just numbers, like 001 for program ID 1."
                    ]
                },
                "TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default id for the tool (H=TOOL_ID)."
                    ]
                },
                "FRAME_ID": {
                    "value": 0,
                    "comment": [
                        "Default id for the reference (H=TOOL_ID)."
                    ]
                }
            }
        },
        "Neura": {
            "N": "Neura",
            "F": "Neura.py",
            "B": "Neura",
            "EXT": ".py",
            "SC": [
                "Neura Real-Time NR-Motion Master"
            ],
            "D": [
                "The Neura post processor generates a NeuraPy Python script compatible with the Neura Robotics Real-Time NR-Motion Master controller."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "py",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 2000.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": "False",
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                }
            }
        },
        "NEWKer-i6": {
            "N": "NEWKer i6",
            "F": "NEWKer_i6.py",
            "B": "NEWKer",
            "EXT": ".txt",
            "SC": [
                "NEWKer i6"
            ],
            "D": [
                "The NEWKer post processor generates code designed for NEWKer i6 CNC controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the output program extension."
                    ]
                },
                "MAX_LINE_LENGTH": {
                    "value": 500,
                    "comment": [
                        "Maximum length of a line of code, in characters."
                    ]
                }
            }
        },
        "NEWKer-i6-MOV": {
            "N": "NEWKer i6 MOV",
            "F": "NEWKer_i6_MOV.py",
            "B": "NEWKer",
            "EXT": ".txt",
            "SC": [
                "NEWKer i6"
            ],
            "D": [
                "The NEWKer post processor generates code for NEWKer i6 CNC controllers. This post processors uses MOVJ and MOVL commands instead of the default G-code G00 and G01 commands."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the output program extension."
                    ]
                },
                "MAX_LINE_LENGTH": {
                    "value": 500,
                    "comment": [
                        "Maximum length of a line of code, in characters."
                    ]
                },
                "tool_nm": {
                    "value": "T1",
                    "comment": [
                        "Default tool."
                    ]
                },
                "ref_nm": {
                    "value": "G53",
                    "comment": [
                        "Default reference frame."
                    ]
                },
                "simplified_movel": {
                    "value": "False",
                    "comment": [
                        "Short notation for MoveL."
                    ]
                },
                "abs_crd": {
                    "value": "True",
                    "comment": [
                        "Always use machine coordinate system."
                    ]
                },
                "VJ": {
                    "value": 10,
                    "comment": [
                        "Default joint speed (deg/s)."
                    ]
                },
                "V": {
                    "value": 10,
                    "comment": [
                        "Default linear speed (mm/s)."
                    ]
                },
                "PL": {
                    "value": 1.0,
                    "comment": [
                        "Default smoothing factor (mm)."
                    ]
                }
            }
        },
        "Niryo": {
            "N": "Niryo",
            "F": "Niryo.py",
            "B": "Niryo",
            "EXT": ".py",
            "SC": [],
            "D": [
                "The Niryo post processor generates Python code designed for Niryo educational robots."
            ],
            "VARS": {
                "POST_CODEGEN_MODE": {
                    "value": 1,
                    "comment": [
                        "Code generation mode.",
                        "1 = simulate.",
                        "2 = Online Programming (run on robot).",
                        "3 = Macro generation (RDK.AddProgram)."
                    ]
                },
                "MAIN_PROGRAM_NAME": {
                    "value": "",
                    "comment": [
                        "Name of the main function, obtained from first instance of ProgStart being called."
                    ]
                },
                "CURRENT_PROGRAM_NAME": {
                    "value": "robot",
                    "comment": [
                        "Name of the current program being written, only for AddProgram (mode 3).",
                        "Defaults to robot for api usage (mode 1 and 2)."
                    ]
                }
            }
        },
        "Omron": {
            "N": "Omron",
            "F": "Omron.py",
            "B": "Omron",
            "EXT": ".flow",
            "SC": [],
            "D": [
                "The Omron post processor generates TMFlow (.flow) code compatible with Omron robotic controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000.",
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "SHOW_PROGRAM_ZIP": {
                    "value": "True",
                    "comment": [
                        "Show zip file on program generation."
                    ]
                },
                "SHOW_PROGRAM_TXT": {
                    "value": "True",
                    "comment": [
                        "Show text file on program generation."
                    ]
                },
                "SKIP_COMMENTS": {
                    "value": "False",
                    "comment": [
                        "Set to True to skip comments."
                    ]
                },
                "INCLUDE_SUBPROGS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the same program."
                    ]
                },
                "USE_ROBOT_BASE": {
                    "value": "False",
                    "comment": [
                        "Use the robot base or a reference frame."
                    ]
                },
                "USE_TARGET_OFFSETS": {
                    "value": "False",
                    "comment": [
                        "Use targets as offsets."
                    ]
                },
                "VERTICAL_INS": {
                    "value": 8,
                    "comment": [
                        "Number of instructions to stack vertically before creating a new column."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 185,
                    "comment": [
                        "Set the maximum speed in DEG/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 1200,
                    "comment": [
                        "Set the maximum speed in MM/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "PSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Point Speed Percentage (PSPercentage)."
                    ]
                },
                "PSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Point Speed Time To Top Speed (PSTTTS)."
                    ]
                },
                "COMPUTE_JOINT_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute joint acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "PSTTTSOF": {
                    "value": "ON",
                    "comment": [
                        "Enable Point Speed Time To Top Speed (PSTTTSOF)."
                    ]
                },
                "LINE_ABS": {
                    "value": "ON",
                    "comment": [
                        "Set default LineABS."
                    ]
                },
                "LSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Linear Speed Percentage (LSPercentage)."
                    ]
                },
                "LSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default Linear Speed A Velocity (LSAVelocity)."
                    ]
                },
                "LSTTTS": {
                    "value": 300,
                    "comment": [
                        "Set default Linear Speed Time To Top Speed (LSTTTS)."
                    ]
                },
                "OBJECT_PAYLOAD": {
                    "value": 2,
                    "comment": [
                        "Set default payload for the robot movements."
                    ]
                },
                "REMOTE_TCP_SPEED": {
                    "value": "False",
                    "comment": [
                        "Set to True to adjust speeds for a remote TCP setup."
                    ]
                },
                "COMPUTE_LINEAR_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute linear acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "ROUNDING_MM": {
                    "value": 1,
                    "comment": [
                        "Set default rounding (radius in mm), set to -1 for accurate movements (point to point)."
                    ]
                },
                "USE_RADIUS_BLENDING": {
                    "value": "False",
                    "comment": [
                        "Set default blending mode for linear and circular movement (False = Pourcentage True = Radius)."
                    ]
                },
                "INIT_MESSAGE": {
                    "value": "",
                    "comment": [
                        "Flag to include all init messages in one Display Node."
                    ]
                },
                "SET_PASSWORD": {
                    "value": "robodk1234",
                    "comment": [
                        "Set the default password (5 chars minimum).",
                        "Warning: if set to None, the password will match the program name (filled with numbers to reach a minimum of 8 characters).",
                        "Warning: if the password is changed, TMFlow may not accept it and ask for a new password."
                    ]
                },
                "ASK_PASSWORD": {
                    "value": "False",
                    "comment": [
                        "Set to true to ask the user for a password."
                    ]
                },
                "ZIP_TYPE": {
                    "value": 1,
                    "comment": [
                        "Set to 0 to not save a ZIP file.",
                        "Set to 1 to save a zip file using TMExportZip.",
                        "Set to 2 to save a zip file without using TMExportZip.",
                        "ZIP_TYPE = 0."
                    ]
                }
            }
        },
        "Omron-Adept-Vplus": {
            "N": "Omron Adept Vplus",
            "F": "Omron_Adept_Vplus.py",
            "B": "Omron",
            "EXT": ".vb1",
            "SC": [
                "Adept V+",
                "Omron Sysmac NJ",
                "Omron eCobra",
                "Omron SmartController EX"
            ],
            "D": [
                "The Adept Vplus post processor is dedicated to generating code in the V+ language for Adept controllers.",
                "The output code is formatted as a .vb1 file.",
                "Omron acquired Adept in 2015."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "vb1",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "OMRON": {
                    "value": "True",
                    "comment": [
                        "If Omron controller is used."
                    ]
                }
            }
        },
        "Omron-FerRobotics": {
            "N": "Omron FerRobotics",
            "F": "Omron_FerRobotics.py",
            "B": "Omron",
            "EXT": ".flow",
            "SC": [],
            "D": [
                "The Omron FerRobotics post processor generates TMFlow (.flow) code compatible with Omron robotic controllers.",
                "This post processor adds support for TM robots equipped with FerRobotics tools."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000.",
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "SHOW_PROGRAM_ZIP": {
                    "value": "True",
                    "comment": [
                        "Show zip file on program generation."
                    ]
                },
                "SHOW_PROGRAM_TXT": {
                    "value": "True",
                    "comment": [
                        "Show text file on program generation."
                    ]
                },
                "SKIP_COMMENTS": {
                    "value": "False",
                    "comment": [
                        "Set to True to skip comments."
                    ]
                },
                "INCLUDE_SUBPROGS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the same program."
                    ]
                },
                "USE_ROBOT_BASE": {
                    "value": "False",
                    "comment": [
                        "Use the robot base or a reference frame."
                    ]
                },
                "USE_TARGET_OFFSETS": {
                    "value": "False",
                    "comment": [
                        "Use targets as offsets."
                    ]
                },
                "VERTICAL_INS": {
                    "value": 8,
                    "comment": [
                        "Number of instructions to stack vertically before creating a new column."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 185,
                    "comment": [
                        "Set the maximum speed in DEG/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 1200,
                    "comment": [
                        "Set the maximum speed in MM/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "PSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Point Speed Percentage (PSPercentage)."
                    ]
                },
                "PSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Point Speed Time To Top Speed (PSTTTS)."
                    ]
                },
                "COMPUTE_JOINT_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute joint acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "PSTTTSOF": {
                    "value": "ON",
                    "comment": [
                        "Enable Point Speed Time To Top Speed (PSTTTSOF)."
                    ]
                },
                "LINE_ABS": {
                    "value": "ON",
                    "comment": [
                        "Set default LineABS."
                    ]
                },
                "LSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Linear Speed Percentage (LSPercentage)."
                    ]
                },
                "LSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default Linear Speed A Velocity (LSAVelocity)."
                    ]
                },
                "LSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Linear Speed Time To Top Speed (LSTTTS)."
                    ]
                },
                "COMPUTE_LINEAR_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute linear acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "ROUNDING_MM": {
                    "value": 1,
                    "comment": [
                        "Set default rounding (radius in mm), set to -1 for accurate movements (point to point)."
                    ]
                },
                "USE_RADIUS_BLENDING": {
                    "value": "False",
                    "comment": [
                        "Set default blending mode for linear and circular movement (False = Pourcentage True = Radius)."
                    ]
                },
                "INIT_MESSAGE": {
                    "value": "",
                    "comment": [
                        "Flag to includ all init messages in one Display Node."
                    ]
                },
                "SET_PASSWORD": {
                    "value": "robodk1234",
                    "comment": [
                        "Set the default password (5 chars minimum).",
                        "Warning: if set to None, the password will match the program name (filled with numbers to reach a minimum of 8 characters).",
                        "Warning: if the password is changed, TMFlow may not accept it and ask for a new password."
                    ]
                },
                "ASK_PASSWORD": {
                    "value": "False",
                    "comment": [
                        "Set to true to ask the user for a password."
                    ]
                },
                "ZIP_TYPE": {
                    "value": 1,
                    "comment": [
                        "Set to 0 to not save a ZIP file.",
                        "Set to 1 to save a zip file using TMExportZip.",
                        "Set to 2 to save a zip file without using TMExportZip.",
                        "ZIP_TYPE = 0."
                    ]
                },
                "PATH_TMExportZip": {
                    "value": "os.path.realpath(os.path.join(os.path.dirname(os.path.realpath(__file__)), \"../Other/TMExportZip/TMExportZip.exe\"))",
                    "comment": [
                        "Path to TMExportZip to automatically ZIP files (needed if ZIP_Type = 1)."
                    ]
                },
                "IP_FER_Robotics": {
                    "value": "",
                    "comment": [
                        "FER Robotics IP Address (need to be made user accessible later)."
                    ]
                }
            }
        },
        "Omron-PathNode": {
            "N": "Omron PathNode",
            "F": "Omron_PathNode.py",
            "B": "Omron",
            "EXT": ".flow",
            "SC": [],
            "D": [
                "The Omron PathNode post processor generates TMFlow (.flow) code compatible with Omron robotic controllers.",
                "This post processor adds support for path nodes."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000.",
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "SHOW_PROGRAM_ZIP": {
                    "value": "True",
                    "comment": [
                        "Show zip file on program generation."
                    ]
                },
                "SHOW_PROGRAM_TXT": {
                    "value": "False",
                    "comment": [
                        "Show text file on program generation."
                    ]
                },
                "SKIP_COMMENTS": {
                    "value": "False",
                    "comment": [
                        "Set to True to skip comments."
                    ]
                },
                "INCLUDE_SUBPROGS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the same program."
                    ]
                },
                "USE_ROBOT_BASE": {
                    "value": "False",
                    "comment": [
                        "Use the robot base or a reference frame."
                    ]
                },
                "USE_TARGET_OFFSETS": {
                    "value": "False",
                    "comment": [
                        "Use targets as offsets."
                    ]
                },
                "VERTICAL_INS": {
                    "value": 8,
                    "comment": [
                        "Number of instructions to stack vertically before creating a new column."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 185,
                    "comment": [
                        "Set the maximum speed in DEG/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 1200,
                    "comment": [
                        "Set the maximum speed in MM/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "LINE_ABS": {
                    "value": "ON",
                    "comment": [
                        "Set default LineABS."
                    ]
                },
                "LSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default Linear Speed A Velocity (LSAVelocity)."
                    ]
                },
                "LSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Linear Speed Time To Top Speed (LSTTTS)."
                    ]
                },
                "COMPUTE_LINEAR_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute linear acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "PLSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default PLinear Speed A Velocity (PLSAVelocity)."
                    ]
                },
                "PLSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default PLinear Speed Time To Top Speed (PLSTTTS)."
                    ]
                },
                "LSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Linear Speed Percentage (LSPercentage)."
                    ]
                },
                "PSTTTSOF": {
                    "value": "ON",
                    "comment": [
                        "Enable Point Speed Time To Top Speed (PSTTTSOF)."
                    ]
                },
                "PSTTTS": {
                    "value": 250,
                    "comment": [
                        "Set default Point Speed Time To Top Speed (PSTTTS)."
                    ]
                },
                "PSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Point Speed Percentage (PSPercentage)."
                    ]
                },
                "COMPUTE_JOINT_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute joint acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "ROB_CONFIG": {
                    "value": "0,2,4",
                    "comment": [
                        "Set default robot configuration (Config)."
                    ]
                },
                "ROUNDING_MM": {
                    "value": 1,
                    "comment": [
                        "Set default rounding (radius in mm), set to -1 for accurate movements (point to point)."
                    ]
                },
                "USE_RADIUS_BLENDING": {
                    "value": "False",
                    "comment": [
                        "Set default blending mode for linear and circular movement (False = Pourcentage True = Radius)."
                    ]
                },
                "USE_PATH_NODE": {
                    "value": "False",
                    "comment": [
                        "Set generated program as a .path file."
                    ]
                },
                "PATH_NODE_NAME": {
                    "value": "RoboDKPath",
                    "comment": [
                        "Set the name of the default .path file."
                    ]
                },
                "USE_PATH_PLINE": {
                    "value": "True",
                    "comment": [
                        "Set .path node motion type to PLine (recommanded state: True)."
                    ]
                },
                "SET_PASSWORD": {
                    "value": "robodk1234",
                    "comment": [
                        "Set the default password (5 chars minimum).",
                        "Warning: if set to None, the password will match the program name (filled with numbers to reach a minimum of 8 characters).",
                        "Warning: if the password is changed, TMFlow may not accept it and ask for a new password."
                    ]
                },
                "ASK_PASSWORD": {
                    "value": "False",
                    "comment": [
                        "Set to true to ask the user for a password."
                    ]
                },
                "TOOL_MASS": {
                    "value": "0",
                    "comment": [
                        "Tool data."
                    ]
                },
                "ZIP_TYPE": {
                    "value": 1,
                    "comment": [
                        "Set to 0 to not save a ZIP file.",
                        "Set to 1 to save a zip file using TMExportZip.",
                        "Set to 2 to save a zip file without using TMExportZip.",
                        "ZIP_TYPE = 0."
                    ]
                }
            }
        },
        "Omron-Remote": {
            "N": "Omron Remote",
            "F": "Omron_Remote.py",
            "B": "Omron",
            "SC": [],
            "D": [
                "The Omron Remote post processor generates a Python script compatible with Omron robotic controllers."
            ],
            "VARS": {
                "USE_MOVEP": {
                    "value": "False",
                    "comment": []
                },
                "ROBOT_IP": {
                    "value": "192.168.1.100",
                    "comment": [
                        "Robot IP (should be provided by RoboDK when the program is generated)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "250    # Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "SPEED_MMS": {
                    "value": 50,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_PERCENT": {
                    "value": 10,
                    "comment": [
                        "Default speed for joint moves in percentage."
                    ]
                },
                "SPEED_DEGS": {
                    "value": 30,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "ACCEL_MMSS": {
                    "value": 100,
                    "comment": [
                        "Default acceleration for lineaer moves in mm/ss."
                    ]
                },
                "ACCEL_DEGSS": {
                    "value": 200,
                    "comment": [
                        "Default acceleration for joint moves in deg/ss."
                    ]
                },
                "ROUNDING": {
                    "value": 1,
                    "comment": [
                        "Default blend radius as a percentage."
                    ]
                },
                "TAB_CHAR": {
                    "value": "",
                    "comment": []
                }
            },
            "EXT": ".script"
        },
        "OTC": {
            "N": "OTC",
            "F": "OTC.py",
            "B": "OTC Daihen",
            "EXT": ".001",
            "SC": [
                "OTC Daihen FD"
            ],
            "D": [
                "The OTC post processor produces code compatible with OTC Daihen FD controllers."
            ],
            "VARS": {
                "BASE_PROGNAME": {
                    "value": "",
                    "comment": [
                        "'MZ07L-01-A'."
                    ]
                },
                "PROG_ID": {
                    "value": 5,
                    "comment": [
                        "Default Program ID (ID to store the program)."
                    ]
                },
                "TOOL_ID": {
                    "value": 1,
                    "comment": [
                        "Default id for the tool (H=TOOL_ID)."
                    ]
                },
                "FRAME_ID": {
                    "value": 0,
                    "comment": [
                        "Default id for the reference (H=TOOL_ID)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 95000,
                    "comment": [
                        "Default maximum number of lines per program."
                    ]
                },
                "EXTAXIS_UNIT": {
                    "value": "M2J",
                    "comment": [
                        "Name of the external axis unit (M2J or M3J).",
                        "Tip: You can name a coordinate system with the M2J or M3J keyword to automatically swap the unit."
                    ]
                },
                "PROG_EXT": {
                    "value": "001",
                    "comment": [
                        "Program extensions are just numbers, like 001 for program ID 1."
                    ]
                }
            }
        },
        "Panasonic-G3-CSR": {
            "N": "Panasonic G3 CSR",
            "F": "Panasonic_G3_CSR.py",
            "B": "Panasonic",
            "EXT": ".csr",
            "SC": [
                "Panasonic G3"
            ],
            "D": [
                "The Panasonic G3 CSR post processor generates .csr files for Panasonic G3 controllers."
            ],
            "VARS": {
                "ACTIVE_TOOL": {
                    "value": 1,
                    "comment": [
                        "Set default active UTool Id (register)."
                    ]
                },
                "STR_V": {
                    "value": "15.00, m/min",
                    "comment": [
                        "Set default cartesian speed."
                    ]
                },
                "STR_VJ": {
                    "value": "50.00, %%",
                    "comment": [
                        "Set default joints speed."
                    ]
                },
                "STR_PL": {
                    "value": "",
                    "comment": [
                        "Rounding value."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 2000,
                    "comment": [
                        "Set default maximum number of lines per program. It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "PROG_EXT": {
                    "value": "csr",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs."
                    ]
                },
                "STR_CNT": {
                    "value": "",
                    "comment": [
                        "Rounding value (from 0 to 4) (in RoboDK, set to 100 mm rounding for PL=4."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 0,
                    "comment": [
                        "Active UFrame Id (register)."
                    ]
                },
                "TL_NAME": {
                    "value": "TOOL01",
                    "comment": []
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Spare Position register for calculations."
                    ]
                },
                "REGISTER_DIGITS": {
                    "value": 5,
                    "comment": []
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1]",
                    "comment": [
                        "Pulses per degree (provide these in the robot parameters menu: Double click the motoman robot in RoboDK, select \"Parameters\"."
                    ]
                }
            }
        },
        "Post-Generic": {
            "N": "Post Generic",
            "F": "Post_Generic.py",
            "EXT": ".cnc",
            "SC": [],
            "D": [
                "The Post Generic post processor produces generic .cnc files that can be used across a variety of CNC and robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "cnc",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Precise": {
            "N": "Precise",
            "F": "Precise.py",
            "B": "Brooks",
            "EXT": ".gpl",
            "SC": [
                "Brooks PreciseFlex"
            ],
            "D": [
                "The Precise post processor allows you to generate code (.gpl) for the Brooks PreciseFlex Collaborative Robots controllers.",
                "The generated code is a GPL (Guidance Programming Language) project folder that can be uploaded to the controller of the robots and launched using the Web Interface of Brooks PreciseFlex cobots.",
                "This post processor also supports the Brooks PreciseFlex grippers and linear rails."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "gpl",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 500,
                    "comment": [
                        "Maximum speed in mm/s (used to convert to percentage of nominal speed).",
                        "Typically 500 for PF400/PF3400 and 600 for DD4/DD6."
                    ]
                },
                "MAX_ACCEL_MMSS": {
                    "value": 2000,
                    "comment": [
                        "Maximum acceleration in mm/s^2 (used to convert to percentage of nominal acceleration).",
                        "Typically 2000 for PF400/PF3400, 5000 for DD4/DD6 and 1000 for PF100."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 720,
                    "comment": [
                        "Maximum speed in deg/s (used to convert to percentage of nominal speed).",
                        "Typically 720 for PF400/PF3400, 600 for DD4/DD6 and 1500 for PF100."
                    ]
                },
                "MAX_ACCEL_DEGSS": {
                    "value": 4000,
                    "comment": [
                        "Maximum acceleration in deg/s^2 (used to convert to percentage of nominal acceleration).",
                        "Typically 4000 for PF400, 2000 for PF3400, 5000 for DD4/DD6 and 10000 for PF100."
                    ]
                }
            }
        },
        "QJAR": {
            "N": "QJAR",
            "F": "QJAR.py",
            "B": "QJAR",
            "EXT": ".rbg",
            "SC": [
                "QJAR"
            ],
            "D": [
                "The QJAR post processor generates .rbg files for QJAR robot controllers."
            ],
            "VARS": {
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 2000.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "EXTAXES_RATIO": {
                    "value": "[1, 1, 1]",
                    "comment": [
                        "Enter the external axes ratio, if required (RoboDK indexes). For example, if you use a linear rail (RoboDK=1mm, Controller=1mm) and 1-axis positioner (RoboDK=10 degrees, Controller=100 pulses, inverted), use.",
                        "EXTAXES_RATIO = [1, -10]."
                    ]
                },
                "EXTAXES_IDX": {
                    "value": "[0, 1, 2]",
                    "comment": [
                        "Enter the external axes indexes. For example, if you use a linear rail (RoboDK=7th, Controller=9th) and a 1-axis positioner (RoboDK=8th, Controller=8th), use.",
                        "EXTAXES_IDX = [2, 1]."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                }
            }
        },
        "RainbowRobotics": {
            "N": "RainbowRobotics",
            "F": "RainbowRobotics.py",
            "B": "Rainbow Robotics",
            "EXT": ".wsl",
            "SC": [],
            "D": [
                "The RainbowRobotics post processor produces .wsl files for Rainbow Robotics controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "wsl",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "RoboDK-CNC": {
            "N": "RoboDK CNC",
            "F": "RoboDK_CNC.py",
            "B": "RoboDK",
            "EXT": ".csv",
            "SC": [],
            "D": [
                "The CSV post processor generates simple CSV-formatted files for generic robotic and automation controllers.",
                "This post processor is versatile and can be used in applications requiring straightforward data import and export."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "csv",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "RoboDK-Python-API": {
            "N": "RoboDK Python API",
            "F": "RoboDK_Python_API.py",
            "B": "RoboDK",
            "EXT": ".py",
            "SC": [],
            "D": [
                "The RoboDK Python API post processor produces RoboDK Python API files, for robot agnostic offline programming."
            ],
            "VARS": {
                "POST_CODEGEN_MODE": {
                    "value": 3,
                    "comment": [
                        "Code generation mode.",
                        "1 = simulate.",
                        "2 = Online Programming (run on robot).",
                        "3 = Macro generation (RDK.AddProgram)."
                    ]
                },
                "MAIN_PROGRAM_NAME": {
                    "value": "",
                    "comment": [
                        "Name of the main function, obtained from first instance of ProgStart being called."
                    ]
                }
            }
        },
        "RoboDK-Quine": {
            "N": "RoboDK Quine",
            "F": "RoboDK_Quine.py",
            "B": "RoboDK",
            "EXT": ".py",
            "SC": [],
            "D": [
                "The RoboDK Quine post processors outputs the intermediary (generic) code to be parsed by the post processor.",
                "This code is usually found in %TEMP%."
            ]
        },
        "Robostar": {
            "N": "Robostar",
            "F": "Robostar.py",
            "B": "Robostar",
            "EXT": ".JOB",
            "SC": [],
            "D": [
                "The Robostar post processor generates .JOB files that are compatible with Robostar robotic controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1900,
                    "comment": [
                        "Set the default maximum number of lines per program.",
                        "It will then generate multiple \"pages (files)\". This can be overriden by RoboDK settings."
                    ]
                },
                "MAX_PNT_X_PROG": {
                    "value": 1000,
                    "comment": [
                        "Set the default maximum number of points per program.",
                        "It will then generate multiple \"pages (files)\" (this setting will not be overriden by RoboDK).",
                        "Default is 1000."
                    ]
                },
                "ACTIVE_TOOL": {
                    "value": 0,
                    "comment": [
                        "Specify the default Tool Id to use (register).",
                        "You can also use Numbered tools in RoboDK (for example, a tool named \"Tool 2\" will use TOOL number 2)."
                    ]
                },
                "ACTIVE_FRAME": {
                    "value": 0,
                    "comment": [
                        "Default active reference frame (base assumed).",
                        "You can also use Numbered frames in RoboDK (for example, a reference named \"Frame 3\" will use BASE number 3)."
                    ]
                },
                "ARM_ID": {
                    "value": 0,
                    "comment": [
                        "Robot Arm ID."
                    ]
                },
                "FORCE_JOINT_OUTPUT": {
                    "value": "False",
                    "comment": [
                        "XPOS or UPOS.",
                        "Set to True to always use joint output.",
                        "FORCE_JOINT_OUTPUT = True \u2010 POS."
                    ]
                },
                "CALC_BASE_TARGETS": {
                    "value": "False",
                    "comment": [
                        "UPOS.",
                        "Output Cartesian targets with respect to the reference frame or with respect to a coordinate system.",
                        "Important: this is only valid if FORCE_JOINT_OUTPUT == False.",
                        "CALC_BASE_TARGETS = True \u2010 XPOS."
                    ]
                },
                "MOVEJ_IN_CARTESIAN": {
                    "value": "False",
                    "comment": [
                        "Force joint movements to be in Cartesian."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "True",
                    "comment": [
                        "Generate sub programs with each program."
                    ]
                },
                "CONFIG_SHOULDER": {
                    "value": "",
                    "comment": [
                        "Provided by RoboDK.",
                        "Configuration behavior for Shoulder."
                    ]
                },
                "CONFIG_ELBOW": {
                    "value": "",
                    "comment": [
                        "Provided by RoboDK.",
                        "Configuration behavior for Elbow."
                    ]
                },
                "CONFIG_WRIST": {
                    "value": "",
                    "comment": [
                        "Provided by RoboDK.",
                        "Configuration behavior for Shoulder."
                    ]
                },
                "CONFIG_JOINTS": {
                    "value": "000",
                    "comment": [
                        "Default configuration for joint moves (should not be required)."
                    ]
                },
                "SPARE_PR": {
                    "value": 95,
                    "comment": [
                        "Specify a spare Position register for calculations (Tool, Reference, ...)."
                    ]
                },
                "PULSES_X_DEG": {
                    "value": "[1, 1, 1, 1, 1, 1, 1.0, 1.0, 1, 1]",
                    "comment": [
                        "Specify the pulses/degree ratio for the external axes here (index 7,8,...)."
                    ]
                },
                "AXIS_INDEX": {
                    "value": "[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]",
                    "comment": [
                        "Table is already swaped (final ids).",
                        "Option to swap a specific axis."
                    ]
                }
            }
        },
        "Rokae": {
            "N": "Rokae",
            "F": "Rokae.py",
            "B": "Rokae",
            "EXT": ".mod",
            "SC": [],
            "D": [
                "The Rokae post processor produces .mod files for ROKAE robot controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "mod",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Rozum-RC-API": {
            "N": "Rozum RC API",
            "F": "Rozum_RC_API.py",
            "B": "Rozum",
            "SC": [
                "Rozum RC Series"
            ],
            "D": [
                "The Rozum RC Series (API) post processor produces Python files (.py) designed for Rozum RC Series controllers."
            ]
        },
        "Rozum-RC-Pulse": {
            "N": "Rozum RC Pulse",
            "F": "Rozum_RC_Pulse.py",
            "B": "Rozum",
            "SC": [
                "Rozum RC Series"
            ],
            "D": [
                "The Rozum RC Series (Pulse) post processor produces .rcp files designed for Rozum RC Series controllers."
            ]
        },
        "RSI": {
            "N": "RSI",
            "F": "RSI.py",
            "B": "RSI",
            "EXT": ".txt",
            "SC": [],
            "D": [
                "The RSI post processor outputs .txt files compatible with RSI (Robotic Systems Integration) robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "SPEED_MMS": {
                    "value": 0.3,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_DEGS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MMSS": {
                    "value": 3,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_DEGSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_MM": {
                    "value": 0.001,
                    "comment": [
                        "Default smooth radius in mm (corners smoothing)."
                    ]
                }
            }
        },
        "Schneider-Electric": {
            "N": "Schneider Electric",
            "F": "Schneider_Electric.py",
            "B": "Schneider Electric",
            "EXT": ".jks",
            "SC": [
                "LXMRL03C1000",
                "LXMRL07C1000",
                "LXMRL12C1000",
                "LXMRL00C2000"
            ],
            "D": [
                "The Schneider Electric Lexium post processor generates allows you to generate code for Schneider Electric Lexium controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "Default maximum number of lines per program. If a program exceeds this value it will then generate multiple \"pages\" (files).",
                        "This value can also be set in Tools-Options-Program-Maximum number of lines per program."
                    ]
                },
                "PROG_EXT": {
                    "value": "jks",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "PROG_EXT_ZU": {
                    "value": "zu",
                    "comment": [
                        "Set the Zu file extension."
                    ]
                },
                "PROG_EXT_ZUS": {
                    "value": "zus",
                    "comment": [
                        "Set the Zus (sub programs) file extension."
                    ]
                },
                "SPEED_MMS": {
                    "value": 250,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "SPEED_DEGS": {
                    "value": 60,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "ACCEL_MMSS": {
                    "value": 250,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "ACCEL_DEGSS": {
                    "value": 200,
                    "comment": [
                        "Default acceleration for joint moves in deg/s^2."
                    ]
                },
                "BLEND_RADIUS_MM": {
                    "value": 1.0,
                    "comment": [
                        "Default blend radius in millimeters (corners smoothing)."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "NEW_CONTROLLER_VERSION": {
                    "value": "True",
                    "comment": [
                        "Version toggle."
                    ]
                }
            }
        },
        "Siasun": {
            "N": "Siasun",
            "F": "Siasun.py",
            "B": "Siasun",
            "EXT": ".spf",
            "SC": [
                "Siasun SNRC4"
            ],
            "D": [
                "The Siasun post processor generates .spf files tailored for Siasun robot controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "spf",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": []
                }
            }
        },
        "Siasun-DUCO": {
            "N": "Siasun DUCO",
            "F": "Siasun_DUCO.py",
            "B": "Siasun",
            "EXT": ".script",
            "SC": [
                "GCR DUCO"
            ],
            "D": [
                "The Siasun post processor generates .script files tailored for Siasun DUCO GCR robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 0.5,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 0.2,
                    "comment": [
                        "Default acceleration for linear moves in m/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 1.5,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 1.5,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                },
                "DEFAULT_MAX_LINES_X_PROG": {
                    "value": "",
                    "comment": [
                        "Default maximum number of lines per file. If this number is exceeded, the program is splitted in different files.",
                        "This setting can be overridden in RoboDK (Tools-Options-Program).",
                        "A value <=0 or None will discard this limit."
                    ]
                },
                "SAVE_SUBPROGRAMS_SEPARATELY": {
                    "value": "False",
                    "comment": [
                        "Set to True to create one additional file per subprogram, False to bundle everything in one file."
                    ]
                }
            }
        },
        "Siasun-JOBTXT": {
            "N": "Siasun JOBTXT",
            "F": "Siasun_JOBTXT.py",
            "B": "Siasun",
            "EXT": ".txt",
            "SC": [],
            "D": [
                "The Siasun post processor generates .txt files tailored for Siasun controllers accepting JOB programs.",
                "Note that job_to_txt.exe (Siasun tool) converts .txt to .job and vice versa"
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 9999,
                    "comment": [
                        "Maximum number of lines per program."
                    ]
                },
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "INCLUDE_SUB_PROGRAMS": {
                    "value": "False",
                    "comment": [
                        "Include subprograms."
                    ]
                }
            }
        },
        "Siemens-840D-PKM": {
            "N": "Siemens 840D PKM",
            "F": "Siemens_840D_PKM.py",
            "B": "Siemens",
            "EXT": ".mpf",
            "SC": [
                "Siemens SINUMERIK"
            ],
            "D": [
                "The Siemens 840D PKM post processor produces .mpf files that are compatible with Siemens 840D PKM."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "mpf",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Siemens-Simatic": {
            "N": "Siemens Simatic",
            "F": "Siemens_Simatic.py",
            "B": "Siemens",
            "EXT": ".csv",
            "SC": [
                "Siemens SIMATIC"
            ],
            "D": [
                "The Siemens SIMATIC post processor produces .csv files designed for Siemens SIMATIC S7 controllers with Kinematics Integrator."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "csv",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 500.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 2000.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": -1,
                    "comment": [
                        "Default speed for joint moves in %. -1 means controller's default."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": -1,
                    "comment": [
                        "Default acceleration for joint moves in %. -1 means controller's default."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in mm."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                },
                "MAX_LABEL_CHARS": {
                    "value": 30,
                    "comment": [
                        "Maximum number of characters for labels. Default is 30."
                    ]
                }
            }
        },
        "Siemens-Sinumerik": {
            "N": "Siemens Sinumerik",
            "F": "Siemens_Sinumerik.py",
            "B": "Siemens",
            "EXT": ".mpf",
            "SC": [
                "Siemens SINUMERIK"
            ],
            "D": [
                "The Siemens Sinumerik post processor produces .mpf files that are compatible with Siemens Sinumerik programming language."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "mpf",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "MM_2_UNITS": {
                    "value": 1.0,
                    "comment": [
                        "Units (1 to use MM).",
                        "MM_2_UNITS = 1.0/25.4 \u2010 Use Inch units."
                    ]
                },
                "M_WAIT_DI": {
                    "value": "M66",
                    "comment": [
                        "Provide the M code to wait for a digital input."
                    ]
                },
                "M_SET_DO_HIGH": {
                    "value": "M62",
                    "comment": [
                        "Provide the M code to set a digital output HIGH (1 or True)."
                    ]
                },
                "M_SET_DO_LOW": {
                    "value": "M63",
                    "comment": [
                        "Provide the M code to set a digital output LOW (0 or False)."
                    ]
                },
                "JOINTS_MAP": {
                    "value": "['RA1', 'RA2', 'RA3', 'RA4', 'RA5', 'RA6', 'G', 'H', 'I', 'J', 'K', 'L']",
                    "comment": [
                        "Joint mappings from axis 1 to axis N."
                    ]
                },
                "CUSTOM_SETUP_COMAU": {
                    "value": "False",
                    "comment": [
                        "Sample special TCP setup with a custom Comau robot arm."
                    ]
                }
            }
        },
        "Siemens-Sinumerik-Inch": {
            "N": "Siemens Sinumerik Inch",
            "F": "Siemens_Sinumerik_Inch.py",
            "B": "Siemens",
            "EXT": ".mpf",
            "SC": [
                "Siemens SINUMERIK"
            ],
            "D": [
                "The Siemens Sinumerik Inch post processor produces .mpf files that are compatible with Siemens Sinumerik programming language."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "mpf",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "MM_2_UNITS": {
                    "value": 0.03937007874015748,
                    "comment": [
                        "Use Inch units.",
                        "Units (1 to use MM).",
                        "MM_2_UNITS = 1.0 \u2010 Use mm."
                    ]
                },
                "M_WAIT_DI": {
                    "value": "M66",
                    "comment": [
                        "Provide the M code to wait for a digital input."
                    ]
                },
                "M_SET_DO_HIGH": {
                    "value": "M62",
                    "comment": [
                        "Provide the M code to set a digital output HIGH (1 or True)."
                    ]
                },
                "M_SET_DO_LOW": {
                    "value": "M63",
                    "comment": [
                        "Provide the M code to set a digital output LOW (0 or False)."
                    ]
                },
                "JOINTS_MAP": {
                    "value": "['RA1', 'RA2', 'RA3', 'RA4', 'RA5', 'RA6', 'G', 'H', 'I', 'J', 'K', 'L']",
                    "comment": [
                        "Joint mappings from axis 1 to axis N."
                    ]
                },
                "CUSTOM_SETUP_COMAU": {
                    "value": "False",
                    "comment": [
                        "Sample special TCP setup with a custom Comau robot arm."
                    ]
                }
            }
        },
        "Staubli-Adept-Vplus": {
            "N": "Staubli Adept Vplus",
            "F": "Staubli_Adept_Vplus.py",
            "B": "Staubli",
            "EXT": ".vb1",
            "SC": [
                "Adept V+"
            ],
            "D": [
                "The Staubli Adept Vplus post processor produces .vb1 files for for Staubli controllers using the Adept V+ language."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "vb1",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "OMRON": {
                    "value": "False",
                    "comment": [
                        "Set this to true to support OMRON Adept V+ specific instructions."
                    ]
                }
            }
        },
        "Staubli-S6": {
            "N": "Staubli S6",
            "F": "Staubli_S6.py",
            "B": "Staubli",
            "EXT": ".pjx",
            "SC": [
                "Staubli S6",
                "Staubli CS7"
            ],
            "D": [
                "The Staubli VAL3 simplified post processor produces .pjx, .pgx and .dtx files compatible with Staubli VAL3 controllers.",
                "This post processor is specific to the VAL3 S6 version."
            ],
            "VARS": {
                "TOOL_CURRENT": {
                    "value": "tProg",
                    "comment": [
                        "Tool variable name."
                    ]
                },
                "REF_CURRENT": {
                    "value": "world",
                    "comment": [
                        "Frame variable name."
                    ]
                },
                "SPEED_CURRENT": {
                    "value": "mNomSpeed",
                    "comment": [
                        "Speed variable name."
                    ]
                },
                "DEFAULT_SPEED": {
                    "value": 150,
                    "comment": [
                        "Default speed."
                    ]
                },
                "DEFAULT_SMOOTH": {
                    "value": 0.1,
                    "comment": [
                        "Default rounding value."
                    ]
                },
                "ALIAS": {
                    "value": "",
                    "comment": [
                        "PJX program aliases section content."
                    ]
                },
                "ALIAS_MAIN": {
                    "value": "",
                    "comment": [
                        "Main PJX program aliases section content."
                    ]
                }
            }
        },
        "Staubli-VAL3": {
            "N": "Staubli VAL3",
            "F": "Staubli_VAL3.py",
            "B": "Staubli",
            "EXT": ".pjx",
            "SC": [
                "Staubli CS7",
                "Staubli CS8C",
                "Staubli CS8M",
                "Staubli CS9"
            ],
            "D": [
                "The Staubli VAL3 post processor produces .pjx, .pgx and .dtx files compatible with Staubli VAL3 controllers."
            ],
            "VARS": {
                "IO_BOARD_NAME": {
                    "value": "BasicIO-1",
                    "comment": [
                        "Set the IO board name as required by the dio data type. For official Staubli boards it should be BasicIO-1 or BasicIO-2."
                    ]
                },
                "PROG_MOVE_COUNT_MAX": {
                    "value": 2000,
                    "comment": [
                        "Set the maximum number of lines per program."
                    ]
                },
                "TOOL_IO_LINK": {
                    "value": "ValveIO/valve1",
                    "comment": [
                        "Set the Tool IO Link."
                    ]
                },
                "USE_POINT_NAMES": {
                    "value": "False",
                    "comment": [
                        "Use named targets instead of coordinates. Make sure to select Export Target Names in Tools-Options-Program."
                    ]
                },
                "USE_WAITENDMOVE": {
                    "value": "False",
                    "comment": [
                        "Add wait end move command before triggering program calls or digital outputs."
                    ]
                }
            }
        },
        "Staubli-VAL3-Machining": {
            "N": "Staubli VAL3 Machining",
            "F": "Staubli_VAL3_Machining.py",
            "B": "Staubli",
            "EXT": ".pjx",
            "SC": [
                "Staubli CS7",
                "Staubli CS8C",
                "Staubli CS8M",
                "Staubli CS9"
            ],
            "D": [
                "The Staubli VAL3 Machining post processor produces .pjx, .pgx and .dtx files compatible with Staubli VAL3 controllers."
            ]
        },
        "Staubli-VAL3-simplified": {
            "N": "Staubli VAL3 simplified",
            "F": "Staubli_VAL3_simplified.py",
            "B": "Staubli",
            "EXT": ".pjx",
            "SC": [
                "Staubli CS7",
                "Staubli CS8C",
                "Staubli CS8M",
                "Staubli CS9"
            ],
            "D": [
                "The Staubli VAL3 simplified post processor produces .pjx, .pgx and .dtx files compatible with Staubli VAL3 controllers."
            ]
        },
        "Staubli-VAL3-XMOVE": {
            "N": "Staubli VAL3 XMOVE",
            "F": "Staubli_VAL3_XMOVE.py",
            "B": "Staubli",
            "EXT": ".pjx",
            "SC": [
                "Staubli CS7",
                "Staubli CS8C",
                "Staubli CS8M",
                "Staubli CS9s"
            ],
            "D": [
                "The Staubli VAL3 XMOVE post processor produces .pjx, .pgx and .dtx files compatible with Staubli VAL3 controllers.",
                "This post processor adds support for external axes."
            ],
            "VARS": {
                "FR_EXTERNAL_POSE": {
                    "value": "Pose(678.000, 0.000, 0.000,  0.000, 0.000, 0.000)",
                    "comment": [
                        "Important: Enter the location of the external axis."
                    ]
                }
            }
        },
        "Techman": {
            "N": "Techman",
            "F": "Techman.py",
            "B": "Techman Robot",
            "SC": [],
            "D": [
                "The Techman post processor generates TMflow (.flow) code compatible with Techman Robot (TM) robotic controllers."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000.",
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "SHOW_PROGRAM_ZIP": {
                    "value": "True",
                    "comment": [
                        "Show zip file on program generation."
                    ]
                },
                "SHOW_PROGRAM_TXT": {
                    "value": "True",
                    "comment": [
                        "Show text file on program generation."
                    ]
                },
                "SKIP_COMMENTS": {
                    "value": "False",
                    "comment": [
                        "Set to True to skip comments."
                    ]
                },
                "INCLUDE_SUBPROGS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the same program."
                    ]
                },
                "USE_ROBOT_BASE": {
                    "value": "False",
                    "comment": [
                        "Use the robot base or a reference frame."
                    ]
                },
                "USE_TARGET_OFFSETS": {
                    "value": "False",
                    "comment": [
                        "Use targets as offsets."
                    ]
                },
                "VERTICAL_INS": {
                    "value": 8,
                    "comment": [
                        "Number of instructions to stack vertically before creating a new column."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 1000,
                    "comment": [
                        "Set the maximum speed in DEG/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 1200,
                    "comment": [
                        "Set the maximum speed in MM/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "OBJECT_PAYLOAD": {
                    "value": 2,
                    "comment": [
                        "Set default payload for the robot movements."
                    ]
                },
                "ROUNDING_MM": {
                    "value": 1,
                    "comment": [
                        "Set default rounding (radius in mm), set to -1 for accurate movements (point to point)."
                    ]
                },
                "SET_PASSWORD": {
                    "value": "robodk1234",
                    "comment": [
                        "Set the default password (5 chars minimum).",
                        "Warning: if set to None, the password will match the program name (filled with numbers to reach a minimum of 8 characters).",
                        "Warning: if the password is changed, TMFlow may not accept it and ask for a new password."
                    ]
                },
                "ASK_PASSWORD": {
                    "value": "False",
                    "comment": [
                        "Set to true to ask the user for a password."
                    ]
                },
                "ZIP_TYPE": {
                    "value": 1,
                    "comment": [
                        "Set to 0 to not save a ZIP file.",
                        "Set to 1 to save a zip file using TMExportZip.",
                        "Set to 2 to save a zip file without using TMExportZip.",
                        "ZIP_TYPE = 0."
                    ]
                },
                "PSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Point Speed Percentage (PSPercentage)."
                    ]
                },
                "PSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Point Speed Time To Top Speed (PSTTTS)."
                    ]
                },
                "COMPUTE_JOINT_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute joint acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "PSTTTSOF": {
                    "value": "ON",
                    "comment": [
                        "Enable Point Speed Time To Top Speed (PSTTTSOF)."
                    ]
                },
                "LINE_ABS": {
                    "value": "ON",
                    "comment": [
                        "Set default LineABS."
                    ]
                },
                "LSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Linear Speed Percentage (LSPercentage)."
                    ]
                },
                "LSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default Linear Speed A Velocity (LSAVelocity)."
                    ]
                },
                "LSTTTS": {
                    "value": 300,
                    "comment": [
                        "Set default Linear Speed Time To Top Speed (LSTTTS)."
                    ]
                },
                "REMOTE_TCP_SPEED": {
                    "value": "False",
                    "comment": [
                        "Set to True to adjust speeds for a remote TCP setup."
                    ]
                },
                "COMPUTE_LINEAR_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute linear acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "USE_RADIUS_BLENDING": {
                    "value": "False",
                    "comment": [
                        "Set default blending mode for linear and circular movement (False = Pourcentage True = Radius)."
                    ]
                },
                "INIT_MESSAGE": {
                    "value": "",
                    "comment": [
                        "Flag to include all init messages in one Display Node."
                    ]
                }
            },
            "EXT": ".flow"
        },
        "Techman-FerRobotics": {
            "N": "Techman FerRobotics",
            "F": "Techman_FerRobotics.py",
            "B": "Techman Robot",
            "SC": [],
            "D": [
                "The Techman FerRobotics post processor generates TMFlow (.flow) code compatible with Techman Robot (TM) robotic controllers.",
                "This post processor adds support for TM robots equipped with FerRobotics tools."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000.",
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "SHOW_PROGRAM_ZIP": {
                    "value": "True",
                    "comment": [
                        "Show zip file on program generation."
                    ]
                },
                "SHOW_PROGRAM_TXT": {
                    "value": "True",
                    "comment": [
                        "Show text file on program generation."
                    ]
                },
                "SKIP_COMMENTS": {
                    "value": "False",
                    "comment": [
                        "Set to True to skip comments."
                    ]
                },
                "INCLUDE_SUBPROGS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the same program."
                    ]
                },
                "USE_ROBOT_BASE": {
                    "value": "False",
                    "comment": [
                        "Use the robot base or a reference frame."
                    ]
                },
                "USE_TARGET_OFFSETS": {
                    "value": "False",
                    "comment": [
                        "Use targets as offsets."
                    ]
                },
                "VERTICAL_INS": {
                    "value": 8,
                    "comment": [
                        "Number of instructions to stack vertically before creating a new column."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 185,
                    "comment": [
                        "Set the maximum speed in DEG/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 1200,
                    "comment": [
                        "Set the maximum speed in MM/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "PSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Point Speed Percentage (PSPercentage)."
                    ]
                },
                "PSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Point Speed Time To Top Speed (PSTTTS)."
                    ]
                },
                "COMPUTE_JOINT_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute joint acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "PSTTTSOF": {
                    "value": "ON",
                    "comment": [
                        "Enable Point Speed Time To Top Speed (PSTTTSOF)."
                    ]
                },
                "LINE_ABS": {
                    "value": "ON",
                    "comment": [
                        "Set default LineABS."
                    ]
                },
                "LSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Linear Speed Percentage (LSPercentage)."
                    ]
                },
                "LSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default Linear Speed A Velocity (LSAVelocity)."
                    ]
                },
                "LSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Linear Speed Time To Top Speed (LSTTTS)."
                    ]
                },
                "COMPUTE_LINEAR_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute linear acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "ROUNDING_MM": {
                    "value": 1,
                    "comment": [
                        "Set default rounding (radius in mm), set to -1 for accurate movements (point to point)."
                    ]
                },
                "USE_RADIUS_BLENDING": {
                    "value": "False",
                    "comment": [
                        "Set default blending mode for linear and circular movement (False = Pourcentage True = Radius)."
                    ]
                },
                "INIT_MESSAGE": {
                    "value": "",
                    "comment": [
                        "Flag to includ all init messages in one Display Node."
                    ]
                },
                "SET_PASSWORD": {
                    "value": "robodk1234",
                    "comment": [
                        "Set the default password (5 chars minimum).",
                        "Warning: if set to None, the password will match the program name (filled with numbers to reach a minimum of 8 characters).",
                        "Warning: if the password is changed, TMFlow may not accept it and ask for a new password."
                    ]
                },
                "ASK_PASSWORD": {
                    "value": "False",
                    "comment": [
                        "Set to true to ask the user for a password."
                    ]
                },
                "ZIP_TYPE": {
                    "value": 1,
                    "comment": [
                        "Set to 0 to not save a ZIP file.",
                        "Set to 1 to save a zip file using TMExportZip.",
                        "Set to 2 to save a zip file without using TMExportZip.",
                        "ZIP_TYPE = 0."
                    ]
                },
                "IP_FER_Robotics": {
                    "value": "",
                    "comment": [
                        "FER Robotics IP Address (need to be made user accessible later)."
                    ]
                },
                "PATH_TMExportZip": {
                    "value": "os.path.realpath(os.path.join(os.path.dirname(os.path.realpath(__file__)), \"../Other/TMExportZip/TMExportZip.exe\"))",
                    "comment": [
                        "Path to TMExportZip to automatically ZIP files (needed if ZIP_Type = 1)."
                    ]
                }
            },
            "EXT": ".flow"
        },
        "Techman-PathNode": {
            "N": "Techman PathNode",
            "F": "Techman_PathNode.py",
            "B": "Techman Robot",
            "SC": [],
            "D": [
                "The Techman PathNode post processor generates TMFlow (.flow) code compatible with Techman Robot (TM) robotic controllers.",
                "This post processor adds support for path nodes."
            ],
            "VARS": {
                "SHOW_PROGRAM_ZIP": {
                    "value": "True",
                    "comment": [
                        "Show zip file on program generation."
                    ]
                },
                "SHOW_PROGRAM_TXT": {
                    "value": "True",
                    "comment": [
                        "Show text file on program generation."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000.",
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "SKIP_COMMENTS": {
                    "value": "False",
                    "comment": [
                        "Set to True to skip comments."
                    ]
                },
                "INCLUDE_SUBPROGS": {
                    "value": "True",
                    "comment": [
                        "Include subprograms in the same program."
                    ]
                },
                "USE_ROBOT_BASE": {
                    "value": "False",
                    "comment": [
                        "Use the robot base or a reference frame."
                    ]
                },
                "USE_TARGET_OFFSETS": {
                    "value": "False",
                    "comment": [
                        "Use targets as offsets."
                    ]
                },
                "VERTICAL_INS": {
                    "value": 8,
                    "comment": [
                        "Number of instructions to stack vertically before creating a new column."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 185,
                    "comment": [
                        "Set the maximum speed in DEG/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 1200,
                    "comment": [
                        "Set the maximum speed in MM/s (percentage speed will be calculated accordingly)."
                    ]
                },
                "LINE_ABS": {
                    "value": "ON",
                    "comment": [
                        "Set default LineABS."
                    ]
                },
                "LSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default Linear Speed A Velocity (LSAVelocity)."
                    ]
                },
                "LSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default Linear Speed Time To Top Speed (LSTTTS)."
                    ]
                },
                "COMPUTE_LINEAR_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute linear acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "PLSAVELOCITY": {
                    "value": 250,
                    "comment": [
                        "Set default PLinear Speed A Velocity (PLSAVelocity)."
                    ]
                },
                "PLSTTTS": {
                    "value": 150,
                    "comment": [
                        "Set default PLinear Speed Time To Top Speed (PLSTTTS)."
                    ]
                },
                "LSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Linear Speed Percentage (LSPercentage)."
                    ]
                },
                "PSTTTSOF": {
                    "value": "ON",
                    "comment": [
                        "Enable Point Speed Time To Top Speed (PSTTTSOF)."
                    ]
                },
                "PSTTTS": {
                    "value": 250,
                    "comment": [
                        "Set default Point Speed Time To Top Speed (PSTTTS)."
                    ]
                },
                "PSPERCENTAGE": {
                    "value": 100,
                    "comment": [
                        "Set default Point Speed Percentage (PSPercentage)."
                    ]
                },
                "COMPUTE_JOINT_ACCEL": {
                    "value": "",
                    "comment": [
                        "Flag compute joint acceleration (this would not be requiered if RDK would generate speed before acceleration)."
                    ]
                },
                "ROB_CONFIG": {
                    "value": "0,2,4",
                    "comment": [
                        "Set default robot configuration (Config)."
                    ]
                },
                "ROUNDING_MM": {
                    "value": 1,
                    "comment": [
                        "Set default rounding (radius in mm), set to -1 for accurate movements (point to point)."
                    ]
                },
                "USE_RADIUS_BLENDING": {
                    "value": "False",
                    "comment": [
                        "Set default blending mode for linear and circular movement (False = Pourcentage True = Radius)."
                    ]
                },
                "USE_PATH_NODE": {
                    "value": "False",
                    "comment": [
                        "Set generated program as a .path file."
                    ]
                },
                "PATH_NODE_NAME": {
                    "value": "RoboDKPath",
                    "comment": [
                        "Set the name of the default .path file."
                    ]
                },
                "USE_PATH_PLINE": {
                    "value": "True",
                    "comment": [
                        "Set .path node motion type to PLine (recommanded state: True)."
                    ]
                },
                "SET_PASSWORD": {
                    "value": "robodk1234",
                    "comment": [
                        "Set the default password (5 chars minimum).",
                        "Warning: if set to None, the password will match the program name (filled with numbers to reach a minimum of 8 characters).",
                        "Warning: if the password is changed, TMFlow may not accept it and ask for a new password."
                    ]
                },
                "ASK_PASSWORD": {
                    "value": "False",
                    "comment": [
                        "Set to true to ask the user for a password."
                    ]
                },
                "TOOL_MASS": {
                    "value": "0",
                    "comment": [
                        "Tool data."
                    ]
                },
                "ZIP_TYPE": {
                    "value": 1,
                    "comment": [
                        "Set to 0 to not save a ZIP file.",
                        "Set to 1 to save a zip file using TMExportZip.",
                        "Set to 2 to save a zip file without using TMExportZip.",
                        "ZIP_TYPE = 0."
                    ]
                }
            },
            "EXT": ".flow"
        },
        "Techman-Remote": {
            "N": "Techman Remote",
            "F": "Techman_Remote.py",
            "B": "Techman Robot",
            "EXT": ".script",
            "SC": [],
            "D": [
                "The Techman Remote post processor generates a Python script compatible with Techman Robot (TM) robotic controllers."
            ],
            "VARS": {
                "ROBOT_IP": {
                    "value": "192.168.1.100",
                    "comment": [
                        "Robot IP (should be provided by RoboDK when the program is generated)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "250    # Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "SPEED_MMS": {
                    "value": 50,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_PERCENT": {
                    "value": 10,
                    "comment": [
                        "Default speed for joint moves in percentage."
                    ]
                },
                "SPEED_DEGS": {
                    "value": 30,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "ACCEL_MMSS": {
                    "value": 100,
                    "comment": [
                        "Default acceleration for lineaer moves in mm/ss."
                    ]
                },
                "ACCEL_DEGSS": {
                    "value": 200,
                    "comment": [
                        "Default acceleration for joint moves in deg/ss."
                    ]
                },
                "ROUNDING": {
                    "value": 1,
                    "comment": [
                        "Default blend radius as a percentage."
                    ]
                },
                "USE_MOVEP": {
                    "value": "False",
                    "comment": []
                },
                "TAB_CHAR": {
                    "value": "",
                    "comment": []
                }
            }
        },
        "Techman-TMscript": {
            "N": "Techman TMscript",
            "F": "Techman_TMscript.py",
            "B": "Techman Robot",
            "EXT": ".scpt",
            "SC": [],
            "D": [
                "The Techman TMscript post processor generates TMscript (.scpt) code compatible with Techman Robot (TM) robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "scpt",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "DEFAULT_LINEAR_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "DEFAULT_LINEAR_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "DEFAULT_JOINT_SPEED": {
                    "value": 100.0,
                    "comment": [
                        "Default speed for joint moves in %."
                    ]
                },
                "DEFAULT_JOINT_ACCEL": {
                    "value": 100.0,
                    "comment": [
                        "Default acceleration for joint moves in %."
                    ]
                },
                "DEFAULT_BLENDING": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius (corners smoothing) in %."
                    ]
                },
                "ADD_FRAME_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK frame name as a comment in the output program."
                    ]
                },
                "ADD_TOOL_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK tool name as a comment in the output program."
                    ]
                },
                "ADD_TARGET_NAME": {
                    "value": "False",
                    "comment": [
                        "Add the RoboDK target name as a comment in the output program."
                    ]
                }
            }
        },
        "Toshiba": {
            "N": "Toshiba",
            "F": "Toshiba.py",
            "B": "Toshiba",
            "EXT": ".txt",
            "SC": [],
            "D": [
                "The Toshiba post processor outputs .txt files for Toshiba robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Turin": {
            "N": "Turin",
            "F": "Turin.py",
            "B": "Turin",
            "EXT": ".txt",
            "SC": [],
            "D": [
                "The Turin post processor outputs .txt files for Turin robot controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "txt",
                    "comment": [
                        "Set the output program extension (for multiple files, handle separately)."
                    ]
                },
                "SPEED_MMS": {
                    "value": 250,
                    "comment": [
                        "Default speed for linear moves in mm/s."
                    ]
                },
                "MAX_SPEED_MMS": {
                    "value": 5000,
                    "comment": [
                        "Maximum speed for linear moves in mm/s (to convert in %)."
                    ]
                },
                "SPEED_DEGS": {
                    "value": 500,
                    "comment": [
                        "Default speed for joint moves in deg/s."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 5000,
                    "comment": [
                        "Maximum speed for joint moves in deg/s (to convert in %)."
                    ]
                },
                "ACCEL_MMSS": {
                    "value": 1500,
                    "comment": [
                        "Default acceleration for linear moves in mm/s^2."
                    ]
                },
                "MAX_ACCEL_MMSS": {
                    "value": 5000,
                    "comment": [
                        "Maximum acceleration for linear moves in mm/s^2 (to convert in %)."
                    ]
                },
                "ACCEL_DEGSS": {
                    "value": 200,
                    "comment": [
                        "Default acceleration for joint moves in deg/s^2."
                    ]
                },
                "MAX_ACCEL_DEGSS": {
                    "value": 2000,
                    "comment": [
                        "Maximum acceleration for joint moves in deg/s^2 (to convert in %)."
                    ]
                },
                "BLEND_RADIUS_MM": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius in millimeters."
                    ]
                },
                "MAX_BLEND_RADIUS_MM": {
                    "value": 100,
                    "comment": [
                        "Maximum blend radius in millimeters (to convert to %)."
                    ]
                }
            }
        },
        "uArm": {
            "N": "uArm",
            "F": "uArm.py",
            "B": "uFactory",
            "EXT": ".cnc",
            "SC": [
                "uFactory uArm"
            ],
            "D": [
                "The uArm post processor outputs .cnc code for uFactory uArm robotic systems."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "cnc",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        },
        "Universal-Robots": {
            "N": "Universal Robots",
            "F": "Universal_Robots.py",
            "B": "Universal Robots",
            "EXT": ".script",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers."
            ],
            "VARS": {
                "INCLUDE_HEADER": {
                    "value": "True",
                    "comment": [
                        "Include custom header to program."
                    ]
                },
                "USE_MOVEP": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MoveP, set to False to use MoveL."
                    ]
                },
                "USE_RELATIVE_TARGETS": {
                    "value": "True",
                    "comment": [
                        "Set to True to use the reference frame as a pose and pose_trans to pre-multiply all targets.",
                        "Set to False to output all targets with respect to the robot base."
                    ]
                },
                "UPLOAD_SFTP": {
                    "value": "False",
                    "comment": [
                        "If True, it will attempt to upload using SFTP. It requires PYSFTP (pip install pysftp. Important: It requires Visual Studio Community C++ 10.0)."
                    ]
                },
                "BLENDING_CHECK": {
                    "value": "",
                    "comment": [
                        "Set True to automatically filter blending (CB3 or prior), set to False to leave it up to the controller to adjust the blending as needed.",
                        "Leave this to default (None) to automatically detect the appropriate action."
                    ]
                },
                "MOVE_ACCURATE_CALLS": {
                    "value": "True",
                    "comment": [
                        "Force accurate move before we trigger program calls, speed changes or changing digital outputs."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000 \u2010 Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MAX_SPEED_MS": {
                    "value": 3.0,
                    "comment": [
                        "Maximum speeds and accelerations allowed by the controller (otherwise it throws a speed error)."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 180,
                    "comment": []
                },
                "MAX_ACCEL_MSS": {
                    "value": 15.0,
                    "comment": []
                },
                "MAX_ACCEL_DEGSS": {
                    "value": 2291.8,
                    "comment": []
                },
                "USE_MOTION_PLUS": {
                    "value": "True",
                    "comment": [
                        "Set to True to use Universal Robots MotionPlus (external axes)."
                    ]
                },
                "AXIS_COMMAND_INDIVIDUALLY": {
                    "value": "False",
                    "comment": [
                        "Set to True to command either the robot or the axis individually when the other is not moving."
                    ]
                },
                "AXIS_GROUP_ADD": {
                    "value": "True",
                    "comment": [
                        "MotionPlus: Set to false to skip axis group definition (axis_group_add, axis_group_add_axis)."
                    ]
                },
                "AXIS_GROUP_NAME": {
                    "value": "rail",
                    "comment": [
                        "MotionPlus: Group name (axis_group_add)."
                    ]
                },
                "AXIS_GROUP_POSE": {
                    "value": "Pose(0.000, 0.000, 0.000,  -0.000, 0.000, 90.000)",
                    "comment": [
                        "MotionPlus: Pose of the axis group\u2019s base, in the \"world\" coordinate frame (axis_group_add).",
                        "Specify a pose or a variable name."
                    ]
                },
                "AXIS_NAME": {
                    "value": "axis1",
                    "comment": [
                        "MotionPlus: Axis name (axis_group_add_axis)."
                    ]
                },
                "AXIS_POSE": {
                    "value": "CAL_AX_LINEAR",
                    "comment": [
                        "MotionPlus: Axis pose, in the parent coordinate frame, this axis will be placed and attached to (axis_group_add_axis).",
                        "Specify a pose or a variable name.",
                        "AXIS_GROUP_AXIS_POSE = robomath.UR_2_Pose([0,0,0,0,0,0])."
                    ]
                },
                "AXIS_VELOCITY_LIMIT": {
                    "value": 0.5,
                    "comment": [
                        "MotionPlus: Maximum axis velocity in rad/s (rotary) or m/s (linear)."
                    ]
                },
                "AXIS_ACCELERATION_LIMIT": {
                    "value": 1.0,
                    "comment": [
                        "MotionPlus: Maximum axis acceleration in rad/s^2 (rotary) or m/s^2 (linear)."
                    ]
                },
                "AXIS_RANGE_LIMIT_MIN": {
                    "value": 0.0,
                    "comment": [
                        "MotionPlus: Lower and upper limits of the axis position in rad (rotary) or m (linear)."
                    ]
                },
                "AXIS_RANGE_LIMIT_MAX": {
                    "value": 1.0,
                    "comment": []
                }
            }
        },
        "Universal-Robots-3D-Printing": {
            "N": "Universal Robots 3D Printing",
            "F": "Universal_Robots_3D_Printing.py",
            "B": "Universal Robots",
            "EXT": ".script",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots 3D Printing post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers.",
                "This post processor adds support for 3D printing."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 250,
                    "comment": [
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.3,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 3,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "USE_MOVEP": {
                    "value": "False",
                    "comment": []
                }
            }
        },
        "Universal-Robots-Conveyor": {
            "N": "Universal Robots Conveyor",
            "F": "Universal_Robots_Conveyor.py",
            "B": "Universal Robots",
            "EXT": ".script",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots Conveyor post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers.",
                "This post processor adds support for conveyor tracking."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 250,
                    "comment": [
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.3,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 3,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "USE_MOVEP": {
                    "value": "False",
                    "comment": []
                },
                "PULSES_X_MM": {
                    "value": 10,
                    "comment": [
                        "Ticks/pulses per millimeter."
                    ]
                }
            }
        },
        "Universal-Robots-FerRobotics": {
            "N": "Universal Robots FerRobotics",
            "F": "Universal_Robots_FerRobotics.py",
            "B": "Universal Robots",
            "EXT": ".script",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots FerRobotics post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers.",
                "This post processor adds support for Universal Robots equipped with FerRobotics OAK (Active Orbital Kit) tools."
            ],
            "VARS": {
                "USE_MOVEP": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MoveP, set to False to use MoveL."
                    ]
                },
                "USE_RELATIVE_TARGETS": {
                    "value": "False",
                    "comment": [
                        "Set to True to use the reference frame as a pose and pose_trans to premultiply all targets.",
                        "Set to False to output all targets with respect to the robot base."
                    ]
                },
                "UPLOAD_SFTP": {
                    "value": "False",
                    "comment": [
                        "If True, it will attempt to upload using SFTP. It requires PYSFTP (pip install pysftp. Important: It requires Visual Studio Community C++ 10.0)."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000 \u2010 Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MAX_SPEED_MS": {
                    "value": 3.0,
                    "comment": [
                        "Maximum speeds and accelerations allowed by the controller (otherwise it throws a speed error)."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 180,
                    "comment": []
                },
                "MAX_ACCEL_MSS": {
                    "value": 15.0,
                    "comment": []
                },
                "MAX_ACCEL_DEGSS": {
                    "value": 2291.8,
                    "comment": []
                }
            }
        },
        "Universal-Robots-MoveP": {
            "N": "Universal Robots MoveP",
            "F": "Universal_Robots_MoveP.py",
            "B": "Universal Robots",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots MoveP post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers.",
                "This post processor has MoveP enabled by default."
            ],
            "VARS": {
                "INCLUDE_HEADER": {
                    "value": "True",
                    "comment": [
                        "Include custom header to program."
                    ]
                },
                "USE_MOVEP": {
                    "value": "True",
                    "comment": [
                        "Set to True to use MoveP, set to False to use MoveL."
                    ]
                },
                "USE_RELATIVE_TARGETS": {
                    "value": "True",
                    "comment": [
                        "Set to True to use the reference frame as a pose and pose_trans to premultiply all targets.",
                        "Set to False to output all targets with respect to the robot base."
                    ]
                },
                "UPLOAD_SFTP": {
                    "value": "False",
                    "comment": [
                        "If True, it will attempt to upload using SFTP. It requires PYSFTP (pip install pysftp. Important: It requires Visual Studio Community C++ 10.0)."
                    ]
                },
                "BLENDING_CHECK": {
                    "value": "",
                    "comment": [
                        "Set True to automatically filter blending (CB3 or prior), set to False to leave it up to the controller to adjust the blending as needed.",
                        "Leave this to default (None) to automatically detect the appropriate action."
                    ]
                },
                "MOVE_ACCURATE_CALLS": {
                    "value": "True",
                    "comment": [
                        "Force accurate move before we trigger program calls, speed changes or changing digital outputs."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000 \u2010 Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MAX_SPEED_MS": {
                    "value": 3.0,
                    "comment": [
                        "Maximum speeds and accelerations allowed by the controller (otherwise it throws a speed error)."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 180,
                    "comment": []
                },
                "MAX_ACCEL_MSS": {
                    "value": 15.0,
                    "comment": []
                },
                "MAX_ACCEL_DEGSS": {
                    "value": 2291.8,
                    "comment": []
                },
                "USE_MOTION_PLUS": {
                    "value": "True",
                    "comment": [
                        "Set to True to use Universal Robots MotionPlus (external axes)."
                    ]
                },
                "AXIS_COMMAND_INDIVIDUALLY": {
                    "value": "False",
                    "comment": [
                        "Set to True to command either the robot or the axis individually when the other is not moving."
                    ]
                },
                "AXIS_GROUP_ADD": {
                    "value": "True",
                    "comment": [
                        "MotionPlus: Set to false to skip axis group definition (axis_group_add, axis_group_add_axis)."
                    ]
                },
                "AXIS_GROUP_NAME": {
                    "value": "rail",
                    "comment": [
                        "MotionPlus: Group name (axis_group_add)."
                    ]
                },
                "AXIS_GROUP_POSE": {
                    "value": "Pose(0.000, 0.000, 0.000,  -0.000, 0.000, 90.000)",
                    "comment": [
                        "MotionPlus: Pose of the axis group\u2019s base, in the \"world\" coordinate frame (axis_group_add).",
                        "Specify a pose or a variable name."
                    ]
                },
                "AXIS_NAME": {
                    "value": "axis1",
                    "comment": [
                        "MotionPlus: Axis name (axis_group_add_axis)."
                    ]
                },
                "AXIS_POSE": {
                    "value": "CAL_AX_LINEAR",
                    "comment": [
                        "MotionPlus: Axis pose, in the parent coordinate frame, this axis will be placed and attached to (axis_group_add_axis).",
                        "Specify a pose or a variable name.",
                        "AXIS_GROUP_AXIS_POSE = robomath.UR_2_Pose([0,0,0,0,0,0])."
                    ]
                },
                "AXIS_VELOCITY_LIMIT": {
                    "value": 0.5,
                    "comment": [
                        "MotionPlus: Maximum axis velocity in rad/s (rotary) or m/s (linear)."
                    ]
                },
                "AXIS_ACCELERATION_LIMIT": {
                    "value": 1.0,
                    "comment": [
                        "MotionPlus: Maximum axis acceleration in rad/s^2 (rotary) or m/s^2 (linear)."
                    ]
                },
                "AXIS_RANGE_LIMIT_MIN": {
                    "value": 0.0,
                    "comment": [
                        "MotionPlus: Lower and upper limits of the axis position in rad (rotary) or m (linear)."
                    ]
                },
                "AXIS_RANGE_LIMIT_MAX": {
                    "value": 1.0,
                    "comment": []
                }
            },
            "EXT": ".script"
        },
        "Universal-Robots-RobotiQ": {
            "N": "Universal Robots RobotiQ",
            "F": "Universal_Robots_RobotiQ.py",
            "B": "Universal Robots",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots RobotiQ post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers.",
                "This post processor adds support for Universal Robots equipped with RobotiQ grippers."
            ],
            "VARS": {
                "INCLUDE_HEADER": {
                    "value": "True",
                    "comment": [
                        "Include custom header to program."
                    ]
                },
                "USE_MOVEP": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MoveP, set to False to use MoveL."
                    ]
                },
                "USE_RELATIVE_TARGETS": {
                    "value": "True",
                    "comment": [
                        "Set to True to use the reference frame as a pose and pose_trans to premultiply all targets.",
                        "Set to False to output all targets with respect to the robot base."
                    ]
                },
                "UPLOAD_SFTP": {
                    "value": "False",
                    "comment": [
                        "If True, it will attempt to upload using SFTP. It requires PYSFTP (pip install pysftp. Important: It requires Visual Studio Community C++ 10.0)."
                    ]
                },
                "BLENDING_CHECK": {
                    "value": "",
                    "comment": [
                        "Set True to automatically filter blending (CB3 or prior), set to False to leave it up to the controller to adjust the blending as needed.",
                        "Leave this to default (None) to automatically detect the appropriate action."
                    ]
                },
                "MOVE_ACCURATE_CALLS": {
                    "value": "True",
                    "comment": [
                        "Force accurate move before we trigger program calls, speed changes or changing digital outputs."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000 \u2010 Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MAX_SPEED_MS": {
                    "value": 3.0,
                    "comment": [
                        "Maximum speeds and accelerations allowed by the controller (otherwise it throws a speed error)."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 180,
                    "comment": []
                },
                "MAX_ACCEL_MSS": {
                    "value": 15.0,
                    "comment": []
                },
                "MAX_ACCEL_DEGSS": {
                    "value": 2291.8,
                    "comment": []
                },
                "USE_MOTION_PLUS": {
                    "value": "True",
                    "comment": [
                        "Set to True to use Universal Robots MotionPlus (external axes)."
                    ]
                },
                "AXIS_COMMAND_INDIVIDUALLY": {
                    "value": "False",
                    "comment": [
                        "Set to True to command either the robot or the axis individually when the other is not moving."
                    ]
                },
                "AXIS_GROUP_ADD": {
                    "value": "True",
                    "comment": [
                        "MotionPlus: Set to false to skip axis group definition (axis_group_add, axis_group_add_axis)."
                    ]
                },
                "AXIS_GROUP_NAME": {
                    "value": "rail",
                    "comment": [
                        "MotionPlus: Group name (axis_group_add)."
                    ]
                },
                "AXIS_GROUP_POSE": {
                    "value": "Pose(0.000, 0.000, 0.000,  -0.000, 0.000, 90.000)",
                    "comment": [
                        "MotionPlus: Pose of the axis group\u2019s base, in the \"world\" coordinate frame (axis_group_add).",
                        "Specify a pose or a variable name."
                    ]
                },
                "AXIS_NAME": {
                    "value": "axis1",
                    "comment": [
                        "MotionPlus: Axis name (axis_group_add_axis)."
                    ]
                },
                "AXIS_POSE": {
                    "value": "CAL_AX_LINEAR",
                    "comment": [
                        "MotionPlus: Axis pose, in the parent coordinate frame, this axis will be placed and attached to (axis_group_add_axis).",
                        "Specify a pose or a variable name.",
                        "AXIS_GROUP_AXIS_POSE = robomath.UR_2_Pose([0,0,0,0,0,0])."
                    ]
                },
                "AXIS_VELOCITY_LIMIT": {
                    "value": 0.5,
                    "comment": [
                        "MotionPlus: Maximum axis velocity in rad/s (rotary) or m/s (linear)."
                    ]
                },
                "AXIS_ACCELERATION_LIMIT": {
                    "value": 1.0,
                    "comment": [
                        "MotionPlus: Maximum axis acceleration in rad/s^2 (rotary) or m/s^2 (linear)."
                    ]
                },
                "AXIS_RANGE_LIMIT_MIN": {
                    "value": 0.0,
                    "comment": [
                        "MotionPlus: Lower and upper limits of the axis position in rad (rotary) or m (linear)."
                    ]
                },
                "AXIS_RANGE_LIMIT_MAX": {
                    "value": 1.0,
                    "comment": []
                }
            },
            "EXT": ".script"
        },
        "Universal-Robots-Sync": {
            "N": "Universal Robots Sync",
            "F": "Universal_Robots_Sync.py",
            "B": "Universal Robots",
            "EXT": ".script",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots Sync post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers.",
                "This post processor adds support for robot synchronization."
            ],
            "VARS": {
                "MAX_LINES_X_PROG": {
                    "value": 1000,
                    "comment": [
                        "Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "PROG_EXT": {
                    "value": "script",
                    "comment": [
                        "Set the program extension."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.3,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 3,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.001,
                    "comment": [
                        "Default blend radius in meters (corners smoothing)."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "USE_MOVEP": {
                    "value": "False",
                    "comment": []
                }
            }
        },
        "Universal-Robots-URP": {
            "N": "Universal Robots URP",
            "F": "Universal_Robots_URP.py",
            "B": "Universal Robots",
            "EXT": ".script",
            "SC": [
                "Universal Robots UR",
                "Universal Robots URe"
            ],
            "D": [
                "The Universal Robots URP post processor produces PolyScope (.script) and URP (.urp) files for Universal Robots controllers.",
                "This post processor adds support for URP move commands."
            ],
            "VARS": {
                "USE_MOVEP": {
                    "value": "False",
                    "comment": [
                        "Set to True to use MoveP, set to False to use MoveL."
                    ]
                },
                "UPLOAD_SFTP": {
                    "value": "False",
                    "comment": [
                        "If True, it will attempt to upload using SFTP. It requires PYSFTP (pip install pysftp. Important: It requires Visual Studio Community C++ 10.0)."
                    ]
                },
                "SPEED_MS": {
                    "value": 0.25,
                    "comment": [
                        "Default speed for linear moves in m/s."
                    ]
                },
                "SPEED_RADS": {
                    "value": 0.75,
                    "comment": [
                        "Default speed for joint moves in rad/s."
                    ]
                },
                "ACCEL_MSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for lineaer moves in m/ss."
                    ]
                },
                "ACCEL_RADSS": {
                    "value": 1.2,
                    "comment": [
                        "Default acceleration for joint moves in rad/ss."
                    ]
                },
                "BLEND_RADIUS_M": {
                    "value": 0.0,
                    "comment": [
                        "Default blend radius in meters (corners smoothing).",
                        "BLEND_RADIUS_M = 0.001."
                    ]
                },
                "MAX_LINES_X_PROG": {
                    "value": 1000000000.0,
                    "comment": [
                        "5000 \u2010 Maximum number of lines per program. If the number of lines is exceeded, the program will be executed step by step by RoboDK."
                    ]
                },
                "MOVEC_MIN_RADIUS": {
                    "value": 1,
                    "comment": [
                        "Minimum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MOVEC_MAX_RADIUS": {
                    "value": 10000,
                    "comment": [
                        "Maximum circle radius to output (in mm). It does not take into account the Blend radius."
                    ]
                },
                "MAX_SPEED_MS": {
                    "value": 3.0,
                    "comment": [
                        "Maximum speed allowed by the controller (otherwise it throws a speed error)# Maximum speeds and accelerations allowed by the controller (otherwise it throws a speed error)."
                    ]
                },
                "MAX_SPEED_DEGS": {
                    "value": 180,
                    "comment": []
                },
                "MAX_ACCEL_MSS": {
                    "value": 15.0,
                    "comment": []
                },
                "MAX_ACCEL_DEGSS": {
                    "value": 2291.8,
                    "comment": []
                },
                "SKIP_MOVEJ": {
                    "value": "False",
                    "comment": [
                        "Prevent generating script code for joint moves (may create problems related to configuration)."
                    ]
                },
                "PATH_SUBPROGS": {
                    "value": "/programs/",
                    "comment": [
                        "Use this path for real robot controllers.",
                        "Path to folder for subprograms: for real controllers this should be /programs/.",
                        "For URSim this should be an absolute path or a relative path as shown in the examples below."
                    ]
                }
            }
        },
        "Wlkata": {
            "N": "Wlkata",
            "F": "Wlkata.py",
            "B": "Wlkata",
            "EXT": ".py",
            "SC": [
                "WLKATA Mirobot"
            ],
            "D": [
                "The WLKATA post processor generates Python code designed for WLKATA Mirobot robotic arms."
            ],
            "VARS": {
                "POST_CODEGEN_MODE": {
                    "value": 1,
                    "comment": [
                        "Code generation mode.",
                        "1 = simulate.",
                        "2 = Online Programming (run on robot).",
                        "3 = Macro generation (RDK.AddProgram)."
                    ]
                },
                "MAIN_PROGRAM_NAME": {
                    "value": "",
                    "comment": [
                        "Name of the main function, obtained from first instance of ProgStart being called."
                    ]
                },
                "CURRENT_PROGRAM_NAME": {
                    "value": "robot",
                    "comment": [
                        "Name of the current program being written, only for AddProgram (mode 3).",
                        "Defaults to robot for api usage (mode 1 and 2)."
                    ]
                }
            }
        },
        "xArm": {
            "N": "xArm",
            "F": "xArm.py",
            "B": "uFactory",
            "EXT": ".py",
            "SC": [
                "uFactory xArm"
            ],
            "D": [
                "The xArm post processor outputs Python code for uFactory xArm robotic systems."
            ],
            "VARS": {
                "POST_CODEGEN_MODE": {
                    "value": 3,
                    "comment": [
                        "Code generation mode.",
                        "1 = simulate.",
                        "2 = Online Programming (run on robot).",
                        "3 = Macro generation (RDK.AddProgram)."
                    ]
                },
                "MAIN_PROGRAM_NAME": {
                    "value": "",
                    "comment": [
                        "Name of the main function, obtained from first instance of ProgStart being called."
                    ]
                }
            }
        },
        "Yamaha": {
            "N": "Yamaha",
            "F": "Yamaha.py",
            "B": "Yamaha",
            "EXT": ".prg",
            "SC": [],
            "D": [
                "The Yamaha post processor generates .prg files for Yamaha robotic controllers."
            ],
            "VARS": {
                "PROG_EXT": {
                    "value": "prg",
                    "comment": [
                        "Set the program extension."
                    ]
                }
            }
        }
    }
}